/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Smart Managed Care API
 * OpenAPI spec version: v0
 */
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult,
} from '@tanstack/react-query';
import { useMutation, useQuery, useSuspenseQuery } from '@tanstack/react-query';

import { request } from './axios';
export interface NotificationSelectionDto {
  deputyNotification: boolean;
  callcenterNotification: boolean;
  partnerNotification: boolean;
  hospitalNotification: boolean;
}

export type MobileAppointmentsSettingsDtoExternalBookingUrl = string | null;

export interface MobileAppointmentsSettingsDto {
  enabled: boolean;
  externalBookingUrl?: MobileAppointmentsSettingsDtoExternalBookingUrl;
}

export type MobileConversationsSettingsDtoEnabledTopicsItem =
  (typeof MobileConversationsSettingsDtoEnabledTopicsItem)[keyof typeof MobileConversationsSettingsDtoEnabledTopicsItem];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MobileConversationsSettingsDtoEnabledTopicsItem = {
  PRESCRIPTION: 'PRESCRIPTION',
  MEDICATION_ORDER: 'MEDICATION_ORDER',
  PHYSIO: 'PHYSIO',
  ACCIDENT_REPORT: 'ACCIDENT_REPORT',
  OTHER: 'OTHER',
} as const;

export interface MobileConversationsSettingsDto {
  email: string;
  enabledTopics: MobileConversationsSettingsDtoEnabledTopicsItem[];
  prescription: MobilePrescriptionConversationSettingsDto;
  other: MobileOtherConversationSettingsDto;
}

export interface MobileMedicationSettingsDto {
  showInactiveMedication: boolean;
}

export interface MobileObservationsSettingsDto {
  enabled: boolean;
  delayWorkingDays: number;
}

export type MobileOtherConversationSettingsDtoMedicalOptionType =
  (typeof MobileOtherConversationSettingsDtoMedicalOptionType)[keyof typeof MobileOtherConversationSettingsDtoMedicalOptionType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MobileOtherConversationSettingsDtoMedicalOptionType = {
  MESSAGE: 'MESSAGE',
  PHONE: 'PHONE',
} as const;

export type MobileOtherConversationSettingsDtoPhoneNumber = string | null;

export interface MobileOtherConversationSettingsDto {
  medicalOptionType: MobileOtherConversationSettingsDtoMedicalOptionType;
  phoneNumber?: MobileOtherConversationSettingsDtoPhoneNumber;
}

export type MobilePracticeSettingsDtoAddress = string | null;

export type MobilePracticeSettingsDtoOpeningHours = string | null;

export type MobilePracticeSettingsDtoPhoneOpeningHours = string | null;

export interface MobilePracticeSettingsDto {
  name: string;
  address?: MobilePracticeSettingsDtoAddress;
  openingHours?: MobilePracticeSettingsDtoOpeningHours;
  phoneOpeningHours?: MobilePracticeSettingsDtoPhoneOpeningHours;
}

export type MobilePrescriptionConversationSettingsDtoEnabledIssueTypesItem =
  (typeof MobilePrescriptionConversationSettingsDtoEnabledIssueTypesItem)[keyof typeof MobilePrescriptionConversationSettingsDtoEnabledIssueTypesItem];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MobilePrescriptionConversationSettingsDtoEnabledIssueTypesItem = {
  PRACTICE_PICKUP: 'PRACTICE_PICKUP',
  SEND_HOME: 'SEND_HOME',
  SEND_TO_PHARMACY: 'SEND_TO_PHARMACY',
} as const;

export interface MobilePrescriptionConversationSettingsDto {
  enabledIssueTypes: MobilePrescriptionConversationSettingsDtoEnabledIssueTypesItem[];
}

export type MobileSettingsDtoConversations = MobileConversationsSettingsDto | null;

export type MobileSettingsDtoObservations = MobileObservationsSettingsDto | null;

export type MobileSettingsDtoAppointments = MobileAppointmentsSettingsDto | null;

export type MobileSettingsDtoPractice = MobilePracticeSettingsDto | null;

export type MobileSettingsDtoMedication = MobileMedicationSettingsDto | null;

export interface MobileSettingsDto {
  conversations?: MobileSettingsDtoConversations;
  observations?: MobileSettingsDtoObservations;
  appointments?: MobileSettingsDtoAppointments;
  practice?: MobileSettingsDtoPractice;
  medication?: MobileSettingsDtoMedication;
}

export interface HospitalSelectionForPracticeUpdateDto {
  hospitalId: string;
  isSelected: boolean;
}

export type HeurekaPatientDtoPid = string | null;

export type HeurekaPatientDtoGender = 'FEMALE' | 'MALE' | null;

export type HeurekaPatientDtoAhvNumber = string | null;

export type HeurekaPatientDtoStreet = string | null;

export type HeurekaPatientDtoCity = string | null;

export type HeurekaPatientDtoPostalCode = string | null;

export interface HeurekaPatientDto {
  id: string;
  pid?: HeurekaPatientDtoPid;
  firstName: string;
  lastName: string;
  dateOfBirth: string;
  gender?: HeurekaPatientDtoGender;
  ahvNumber?: HeurekaPatientDtoAhvNumber;
  street?: HeurekaPatientDtoStreet;
  city?: HeurekaPatientDtoCity;
  postalCode?: HeurekaPatientDtoPostalCode;
}

export interface HeurekaPatientSuggestionDto {
  patient: HeurekaPatientDto;
  score: number;
}

export type LinkHeurekaDtoPid = string | null;

export interface LinkHeurekaDto {
  pid?: LinkHeurekaDtoPid;
  heurekaId: string;
}

export type CreateDeputyDtoDeputyDurationDays = number | null;

export interface CreateDeputyDto {
  deputyPracticeId: string;
  sharedPracticeId: string;
  deputyDurationDays?: CreateDeputyDtoDeputyDurationDays;
}

export interface RejectDeputyDto {
  message: string;
}

export type PracticeContractVersionDtoName =
  (typeof PracticeContractVersionDtoName)[keyof typeof PracticeContractVersionDtoName];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PracticeContractVersionDtoName = {
  SEPTEMBER_2023: 'SEPTEMBER_2023',
  FEBRUARY_2025: 'FEBRUARY_2025',
} as const;

export interface PracticeContractVersionDto {
  name: PracticeContractVersionDtoName;
  code: number;
}

export type PracticeDtoIsPartner = boolean | null;

export type PracticeDtoStreet = string | null;

export type PracticeDtoPostcode = string | null;

export type PracticeDtoCity = string | null;

export type PracticeDtoIsPatientMatchRunnerEnabled = boolean | null;

export type PracticeDtoMobileSettings = MobileSettingsDto | null;

export interface PracticeDto {
  id: string;
  name: string;
  email: string;
  isConnectedToHeureka: boolean;
  isPartner?: PracticeDtoIsPartner;
  street?: PracticeDtoStreet;
  postcode?: PracticeDtoPostcode;
  city?: PracticeDtoCity;
  isPatientMatchRunnerEnabled?: PracticeDtoIsPatientMatchRunnerEnabled;
  isHospitalEnabled: boolean;
  isMobileEnabled: boolean;
  mobileSettings?: PracticeDtoMobileSettings;
  isCallcenterEnabled: boolean;
  contractVersion: PracticeContractVersionDto;
}

export type UserDtoHinId = string | null;

export type UserDtoFirstName = string | null;

export type UserDtoLastName = string | null;

export type UserDtoLoginType = (typeof UserDtoLoginType)[keyof typeof UserDtoLoginType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UserDtoLoginType = {
  PRACTICE: 'PRACTICE',
  PERSONAL: 'PERSONAL',
} as const;

export interface UserDto {
  id: string;
  hinId?: UserDtoHinId;
  email: string;
  firstName?: UserDtoFirstName;
  lastName?: UserDtoLastName;
  loginType: UserDtoLoginType;
}

export interface WhoamiDto {
  user: UserDto;
  practices: PracticeDto[];
}

export type SharedPatientDtoBirthDate = string | null;

export type SharedPatientDtoAddress = string | null;

export type SharedPatientDtoZipCode = string | null;

export type SharedPatientDtoCity = string | null;

export type SharedPatientDtoInsurancePatientNumber = string | null;

export type SharedPatientDtoInsuranceName = string | null;

export type SharedPatientDtoPid = string | null;

export type SharedPatientDtoShareType = (typeof SharedPatientDtoShareType)[keyof typeof SharedPatientDtoShareType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SharedPatientDtoShareType = {
  PARTNER: 'PARTNER',
  DEPUTY: 'DEPUTY',
  EMERGENCY_SERVICE: 'EMERGENCY_SERVICE',
} as const;

export interface SharedPatientDto {
  id: string;
  firstName: string;
  lastName: string;
  birthDate?: SharedPatientDtoBirthDate;
  address?: SharedPatientDtoAddress;
  zipCode?: SharedPatientDtoZipCode;
  city?: SharedPatientDtoCity;
  insurancePatientNumber?: SharedPatientDtoInsurancePatientNumber;
  insuranceName?: SharedPatientDtoInsuranceName;
  pid?: SharedPatientDtoPid;
  practiceName: string;
  shareType: SharedPatientDtoShareType;
}

export interface EmergencyCircleDto {
  id: string;
  name: string;
  practices: PracticeDto[];
}

export type SharedPatientDetailsDtoBirthDate = string | null;

export type SharedPatientDetailsDtoAddress = string | null;

export type SharedPatientDetailsDtoZipCode = string | null;

export type SharedPatientDetailsDtoCity = string | null;

export type SharedPatientDetailsDtoPid = string | null;

export type SharedPatientDetailsDtoShareType =
  (typeof SharedPatientDetailsDtoShareType)[keyof typeof SharedPatientDetailsDtoShareType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SharedPatientDetailsDtoShareType = {
  PARTNER: 'PARTNER',
  DEPUTY: 'DEPUTY',
  EMERGENCY_SERVICE: 'EMERGENCY_SERVICE',
} as const;

export type SharedPatientDetailsDtoEmergencyCircle = EmergencyCircleDto | null;

export type SharedPatientDetailsDtoShareEndDate = string | null;

export interface SharedPatientDetailsDto {
  id: string;
  firstName: string;
  lastName: string;
  birthDate?: SharedPatientDetailsDtoBirthDate;
  address?: SharedPatientDetailsDtoAddress;
  zipCode?: SharedPatientDetailsDtoZipCode;
  city?: SharedPatientDetailsDtoCity;
  pid?: SharedPatientDetailsDtoPid;
  practiceName: string;
  shareType: SharedPatientDetailsDtoShareType;
  emergencyCircle?: SharedPatientDetailsDtoEmergencyCircle;
  shareEndDate?: SharedPatientDetailsDtoShareEndDate;
}

export type MobilePatientDtoPid = string | null;

export type MobilePatientDtoAppLanguage = string | null;

export interface MobilePatientDto {
  id: string;
  practiceId: string;
  pid?: MobilePatientDtoPid;
  firstName: string;
  lastName: string;
  birthDate: string;
  isManagedCare: boolean;
  heurekaPatientId: string;
  appLanguage?: MobilePatientDtoAppLanguage;
}

export interface ActivationUrl {
  url: string;
  expiresAt: string;
}

export interface HospitalDto {
  id: string;
  name: string;
  displayName: string;
}

export interface HospitalSelectionForPracticeDto {
  hospital: HospitalDto;
  isSelected: boolean;
}

export type ContractSignatureStatusDtoFirstName = string | null;

export type ContractSignatureStatusDtoLastName = string | null;

export interface ContractSignatureStatusDto {
  userId: string;
  email: string;
  firstName?: ContractSignatureStatusDtoFirstName;
  lastName?: ContractSignatureStatusDtoLastName;
  hasSigned: boolean;
}

export type PatientDtoPracticeId = string | null;

export type PatientDtoExternalId = string | null;

export type PatientDtoBirthDate = string | null;

export type PatientDtoAddress = string | null;

export type PatientDtoZipCode = string | null;

export type PatientDtoCity = string | null;

export type PatientDtoInsurancePatientNumber = string | null;

export type PatientDtoAhvNumber = string | null;

export type PatientDtoManagedByZsr = string | null;

export type PatientDtoHeurekaPatientId = string | null;

export type PatientDtoInsuranceName = string | null;

export type PatientDtoPid = string | null;

export type PatientDtoStatus = (typeof PatientDtoStatus)[keyof typeof PatientDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PatientDtoStatus = {
  NOT_SYNCED: 'NOT_SYNCED',
  SYNCING: 'SYNCING',
  NOT_FOUND: 'NOT_FOUND',
  EXTERNAL_ACCESS_SOON: 'EXTERNAL_ACCESS_SOON',
  EXTERNAL_ACCESS_GRANTED: 'EXTERNAL_ACCESS_GRANTED',
  EXTERNAL_ACCESS_REVOKED: 'EXTERNAL_ACCESS_REVOKED',
  NEVER_SEEN: 'NEVER_SEEN',
} as const;

export type PatientDtoHeurekaPatientMatchStatus =
  'NOT_FOUND' | 'MATCH_PENDING' | 'PERSONAL_INFO_MATCHED' | 'AHV_NUMBER_MATCHED' | 'MANUALLY_MATCHED' | null;

export interface PatientDto {
  id: string;
  practiceId?: PatientDtoPracticeId;
  externalId?: PatientDtoExternalId;
  firstName: string;
  lastName: string;
  birthDate?: PatientDtoBirthDate;
  address?: PatientDtoAddress;
  zipCode?: PatientDtoZipCode;
  city?: PatientDtoCity;
  insurancePatientNumber?: PatientDtoInsurancePatientNumber;
  ahvNumber?: PatientDtoAhvNumber;
  managedByZsr?: PatientDtoManagedByZsr;
  heurekaPatientId?: PatientDtoHeurekaPatientId;
  insuranceName?: PatientDtoInsuranceName;
  pid?: PatientDtoPid;
  externallyAvailableInDays: number;
  status: PatientDtoStatus;
  heurekaPatientMatchStatus?: PatientDtoHeurekaPatientMatchStatus;
}

export type HeurekaResourceAvailabilityDtoReadPatients =
  (typeof HeurekaResourceAvailabilityDtoReadPatients)[keyof typeof HeurekaResourceAvailabilityDtoReadPatients];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const HeurekaResourceAvailabilityDtoReadPatients = {
  UNSUPPORTED: 'UNSUPPORTED',
  NOT_GRANTED: 'NOT_GRANTED',
  GRANTED: 'GRANTED',
} as const;

export type HeurekaResourceAvailabilityDtoReadMedicationStatements =
  (typeof HeurekaResourceAvailabilityDtoReadMedicationStatements)[keyof typeof HeurekaResourceAvailabilityDtoReadMedicationStatements];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const HeurekaResourceAvailabilityDtoReadMedicationStatements = {
  UNSUPPORTED: 'UNSUPPORTED',
  NOT_GRANTED: 'NOT_GRANTED',
  GRANTED: 'GRANTED',
} as const;

export type HeurekaResourceAvailabilityDtoReadConditions =
  (typeof HeurekaResourceAvailabilityDtoReadConditions)[keyof typeof HeurekaResourceAvailabilityDtoReadConditions];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const HeurekaResourceAvailabilityDtoReadConditions = {
  UNSUPPORTED: 'UNSUPPORTED',
  NOT_GRANTED: 'NOT_GRANTED',
  GRANTED: 'GRANTED',
} as const;

export type HeurekaResourceAvailabilityDtoReadObservations =
  (typeof HeurekaResourceAvailabilityDtoReadObservations)[keyof typeof HeurekaResourceAvailabilityDtoReadObservations];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const HeurekaResourceAvailabilityDtoReadObservations = {
  UNSUPPORTED: 'UNSUPPORTED',
  NOT_GRANTED: 'NOT_GRANTED',
  GRANTED: 'GRANTED',
} as const;

export type HeurekaResourceAvailabilityDtoReadAppointments =
  (typeof HeurekaResourceAvailabilityDtoReadAppointments)[keyof typeof HeurekaResourceAvailabilityDtoReadAppointments];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const HeurekaResourceAvailabilityDtoReadAppointments = {
  UNSUPPORTED: 'UNSUPPORTED',
  NOT_GRANTED: 'NOT_GRANTED',
  GRANTED: 'GRANTED',
} as const;

export interface HeurekaResourceAvailabilityDto {
  readPatients: HeurekaResourceAvailabilityDtoReadPatients;
  readMedicationStatements: HeurekaResourceAvailabilityDtoReadMedicationStatements;
  readConditions: HeurekaResourceAvailabilityDtoReadConditions;
  readObservations: HeurekaResourceAvailabilityDtoReadObservations;
  readAppointments: HeurekaResourceAvailabilityDtoReadAppointments;
}

export interface PatientForManualMatchingDto {
  patient: HeurekaPatientDto;
  isAlreadyMatched: boolean;
}

export interface MobileVerificationPhoneNumberDto {
  id: string;
  phoneNumber: string;
}

export interface HeurekaDto {
  isConnected: boolean;
}

export type ConditionCodingDtoSystem = string | null;

export type ConditionCodingDtoCode = string | null;

export type ConditionCodingDtoDisplay = string | null;

export interface ConditionCodingDto {
  system?: ConditionCodingDtoSystem;
  code?: ConditionCodingDtoCode;
  display?: ConditionCodingDtoDisplay;
}

export type HeurekaConditionDtoRecorded = string | null;

export type HeurekaConditionDtoFrom = string | null;

export type HeurekaConditionDtoUntil = string | null;

export interface HeurekaConditionDto {
  id: string;
  codings: ConditionCodingDto[];
  comments: string[];
  recorded?: HeurekaConditionDtoRecorded;
  from?: HeurekaConditionDtoFrom;
  until?: HeurekaConditionDtoUntil;
}

export type HeurekaMedicationStatementDtoFrom = string | null;

export type HeurekaMedicationStatementDtoUntil = string | null;

export type HeurekaMedicationStatementDtoComments = string[] | null;

export type HeurekaMedicationStatementDtoPatientId = string | null;

export type HeurekaMedicationStatementDtoGtin = string | null;

export type HeurekaMedicationStatementDtoPharmaCode = string | null;

export type HeurekaMedicationStatementDtoHciProductNumber = string | null;

export interface HeurekaMedicationStatementDto {
  id: string;
  medicationName: string;
  from?: HeurekaMedicationStatementDtoFrom;
  until?: HeurekaMedicationStatementDtoUntil;
  dosage: MedicationDosageDto;
  comments?: HeurekaMedicationStatementDtoComments;
  asNeeded: boolean;
  patientId?: HeurekaMedicationStatementDtoPatientId;
  gtin?: HeurekaMedicationStatementDtoGtin;
  pharmaCode?: HeurekaMedicationStatementDtoPharmaCode;
  hciProductNumber?: HeurekaMedicationStatementDtoHciProductNumber;
}

export type HeurekaPatientDetailsDtoConditions = HeurekaConditionDto[] | null;

export interface HeurekaPatientDetailsDto {
  patient: ReducedHeurekaPatientDto;
  medicationStatements: HeurekaMedicationStatementDto[];
  conditions?: HeurekaPatientDetailsDtoConditions;
}

export type HeurekaPatientDetailsWithPracticeAndInsuranceDtoPracticeName = string | null;

export type HeurekaPatientDetailsWithPracticeAndInsuranceDtoPracticeEmail = string | null;

export type HeurekaPatientDetailsWithPracticeAndInsuranceDtoInsuranceName = string | null;

export type HeurekaPatientDetailsWithPracticeAndInsuranceDtoInsurancePatientNumber = string | null;

export type HeurekaPatientDetailsWithPracticeAndInsuranceDtoHeurekaDetails = HeurekaPatientDetailsDto | null;

export interface HeurekaPatientDetailsWithPracticeAndInsuranceDto {
  practiceName?: HeurekaPatientDetailsWithPracticeAndInsuranceDtoPracticeName;
  practiceEmail?: HeurekaPatientDetailsWithPracticeAndInsuranceDtoPracticeEmail;
  insuranceName?: HeurekaPatientDetailsWithPracticeAndInsuranceDtoInsuranceName;
  insurancePatientNumber?: HeurekaPatientDetailsWithPracticeAndInsuranceDtoInsurancePatientNumber;
  heurekaDetails?: HeurekaPatientDetailsWithPracticeAndInsuranceDtoHeurekaDetails;
}

export type MedicationDosageDtoMornNoonEveNight = number[] | null;

export type MedicationDosageDtoDetails = string[] | null;

export interface MedicationDosageDto {
  mornNoonEveNight?: MedicationDosageDtoMornNoonEveNight;
  details?: MedicationDosageDtoDetails;
}

export type ReducedHeurekaPatientDtoPid = string | null;

export type ReducedHeurekaPatientDtoGender = 'FEMALE' | 'MALE' | null;

export interface ReducedHeurekaPatientDto {
  id: string;
  pid?: ReducedHeurekaPatientDtoPid;
  firstName: string;
  lastName: string;
  dateOfBirth: string;
  gender?: ReducedHeurekaPatientDtoGender;
}

export interface EmergencyServiceDto {
  id: string;
  emergencyCircle: EmergencyCircleDto;
  practiceOnDuty: PracticeDto;
  endDateTime: string;
}

export type DeputyDtoEndDate = string | null;

export type DeputyDtoStatus = (typeof DeputyDtoStatus)[keyof typeof DeputyDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DeputyDtoStatus = {
  OFFERED: 'OFFERED',
  ACCEPTED: 'ACCEPTED',
  REJECTED: 'REJECTED',
  REVOKED: 'REVOKED',
} as const;

export type DeputyDtoCreated = string | null;

export type DeputyDtoUpdated = string | null;

export interface DeputyDto {
  id: string;
  offeringUser: UserDto;
  deputyPractice: PracticeDto;
  sharedPractice: PracticeDto;
  endDate?: DeputyDtoEndDate;
  status: DeputyDtoStatus;
  created?: DeputyDtoCreated;
  updated?: DeputyDtoUpdated;
}

export type AccessLogDtoCreated = string | null;

export type AccessLogDtoUser = string | null;

export type AccessLogDtoUserType = (typeof AccessLogDtoUserType)[keyof typeof AccessLogDtoUserType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AccessLogDtoUserType = {
  CALLCENTER: 'CALLCENTER',
  PRACTICE: 'PRACTICE',
  DEPUTY: 'DEPUTY',
  EMERGENCY_SERVICE: 'EMERGENCY_SERVICE',
  PARTNER: 'PARTNER',
  HOSPITAL: 'HOSPITAL',
  PATIENT: 'PATIENT',
} as const;

export type AccessLogDtoPatientLastName = string | null;

export type AccessLogDtoPatientFirstName = string | null;

export type AccessLogDtoPatientBirthDate = string | null;

export type AccessLogDtoPid = string | null;

export interface AccessLogDto {
  id: string;
  created?: AccessLogDtoCreated;
  user?: AccessLogDtoUser;
  userType: AccessLogDtoUserType;
  patientLastName?: AccessLogDtoPatientLastName;
  patientFirstName?: AccessLogDtoPatientFirstName;
  patientBirthDate?: AccessLogDtoPatientBirthDate;
  pid?: AccessLogDtoPid;
  count: number;
}

export type SetExternalAccessRevokedByPracticeParams = {
  practiceId: string;
};

export type MakeExternallyAccessibleNowByPracticeParams = {
  practiceId: string;
};

export type SetExternalAccessGrantedByPracticeParams = {
  practiceId: string;
};

export type StartEmergencyServiceParams = {
  emergencyCircleId: string;
  dutyPracticeId: string;
};

export type CreatePatientDataRequestBody = {
  insurance: string;
  insuranceCustomerNr: string;
  birthDate: string;
  pid: string;
  fid: string;
  hospitalName: string;
  department?: string;
  confirmationEmail: string;
  requestId: string;
  created: string;
  hmac: string;
};

export type ShareMedi24PatientWithPartnerParams = {
  practiceId: string;
  expiration: string;
};

export type GetPatientsSharedWithPracticeParams = {
  practiceId: string;
};

export type GetSharedPatientDetailsParams = {
  practiceId: string;
};

export type GetMobileActivationUrlParams = {
  heurekaPatientId: string;
};

export type GetCallcentersAssignedToPractice200Item =
  (typeof GetCallcentersAssignedToPractice200Item)[keyof typeof GetCallcentersAssignedToPractice200Item];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetCallcentersAssignedToPractice200Item = {
  MEDI24: 'MEDI24',
  SANTE24: 'SANTE24',
} as const;

export type GetPatientsByPracticeParams = {
  practiceId: string;
};

export type GetHeurekaPatientsByContentParams = {
  content: string;
};

export type GetHeurekaPatientForManualMatchingParams = {
  pid: string;
};

export type GetActiveEmergencyServiceForEmergencyCircleParams = {
  emergencyCircleId: string;
};

export type GetActiveEmergencyServiceForEmergencyCircle200 = EmergencyServiceDto | null;

export type GetEmergencyCirclesForPracticeParams = {
  practiceId: string;
};

export type GetOfferedDeputyForDeputyPractice200 = DeputyDto | null;

export type GetUnexpiredNonRevokedDeputiesForSharedPracticeParams = {
  sharedPracticeId: string;
};

export type GetDeputyPracticesByNameParams = {
  nameQuery: string;
  practiceId: string;
};

export type GetActiveDeputiesForDeputyPracticeParams = {
  deputyPracticeId: string;
};

export type GetAccessLogsForPracticeParams = {
  practiceId: string;
};

export type DenySharePatientWithHospitalParams = {
  hospitalPatientRequestId: string;
  hmac: string;
};

export type DenySharePatientWithHospital200 =
  (typeof DenySharePatientWithHospital200)[keyof typeof DenySharePatientWithHospital200];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DenySharePatientWithHospital200 = {
  SUCCESS: 'SUCCESS',
  DENIED: 'DENIED',
  ERROR: 'ERROR',
} as const;

export type AcceptSharePatientWithHospitalParams = {
  hospitalPatientRequestId: string;
  hmac: string;
};

export type AcceptSharePatientWithHospital200 =
  (typeof AcceptSharePatientWithHospital200)[keyof typeof AcceptSharePatientWithHospital200];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AcceptSharePatientWithHospital200 = {
  SUCCESS: 'SUCCESS',
  DENIED: 'DENIED',
  ERROR: 'ERROR',
} as const;

export type IsMedi24PatientDataAvailableParams = {
  insurance: string;
  insuranceCustomerNr: string;
  requestId: string;
  user: string;
  created: string;
  hmac: string;
};

export type GetMedi24PartnerPracticesParams = {
  patientId?: string;
};

export type GetMedi24EmailAddressParams = {
  zsr: string;
  requestId: string;
  user: string;
  created: string;
  hmac: string;
};

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

export const getNotificationSelection = (options?: SecondParameter<typeof request>, signal?: AbortSignal) => {
  return request<NotificationSelectionDto>({ url: `/suite/user/notification`, method: 'GET', signal }, options);
};

export const getGetNotificationSelectionQueryKey = () => {
  return [`/suite/user/notification`] as const;
};

export const getGetNotificationSelectionQueryOptions = <
  TData = Awaited<ReturnType<typeof getNotificationSelection>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getNotificationSelection>>, TError, TData>>;
  request?: SecondParameter<typeof request>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetNotificationSelectionQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getNotificationSelection>>> = ({ signal }) =>
    getNotificationSelection(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getNotificationSelection>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetNotificationSelectionQueryResult = NonNullable<Awaited<ReturnType<typeof getNotificationSelection>>>;
export type GetNotificationSelectionQueryError = unknown;

export function useGetNotificationSelection<
  TData = Awaited<ReturnType<typeof getNotificationSelection>>,
  TError = unknown,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getNotificationSelection>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNotificationSelection>>,
          TError,
          Awaited<ReturnType<typeof getNotificationSelection>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetNotificationSelection<
  TData = Awaited<ReturnType<typeof getNotificationSelection>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getNotificationSelection>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNotificationSelection>>,
          TError,
          Awaited<ReturnType<typeof getNotificationSelection>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetNotificationSelection<
  TData = Awaited<ReturnType<typeof getNotificationSelection>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getNotificationSelection>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetNotificationSelection<
  TData = Awaited<ReturnType<typeof getNotificationSelection>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getNotificationSelection>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetNotificationSelectionQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetNotificationSelectionSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getNotificationSelection>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getNotificationSelection>>, TError, TData>>;
  request?: SecondParameter<typeof request>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetNotificationSelectionQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getNotificationSelection>>> = ({ signal }) =>
    getNotificationSelection(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getNotificationSelection>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetNotificationSelectionSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getNotificationSelection>>
>;
export type GetNotificationSelectionSuspenseQueryError = unknown;

export function useGetNotificationSelectionSuspense<
  TData = Awaited<ReturnType<typeof getNotificationSelection>>,
  TError = unknown,
>(
  options: {
    query: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getNotificationSelection>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetNotificationSelectionSuspense<
  TData = Awaited<ReturnType<typeof getNotificationSelection>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getNotificationSelection>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetNotificationSelectionSuspense<
  TData = Awaited<ReturnType<typeof getNotificationSelection>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getNotificationSelection>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetNotificationSelectionSuspense<
  TData = Awaited<ReturnType<typeof getNotificationSelection>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getNotificationSelection>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetNotificationSelectionSuspenseQueryOptions(options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const updateNotificationSelection = (
  notificationSelectionDto: NotificationSelectionDto,
  options?: SecondParameter<typeof request>,
  signal?: AbortSignal,
) => {
  return request<void>(
    {
      url: `/suite/user/notification`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: notificationSelectionDto,
      signal,
    },
    options,
  );
};

export const getUpdateNotificationSelectionMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateNotificationSelection>>,
    TError,
    { data: NotificationSelectionDto },
    TContext
  >;
  request?: SecondParameter<typeof request>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateNotificationSelection>>,
  TError,
  { data: NotificationSelectionDto },
  TContext
> => {
  const mutationKey = ['updateNotificationSelection'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateNotificationSelection>>,
    { data: NotificationSelectionDto }
  > = (props) => {
    const { data } = props ?? {};

    return updateNotificationSelection(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateNotificationSelectionMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateNotificationSelection>>
>;
export type UpdateNotificationSelectionMutationBody = NotificationSelectionDto;
export type UpdateNotificationSelectionMutationError = unknown;

export const useUpdateNotificationSelection = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateNotificationSelection>>,
      TError,
      { data: NotificationSelectionDto },
      TContext
    >;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateNotificationSelection>>,
  TError,
  { data: NotificationSelectionDto },
  TContext
> => {
  const mutationOptions = getUpdateNotificationSelectionMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const getMobileSettings = (
  practiceId: string,
  options?: SecondParameter<typeof request>,
  signal?: AbortSignal,
) => {
  return request<MobileSettingsDto>(
    { url: `/suite/practices/${practiceId}/mobile/settings`, method: 'GET', signal },
    options,
  );
};

export const getGetMobileSettingsQueryKey = (practiceId?: string) => {
  return [`/suite/practices/${practiceId}/mobile/settings`] as const;
};

export const getGetMobileSettingsQueryOptions = <
  TData = Awaited<ReturnType<typeof getMobileSettings>>,
  TError = unknown,
>(
  practiceId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMobileSettings>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMobileSettingsQueryKey(practiceId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMobileSettings>>> = ({ signal }) =>
    getMobileSettings(practiceId, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!practiceId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMobileSettings>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMobileSettingsQueryResult = NonNullable<Awaited<ReturnType<typeof getMobileSettings>>>;
export type GetMobileSettingsQueryError = unknown;

export function useGetMobileSettings<TData = Awaited<ReturnType<typeof getMobileSettings>>, TError = unknown>(
  practiceId: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMobileSettings>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMobileSettings>>,
          TError,
          Awaited<ReturnType<typeof getMobileSettings>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMobileSettings<TData = Awaited<ReturnType<typeof getMobileSettings>>, TError = unknown>(
  practiceId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMobileSettings>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMobileSettings>>,
          TError,
          Awaited<ReturnType<typeof getMobileSettings>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMobileSettings<TData = Awaited<ReturnType<typeof getMobileSettings>>, TError = unknown>(
  practiceId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMobileSettings>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetMobileSettings<TData = Awaited<ReturnType<typeof getMobileSettings>>, TError = unknown>(
  practiceId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMobileSettings>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMobileSettingsQueryOptions(practiceId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMobileSettingsSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getMobileSettings>>,
  TError = unknown,
>(
  practiceId: string,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMobileSettings>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMobileSettingsQueryKey(practiceId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMobileSettings>>> = ({ signal }) =>
    getMobileSettings(practiceId, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getMobileSettings>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMobileSettingsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getMobileSettings>>>;
export type GetMobileSettingsSuspenseQueryError = unknown;

export function useGetMobileSettingsSuspense<TData = Awaited<ReturnType<typeof getMobileSettings>>, TError = unknown>(
  practiceId: string,
  options: {
    query: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMobileSettings>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMobileSettingsSuspense<TData = Awaited<ReturnType<typeof getMobileSettings>>, TError = unknown>(
  practiceId: string,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMobileSettings>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMobileSettingsSuspense<TData = Awaited<ReturnType<typeof getMobileSettings>>, TError = unknown>(
  practiceId: string,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMobileSettings>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetMobileSettingsSuspense<TData = Awaited<ReturnType<typeof getMobileSettings>>, TError = unknown>(
  practiceId: string,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMobileSettings>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMobileSettingsSuspenseQueryOptions(practiceId, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const updateMobileSettings = (
  practiceId: string,
  mobileSettingsDto: MobileSettingsDto,
  options?: SecondParameter<typeof request>,
  signal?: AbortSignal,
) => {
  return request<MobileSettingsDto>(
    {
      url: `/suite/practices/${practiceId}/mobile/settings`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: mobileSettingsDto,
      signal,
    },
    options,
  );
};

export const getUpdateMobileSettingsMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateMobileSettings>>,
    TError,
    { practiceId: string; data: MobileSettingsDto },
    TContext
  >;
  request?: SecondParameter<typeof request>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateMobileSettings>>,
  TError,
  { practiceId: string; data: MobileSettingsDto },
  TContext
> => {
  const mutationKey = ['updateMobileSettings'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateMobileSettings>>,
    { practiceId: string; data: MobileSettingsDto }
  > = (props) => {
    const { practiceId, data } = props ?? {};

    return updateMobileSettings(practiceId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateMobileSettingsMutationResult = NonNullable<Awaited<ReturnType<typeof updateMobileSettings>>>;
export type UpdateMobileSettingsMutationBody = MobileSettingsDto;
export type UpdateMobileSettingsMutationError = unknown;

export const useUpdateMobileSettings = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateMobileSettings>>,
      TError,
      { practiceId: string; data: MobileSettingsDto },
      TContext
    >;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateMobileSettings>>,
  TError,
  { practiceId: string; data: MobileSettingsDto },
  TContext
> => {
  const mutationOptions = getUpdateMobileSettingsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const logoutMobilePatient = (
  practiceId: string,
  mobilePatientId: string,
  options?: SecondParameter<typeof request>,
  signal?: AbortSignal,
) => {
  return request<void>(
    { url: `/suite/practices/${practiceId}/mobile/patients/${mobilePatientId}/logout`, method: 'POST', signal },
    options,
  );
};

export const getLogoutMobilePatientMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof logoutMobilePatient>>,
    TError,
    { practiceId: string; mobilePatientId: string },
    TContext
  >;
  request?: SecondParameter<typeof request>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof logoutMobilePatient>>,
  TError,
  { practiceId: string; mobilePatientId: string },
  TContext
> => {
  const mutationKey = ['logoutMobilePatient'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof logoutMobilePatient>>,
    { practiceId: string; mobilePatientId: string }
  > = (props) => {
    const { practiceId, mobilePatientId } = props ?? {};

    return logoutMobilePatient(practiceId, mobilePatientId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type LogoutMobilePatientMutationResult = NonNullable<Awaited<ReturnType<typeof logoutMobilePatient>>>;

export type LogoutMobilePatientMutationError = unknown;

export const useLogoutMobilePatient = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof logoutMobilePatient>>,
      TError,
      { practiceId: string; mobilePatientId: string },
      TContext
    >;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof logoutMobilePatient>>,
  TError,
  { practiceId: string; mobilePatientId: string },
  TContext
> => {
  const mutationOptions = getLogoutMobilePatientMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const getHospitalSelectionsForPractice = (
  practiceId: string,
  options?: SecondParameter<typeof request>,
  signal?: AbortSignal,
) => {
  return request<HospitalSelectionForPracticeDto[]>(
    { url: `/suite/practices/${practiceId}/hospitals`, method: 'GET', signal },
    options,
  );
};

export const getGetHospitalSelectionsForPracticeQueryKey = (practiceId?: string) => {
  return [`/suite/practices/${practiceId}/hospitals`] as const;
};

export const getGetHospitalSelectionsForPracticeQueryOptions = <
  TData = Awaited<ReturnType<typeof getHospitalSelectionsForPractice>>,
  TError = unknown,
>(
  practiceId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getHospitalSelectionsForPractice>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetHospitalSelectionsForPracticeQueryKey(practiceId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getHospitalSelectionsForPractice>>> = ({ signal }) =>
    getHospitalSelectionsForPractice(practiceId, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!practiceId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getHospitalSelectionsForPractice>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetHospitalSelectionsForPracticeQueryResult = NonNullable<
  Awaited<ReturnType<typeof getHospitalSelectionsForPractice>>
>;
export type GetHospitalSelectionsForPracticeQueryError = unknown;

export function useGetHospitalSelectionsForPractice<
  TData = Awaited<ReturnType<typeof getHospitalSelectionsForPractice>>,
  TError = unknown,
>(
  practiceId: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getHospitalSelectionsForPractice>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getHospitalSelectionsForPractice>>,
          TError,
          Awaited<ReturnType<typeof getHospitalSelectionsForPractice>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetHospitalSelectionsForPractice<
  TData = Awaited<ReturnType<typeof getHospitalSelectionsForPractice>>,
  TError = unknown,
>(
  practiceId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getHospitalSelectionsForPractice>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getHospitalSelectionsForPractice>>,
          TError,
          Awaited<ReturnType<typeof getHospitalSelectionsForPractice>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetHospitalSelectionsForPractice<
  TData = Awaited<ReturnType<typeof getHospitalSelectionsForPractice>>,
  TError = unknown,
>(
  practiceId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getHospitalSelectionsForPractice>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetHospitalSelectionsForPractice<
  TData = Awaited<ReturnType<typeof getHospitalSelectionsForPractice>>,
  TError = unknown,
>(
  practiceId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getHospitalSelectionsForPractice>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetHospitalSelectionsForPracticeQueryOptions(practiceId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetHospitalSelectionsForPracticeSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getHospitalSelectionsForPractice>>,
  TError = unknown,
>(
  practiceId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getHospitalSelectionsForPractice>>, TError, TData>
    >;
    request?: SecondParameter<typeof request>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetHospitalSelectionsForPracticeQueryKey(practiceId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getHospitalSelectionsForPractice>>> = ({ signal }) =>
    getHospitalSelectionsForPractice(practiceId, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getHospitalSelectionsForPractice>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetHospitalSelectionsForPracticeSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getHospitalSelectionsForPractice>>
>;
export type GetHospitalSelectionsForPracticeSuspenseQueryError = unknown;

export function useGetHospitalSelectionsForPracticeSuspense<
  TData = Awaited<ReturnType<typeof getHospitalSelectionsForPractice>>,
  TError = unknown,
>(
  practiceId: string,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getHospitalSelectionsForPractice>>, TError, TData>
    >;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetHospitalSelectionsForPracticeSuspense<
  TData = Awaited<ReturnType<typeof getHospitalSelectionsForPractice>>,
  TError = unknown,
>(
  practiceId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getHospitalSelectionsForPractice>>, TError, TData>
    >;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetHospitalSelectionsForPracticeSuspense<
  TData = Awaited<ReturnType<typeof getHospitalSelectionsForPractice>>,
  TError = unknown,
>(
  practiceId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getHospitalSelectionsForPractice>>, TError, TData>
    >;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetHospitalSelectionsForPracticeSuspense<
  TData = Awaited<ReturnType<typeof getHospitalSelectionsForPractice>>,
  TError = unknown,
>(
  practiceId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getHospitalSelectionsForPractice>>, TError, TData>
    >;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetHospitalSelectionsForPracticeSuspenseQueryOptions(practiceId, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const updateHospitalSelectionForPractice = (
  practiceId: string,
  hospitalSelectionForPracticeUpdateDto: HospitalSelectionForPracticeUpdateDto,
  options?: SecondParameter<typeof request>,
  signal?: AbortSignal,
) => {
  return request<void>(
    {
      url: `/suite/practices/${practiceId}/hospitals`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: hospitalSelectionForPracticeUpdateDto,
      signal,
    },
    options,
  );
};

export const getUpdateHospitalSelectionForPracticeMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateHospitalSelectionForPractice>>,
    TError,
    { practiceId: string; data: HospitalSelectionForPracticeUpdateDto },
    TContext
  >;
  request?: SecondParameter<typeof request>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateHospitalSelectionForPractice>>,
  TError,
  { practiceId: string; data: HospitalSelectionForPracticeUpdateDto },
  TContext
> => {
  const mutationKey = ['updateHospitalSelectionForPractice'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateHospitalSelectionForPractice>>,
    { practiceId: string; data: HospitalSelectionForPracticeUpdateDto }
  > = (props) => {
    const { practiceId, data } = props ?? {};

    return updateHospitalSelectionForPractice(practiceId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateHospitalSelectionForPracticeMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateHospitalSelectionForPractice>>
>;
export type UpdateHospitalSelectionForPracticeMutationBody = HospitalSelectionForPracticeUpdateDto;
export type UpdateHospitalSelectionForPracticeMutationError = unknown;

export const useUpdateHospitalSelectionForPractice = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateHospitalSelectionForPractice>>,
      TError,
      { practiceId: string; data: HospitalSelectionForPracticeUpdateDto },
      TContext
    >;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateHospitalSelectionForPractice>>,
  TError,
  { practiceId: string; data: HospitalSelectionForPracticeUpdateDto },
  TContext
> => {
  const mutationOptions = getUpdateHospitalSelectionForPracticeMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const getPracticeContractSignatures = (
  practiceId: string,
  contractVersion: 'SEPTEMBER_2023' | 'FEBRUARY_2025',
  options?: SecondParameter<typeof request>,
  signal?: AbortSignal,
) => {
  return request<ContractSignatureStatusDto[]>(
    { url: `/suite/practices/${practiceId}/contract/${contractVersion}/signatures`, method: 'GET', signal },
    options,
  );
};

export const getGetPracticeContractSignaturesQueryKey = (
  practiceId?: string,
  contractVersion?: 'SEPTEMBER_2023' | 'FEBRUARY_2025',
) => {
  return [`/suite/practices/${practiceId}/contract/${contractVersion}/signatures`] as const;
};

export const getGetPracticeContractSignaturesQueryOptions = <
  TData = Awaited<ReturnType<typeof getPracticeContractSignatures>>,
  TError = unknown,
>(
  practiceId: string,
  contractVersion: 'SEPTEMBER_2023' | 'FEBRUARY_2025',
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPracticeContractSignatures>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetPracticeContractSignaturesQueryKey(practiceId, contractVersion);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPracticeContractSignatures>>> = ({ signal }) =>
    getPracticeContractSignatures(practiceId, contractVersion, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!(practiceId && contractVersion), ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getPracticeContractSignatures>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetPracticeContractSignaturesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPracticeContractSignatures>>
>;
export type GetPracticeContractSignaturesQueryError = unknown;

export function useGetPracticeContractSignatures<
  TData = Awaited<ReturnType<typeof getPracticeContractSignatures>>,
  TError = unknown,
>(
  practiceId: string,
  contractVersion: 'SEPTEMBER_2023' | 'FEBRUARY_2025',
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPracticeContractSignatures>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPracticeContractSignatures>>,
          TError,
          Awaited<ReturnType<typeof getPracticeContractSignatures>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetPracticeContractSignatures<
  TData = Awaited<ReturnType<typeof getPracticeContractSignatures>>,
  TError = unknown,
>(
  practiceId: string,
  contractVersion: 'SEPTEMBER_2023' | 'FEBRUARY_2025',
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPracticeContractSignatures>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPracticeContractSignatures>>,
          TError,
          Awaited<ReturnType<typeof getPracticeContractSignatures>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetPracticeContractSignatures<
  TData = Awaited<ReturnType<typeof getPracticeContractSignatures>>,
  TError = unknown,
>(
  practiceId: string,
  contractVersion: 'SEPTEMBER_2023' | 'FEBRUARY_2025',
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPracticeContractSignatures>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetPracticeContractSignatures<
  TData = Awaited<ReturnType<typeof getPracticeContractSignatures>>,
  TError = unknown,
>(
  practiceId: string,
  contractVersion: 'SEPTEMBER_2023' | 'FEBRUARY_2025',
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPracticeContractSignatures>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetPracticeContractSignaturesQueryOptions(practiceId, contractVersion, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetPracticeContractSignaturesSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getPracticeContractSignatures>>,
  TError = unknown,
>(
  practiceId: string,
  contractVersion: 'SEPTEMBER_2023' | 'FEBRUARY_2025',
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPracticeContractSignatures>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetPracticeContractSignaturesQueryKey(practiceId, contractVersion);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPracticeContractSignatures>>> = ({ signal }) =>
    getPracticeContractSignatures(practiceId, contractVersion, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getPracticeContractSignatures>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetPracticeContractSignaturesSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPracticeContractSignatures>>
>;
export type GetPracticeContractSignaturesSuspenseQueryError = unknown;

export function useGetPracticeContractSignaturesSuspense<
  TData = Awaited<ReturnType<typeof getPracticeContractSignatures>>,
  TError = unknown,
>(
  practiceId: string,
  contractVersion: 'SEPTEMBER_2023' | 'FEBRUARY_2025',
  options: {
    query: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPracticeContractSignatures>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetPracticeContractSignaturesSuspense<
  TData = Awaited<ReturnType<typeof getPracticeContractSignatures>>,
  TError = unknown,
>(
  practiceId: string,
  contractVersion: 'SEPTEMBER_2023' | 'FEBRUARY_2025',
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPracticeContractSignatures>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetPracticeContractSignaturesSuspense<
  TData = Awaited<ReturnType<typeof getPracticeContractSignatures>>,
  TError = unknown,
>(
  practiceId: string,
  contractVersion: 'SEPTEMBER_2023' | 'FEBRUARY_2025',
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPracticeContractSignatures>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetPracticeContractSignaturesSuspense<
  TData = Awaited<ReturnType<typeof getPracticeContractSignatures>>,
  TError = unknown,
>(
  practiceId: string,
  contractVersion: 'SEPTEMBER_2023' | 'FEBRUARY_2025',
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPracticeContractSignatures>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetPracticeContractSignaturesSuspenseQueryOptions(practiceId, contractVersion, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const signPracticeContract = (
  practiceId: string,
  contractVersion: 'SEPTEMBER_2023' | 'FEBRUARY_2025',
  options?: SecondParameter<typeof request>,
  signal?: AbortSignal,
) => {
  return request<void>(
    { url: `/suite/practices/${practiceId}/contract/${contractVersion}/signatures`, method: 'POST', signal },
    options,
  );
};

export const getSignPracticeContractMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof signPracticeContract>>,
    TError,
    { practiceId: string; contractVersion: 'SEPTEMBER_2023' | 'FEBRUARY_2025' },
    TContext
  >;
  request?: SecondParameter<typeof request>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof signPracticeContract>>,
  TError,
  { practiceId: string; contractVersion: 'SEPTEMBER_2023' | 'FEBRUARY_2025' },
  TContext
> => {
  const mutationKey = ['signPracticeContract'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof signPracticeContract>>,
    { practiceId: string; contractVersion: 'SEPTEMBER_2023' | 'FEBRUARY_2025' }
  > = (props) => {
    const { practiceId, contractVersion } = props ?? {};

    return signPracticeContract(practiceId, contractVersion, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SignPracticeContractMutationResult = NonNullable<Awaited<ReturnType<typeof signPracticeContract>>>;

export type SignPracticeContractMutationError = unknown;

export const useSignPracticeContract = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof signPracticeContract>>,
      TError,
      { practiceId: string; contractVersion: 'SEPTEMBER_2023' | 'FEBRUARY_2025' },
      TContext
    >;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof signPracticeContract>>,
  TError,
  { practiceId: string; contractVersion: 'SEPTEMBER_2023' | 'FEBRUARY_2025' },
  TContext
> => {
  const mutationOptions = getSignPracticeContractMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const confirmSoloSignature = (
  practiceId: string,
  contractVersion: 'SEPTEMBER_2023' | 'FEBRUARY_2025',
  options?: SecondParameter<typeof request>,
  signal?: AbortSignal,
) => {
  return request<void>(
    { url: `/suite/practices/${practiceId}/contract/${contractVersion}/confirm-solo`, method: 'POST', signal },
    options,
  );
};

export const getConfirmSoloSignatureMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof confirmSoloSignature>>,
    TError,
    { practiceId: string; contractVersion: 'SEPTEMBER_2023' | 'FEBRUARY_2025' },
    TContext
  >;
  request?: SecondParameter<typeof request>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof confirmSoloSignature>>,
  TError,
  { practiceId: string; contractVersion: 'SEPTEMBER_2023' | 'FEBRUARY_2025' },
  TContext
> => {
  const mutationKey = ['confirmSoloSignature'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof confirmSoloSignature>>,
    { practiceId: string; contractVersion: 'SEPTEMBER_2023' | 'FEBRUARY_2025' }
  > = (props) => {
    const { practiceId, contractVersion } = props ?? {};

    return confirmSoloSignature(practiceId, contractVersion, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ConfirmSoloSignatureMutationResult = NonNullable<Awaited<ReturnType<typeof confirmSoloSignature>>>;

export type ConfirmSoloSignatureMutationError = unknown;

export const useConfirmSoloSignature = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof confirmSoloSignature>>,
      TError,
      { practiceId: string; contractVersion: 'SEPTEMBER_2023' | 'FEBRUARY_2025' },
      TContext
    >;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof confirmSoloSignature>>,
  TError,
  { practiceId: string; contractVersion: 'SEPTEMBER_2023' | 'FEBRUARY_2025' },
  TContext
> => {
  const mutationOptions = getConfirmSoloSignatureMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const unlinkHeurekaPatientById = (
  patientId: string,
  options?: SecondParameter<typeof request>,
  signal?: AbortSignal,
) => {
  return request<void>({ url: `/suite/patients/${patientId}/unlinkheureka`, method: 'POST', signal }, options);
};

export const getUnlinkHeurekaPatientByIdMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof unlinkHeurekaPatientById>>,
    TError,
    { patientId: string },
    TContext
  >;
  request?: SecondParameter<typeof request>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof unlinkHeurekaPatientById>>,
  TError,
  { patientId: string },
  TContext
> => {
  const mutationKey = ['unlinkHeurekaPatientById'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof unlinkHeurekaPatientById>>, { patientId: string }> = (
    props,
  ) => {
    const { patientId } = props ?? {};

    return unlinkHeurekaPatientById(patientId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UnlinkHeurekaPatientByIdMutationResult = NonNullable<Awaited<ReturnType<typeof unlinkHeurekaPatientById>>>;

export type UnlinkHeurekaPatientByIdMutationError = unknown;

export const useUnlinkHeurekaPatientById = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof unlinkHeurekaPatientById>>,
      TError,
      { patientId: string },
      TContext
    >;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseMutationResult<Awaited<ReturnType<typeof unlinkHeurekaPatientById>>, TError, { patientId: string }, TContext> => {
  const mutationOptions = getUnlinkHeurekaPatientByIdMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const setStatusToNeverSeen = (
  patientId: string,
  options?: SecondParameter<typeof request>,
  signal?: AbortSignal,
) => {
  return request<void>({ url: `/suite/patients/${patientId}/status/neverseen`, method: 'POST', signal }, options);
};

export const getSetStatusToNeverSeenMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof setStatusToNeverSeen>>,
    TError,
    { patientId: string },
    TContext
  >;
  request?: SecondParameter<typeof request>;
}): UseMutationOptions<Awaited<ReturnType<typeof setStatusToNeverSeen>>, TError, { patientId: string }, TContext> => {
  const mutationKey = ['setStatusToNeverSeen'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof setStatusToNeverSeen>>, { patientId: string }> = (
    props,
  ) => {
    const { patientId } = props ?? {};

    return setStatusToNeverSeen(patientId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SetStatusToNeverSeenMutationResult = NonNullable<Awaited<ReturnType<typeof setStatusToNeverSeen>>>;

export type SetStatusToNeverSeenMutationError = unknown;

export const useSetStatusToNeverSeen = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof setStatusToNeverSeen>>,
      TError,
      { patientId: string },
      TContext
    >;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseMutationResult<Awaited<ReturnType<typeof setStatusToNeverSeen>>, TError, { patientId: string }, TContext> => {
  const mutationOptions = getSetStatusToNeverSeenMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const refreshPatientMatchingSuggestions = (
  patientId: string,
  options?: SecondParameter<typeof request>,
  signal?: AbortSignal,
) => {
  return request<HeurekaPatientSuggestionDto[]>(
    { url: `/suite/patients/${patientId}/matching-suggestions/refresh`, method: 'POST', signal },
    options,
  );
};

export const getRefreshPatientMatchingSuggestionsMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof refreshPatientMatchingSuggestions>>,
    TError,
    { patientId: string },
    TContext
  >;
  request?: SecondParameter<typeof request>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof refreshPatientMatchingSuggestions>>,
  TError,
  { patientId: string },
  TContext
> => {
  const mutationKey = ['refreshPatientMatchingSuggestions'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof refreshPatientMatchingSuggestions>>,
    { patientId: string }
  > = (props) => {
    const { patientId } = props ?? {};

    return refreshPatientMatchingSuggestions(patientId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RefreshPatientMatchingSuggestionsMutationResult = NonNullable<
  Awaited<ReturnType<typeof refreshPatientMatchingSuggestions>>
>;

export type RefreshPatientMatchingSuggestionsMutationError = unknown;

export const useRefreshPatientMatchingSuggestions = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof refreshPatientMatchingSuggestions>>,
      TError,
      { patientId: string },
      TContext
    >;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof refreshPatientMatchingSuggestions>>,
  TError,
  { patientId: string },
  TContext
> => {
  const mutationOptions = getRefreshPatientMatchingSuggestionsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const linkHeurekaPatientById = (
  patientId: string,
  linkHeurekaDto: LinkHeurekaDto,
  options?: SecondParameter<typeof request>,
  signal?: AbortSignal,
) => {
  return request<void>(
    {
      url: `/suite/patients/${patientId}/linkheureka`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: linkHeurekaDto,
      signal,
    },
    options,
  );
};

export const getLinkHeurekaPatientByIdMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof linkHeurekaPatientById>>,
    TError,
    { patientId: string; data: LinkHeurekaDto },
    TContext
  >;
  request?: SecondParameter<typeof request>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof linkHeurekaPatientById>>,
  TError,
  { patientId: string; data: LinkHeurekaDto },
  TContext
> => {
  const mutationKey = ['linkHeurekaPatientById'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof linkHeurekaPatientById>>,
    { patientId: string; data: LinkHeurekaDto }
  > = (props) => {
    const { patientId, data } = props ?? {};

    return linkHeurekaPatientById(patientId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type LinkHeurekaPatientByIdMutationResult = NonNullable<Awaited<ReturnType<typeof linkHeurekaPatientById>>>;
export type LinkHeurekaPatientByIdMutationBody = LinkHeurekaDto;
export type LinkHeurekaPatientByIdMutationError = unknown;

export const useLinkHeurekaPatientById = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof linkHeurekaPatientById>>,
      TError,
      { patientId: string; data: LinkHeurekaDto },
      TContext
    >;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof linkHeurekaPatientById>>,
  TError,
  { patientId: string; data: LinkHeurekaDto },
  TContext
> => {
  const mutationOptions = getLinkHeurekaPatientByIdMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const revokeCallcenterAccess = (
  patientId: string,
  options?: SecondParameter<typeof request>,
  signal?: AbortSignal,
) => {
  return request<void>({ url: `/suite/patients/${patientId}/externalaccess/revoke`, method: 'POST', signal }, options);
};

export const getRevokeCallcenterAccessMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof revokeCallcenterAccess>>,
    TError,
    { patientId: string },
    TContext
  >;
  request?: SecondParameter<typeof request>;
}): UseMutationOptions<Awaited<ReturnType<typeof revokeCallcenterAccess>>, TError, { patientId: string }, TContext> => {
  const mutationKey = ['revokeCallcenterAccess'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof revokeCallcenterAccess>>, { patientId: string }> = (
    props,
  ) => {
    const { patientId } = props ?? {};

    return revokeCallcenterAccess(patientId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RevokeCallcenterAccessMutationResult = NonNullable<Awaited<ReturnType<typeof revokeCallcenterAccess>>>;

export type RevokeCallcenterAccessMutationError = unknown;

export const useRevokeCallcenterAccess = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof revokeCallcenterAccess>>,
      TError,
      { patientId: string },
      TContext
    >;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseMutationResult<Awaited<ReturnType<typeof revokeCallcenterAccess>>, TError, { patientId: string }, TContext> => {
  const mutationOptions = getRevokeCallcenterAccessMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const makeExternallyAccessibleNow = (
  patientId: string,
  options?: SecondParameter<typeof request>,
  signal?: AbortSignal,
) => {
  return request<void>(
    { url: `/suite/patients/${patientId}/externalaccess/grantnow`, method: 'POST', signal },
    options,
  );
};

export const getMakeExternallyAccessibleNowMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof makeExternallyAccessibleNow>>,
    TError,
    { patientId: string },
    TContext
  >;
  request?: SecondParameter<typeof request>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof makeExternallyAccessibleNow>>,
  TError,
  { patientId: string },
  TContext
> => {
  const mutationKey = ['makeExternallyAccessibleNow'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof makeExternallyAccessibleNow>>, { patientId: string }> = (
    props,
  ) => {
    const { patientId } = props ?? {};

    return makeExternallyAccessibleNow(patientId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type MakeExternallyAccessibleNowMutationResult = NonNullable<
  Awaited<ReturnType<typeof makeExternallyAccessibleNow>>
>;

export type MakeExternallyAccessibleNowMutationError = unknown;

export const useMakeExternallyAccessibleNow = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof makeExternallyAccessibleNow>>,
      TError,
      { patientId: string },
      TContext
    >;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof makeExternallyAccessibleNow>>,
  TError,
  { patientId: string },
  TContext
> => {
  const mutationOptions = getMakeExternallyAccessibleNowMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const grantCallcenterAccess = (
  patientId: string,
  options?: SecondParameter<typeof request>,
  signal?: AbortSignal,
) => {
  return request<void>({ url: `/suite/patients/${patientId}/externalaccess/grant`, method: 'POST', signal }, options);
};

export const getGrantCallcenterAccessMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof grantCallcenterAccess>>,
    TError,
    { patientId: string },
    TContext
  >;
  request?: SecondParameter<typeof request>;
}): UseMutationOptions<Awaited<ReturnType<typeof grantCallcenterAccess>>, TError, { patientId: string }, TContext> => {
  const mutationKey = ['grantCallcenterAccess'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof grantCallcenterAccess>>, { patientId: string }> = (
    props,
  ) => {
    const { patientId } = props ?? {};

    return grantCallcenterAccess(patientId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GrantCallcenterAccessMutationResult = NonNullable<Awaited<ReturnType<typeof grantCallcenterAccess>>>;

export type GrantCallcenterAccessMutationError = unknown;

export const useGrantCallcenterAccess = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof grantCallcenterAccess>>,
      TError,
      { patientId: string },
      TContext
    >;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseMutationResult<Awaited<ReturnType<typeof grantCallcenterAccess>>, TError, { patientId: string }, TContext> => {
  const mutationOptions = getGrantCallcenterAccessMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const setExternalAccessRevokedByPractice = (
  params: SetExternalAccessRevokedByPracticeParams,
  options?: SecondParameter<typeof request>,
  signal?: AbortSignal,
) => {
  return request<void>({ url: `/suite/patients/externalaccess/revoke`, method: 'POST', params, signal }, options);
};

export const getSetExternalAccessRevokedByPracticeMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof setExternalAccessRevokedByPractice>>,
    TError,
    { params: SetExternalAccessRevokedByPracticeParams },
    TContext
  >;
  request?: SecondParameter<typeof request>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof setExternalAccessRevokedByPractice>>,
  TError,
  { params: SetExternalAccessRevokedByPracticeParams },
  TContext
> => {
  const mutationKey = ['setExternalAccessRevokedByPractice'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof setExternalAccessRevokedByPractice>>,
    { params: SetExternalAccessRevokedByPracticeParams }
  > = (props) => {
    const { params } = props ?? {};

    return setExternalAccessRevokedByPractice(params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SetExternalAccessRevokedByPracticeMutationResult = NonNullable<
  Awaited<ReturnType<typeof setExternalAccessRevokedByPractice>>
>;

export type SetExternalAccessRevokedByPracticeMutationError = unknown;

export const useSetExternalAccessRevokedByPractice = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof setExternalAccessRevokedByPractice>>,
      TError,
      { params: SetExternalAccessRevokedByPracticeParams },
      TContext
    >;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof setExternalAccessRevokedByPractice>>,
  TError,
  { params: SetExternalAccessRevokedByPracticeParams },
  TContext
> => {
  const mutationOptions = getSetExternalAccessRevokedByPracticeMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const makeExternallyAccessibleNowByPractice = (
  params: MakeExternallyAccessibleNowByPracticeParams,
  options?: SecondParameter<typeof request>,
  signal?: AbortSignal,
) => {
  return request<void>({ url: `/suite/patients/externalaccess/grantnow`, method: 'POST', params, signal }, options);
};

export const getMakeExternallyAccessibleNowByPracticeMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof makeExternallyAccessibleNowByPractice>>,
    TError,
    { params: MakeExternallyAccessibleNowByPracticeParams },
    TContext
  >;
  request?: SecondParameter<typeof request>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof makeExternallyAccessibleNowByPractice>>,
  TError,
  { params: MakeExternallyAccessibleNowByPracticeParams },
  TContext
> => {
  const mutationKey = ['makeExternallyAccessibleNowByPractice'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof makeExternallyAccessibleNowByPractice>>,
    { params: MakeExternallyAccessibleNowByPracticeParams }
  > = (props) => {
    const { params } = props ?? {};

    return makeExternallyAccessibleNowByPractice(params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type MakeExternallyAccessibleNowByPracticeMutationResult = NonNullable<
  Awaited<ReturnType<typeof makeExternallyAccessibleNowByPractice>>
>;

export type MakeExternallyAccessibleNowByPracticeMutationError = unknown;

export const useMakeExternallyAccessibleNowByPractice = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof makeExternallyAccessibleNowByPractice>>,
      TError,
      { params: MakeExternallyAccessibleNowByPracticeParams },
      TContext
    >;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof makeExternallyAccessibleNowByPractice>>,
  TError,
  { params: MakeExternallyAccessibleNowByPracticeParams },
  TContext
> => {
  const mutationOptions = getMakeExternallyAccessibleNowByPracticeMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const setExternalAccessGrantedByPractice = (
  params: SetExternalAccessGrantedByPracticeParams,
  options?: SecondParameter<typeof request>,
  signal?: AbortSignal,
) => {
  return request<void>({ url: `/suite/patients/externalaccess/grant`, method: 'POST', params, signal }, options);
};

export const getSetExternalAccessGrantedByPracticeMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof setExternalAccessGrantedByPractice>>,
    TError,
    { params: SetExternalAccessGrantedByPracticeParams },
    TContext
  >;
  request?: SecondParameter<typeof request>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof setExternalAccessGrantedByPractice>>,
  TError,
  { params: SetExternalAccessGrantedByPracticeParams },
  TContext
> => {
  const mutationKey = ['setExternalAccessGrantedByPractice'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof setExternalAccessGrantedByPractice>>,
    { params: SetExternalAccessGrantedByPracticeParams }
  > = (props) => {
    const { params } = props ?? {};

    return setExternalAccessGrantedByPractice(params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SetExternalAccessGrantedByPracticeMutationResult = NonNullable<
  Awaited<ReturnType<typeof setExternalAccessGrantedByPractice>>
>;

export type SetExternalAccessGrantedByPracticeMutationError = unknown;

export const useSetExternalAccessGrantedByPractice = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof setExternalAccessGrantedByPractice>>,
      TError,
      { params: SetExternalAccessGrantedByPracticeParams },
      TContext
    >;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof setExternalAccessGrantedByPractice>>,
  TError,
  { params: SetExternalAccessGrantedByPracticeParams },
  TContext
> => {
  const mutationOptions = getSetExternalAccessGrantedByPracticeMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const prepareRedirectToRevokeHeurekaPortalScreen = (
  practiceId: string,
  options?: SecondParameter<typeof request>,
  signal?: AbortSignal,
) => {
  return request<string>(
    { url: `/suite/heureka/practices/${practiceId}/prepare-revoke`, method: 'POST', signal },
    options,
  );
};

export const getPrepareRedirectToRevokeHeurekaPortalScreenMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof prepareRedirectToRevokeHeurekaPortalScreen>>,
    TError,
    { practiceId: string },
    TContext
  >;
  request?: SecondParameter<typeof request>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof prepareRedirectToRevokeHeurekaPortalScreen>>,
  TError,
  { practiceId: string },
  TContext
> => {
  const mutationKey = ['prepareRedirectToRevokeHeurekaPortalScreen'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof prepareRedirectToRevokeHeurekaPortalScreen>>,
    { practiceId: string }
  > = (props) => {
    const { practiceId } = props ?? {};

    return prepareRedirectToRevokeHeurekaPortalScreen(practiceId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PrepareRedirectToRevokeHeurekaPortalScreenMutationResult = NonNullable<
  Awaited<ReturnType<typeof prepareRedirectToRevokeHeurekaPortalScreen>>
>;

export type PrepareRedirectToRevokeHeurekaPortalScreenMutationError = unknown;

export const usePrepareRedirectToRevokeHeurekaPortalScreen = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof prepareRedirectToRevokeHeurekaPortalScreen>>,
      TError,
      { practiceId: string },
      TContext
    >;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof prepareRedirectToRevokeHeurekaPortalScreen>>,
  TError,
  { practiceId: string },
  TContext
> => {
  const mutationOptions = getPrepareRedirectToRevokeHeurekaPortalScreenMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const startEmergencyService = (
  params: StartEmergencyServiceParams,
  options?: SecondParameter<typeof request>,
  signal?: AbortSignal,
) => {
  return request<void>({ url: `/suite/emergency-service/start`, method: 'POST', params, signal }, options);
};

export const getStartEmergencyServiceMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof startEmergencyService>>,
    TError,
    { params: StartEmergencyServiceParams },
    TContext
  >;
  request?: SecondParameter<typeof request>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof startEmergencyService>>,
  TError,
  { params: StartEmergencyServiceParams },
  TContext
> => {
  const mutationKey = ['startEmergencyService'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof startEmergencyService>>,
    { params: StartEmergencyServiceParams }
  > = (props) => {
    const { params } = props ?? {};

    return startEmergencyService(params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type StartEmergencyServiceMutationResult = NonNullable<Awaited<ReturnType<typeof startEmergencyService>>>;

export type StartEmergencyServiceMutationError = unknown;

export const useStartEmergencyService = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof startEmergencyService>>,
      TError,
      { params: StartEmergencyServiceParams },
      TContext
    >;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof startEmergencyService>>,
  TError,
  { params: StartEmergencyServiceParams },
  TContext
> => {
  const mutationOptions = getStartEmergencyServiceMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const createDeputy = (
  createDeputyDto: CreateDeputyDto,
  options?: SecondParameter<typeof request>,
  signal?: AbortSignal,
) => {
  return request<void>(
    {
      url: `/suite/deputies`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createDeputyDto,
      signal,
    },
    options,
  );
};

export const getCreateDeputyMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof createDeputy>>, TError, { data: CreateDeputyDto }, TContext>;
  request?: SecondParameter<typeof request>;
}): UseMutationOptions<Awaited<ReturnType<typeof createDeputy>>, TError, { data: CreateDeputyDto }, TContext> => {
  const mutationKey = ['createDeputy'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof createDeputy>>, { data: CreateDeputyDto }> = (props) => {
    const { data } = props ?? {};

    return createDeputy(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateDeputyMutationResult = NonNullable<Awaited<ReturnType<typeof createDeputy>>>;
export type CreateDeputyMutationBody = CreateDeputyDto;
export type CreateDeputyMutationError = unknown;

export const useCreateDeputy = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createDeputy>>,
      TError,
      { data: CreateDeputyDto },
      TContext
    >;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseMutationResult<Awaited<ReturnType<typeof createDeputy>>, TError, { data: CreateDeputyDto }, TContext> => {
  const mutationOptions = getCreateDeputyMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const revokeDeputy = (id: string, options?: SecondParameter<typeof request>, signal?: AbortSignal) => {
  return request<void>({ url: `/suite/deputies/${id}/revoke`, method: 'POST', signal }, options);
};

export const getRevokeDeputyMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof revokeDeputy>>, TError, { id: string }, TContext>;
  request?: SecondParameter<typeof request>;
}): UseMutationOptions<Awaited<ReturnType<typeof revokeDeputy>>, TError, { id: string }, TContext> => {
  const mutationKey = ['revokeDeputy'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof revokeDeputy>>, { id: string }> = (props) => {
    const { id } = props ?? {};

    return revokeDeputy(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RevokeDeputyMutationResult = NonNullable<Awaited<ReturnType<typeof revokeDeputy>>>;

export type RevokeDeputyMutationError = unknown;

export const useRevokeDeputy = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<Awaited<ReturnType<typeof revokeDeputy>>, TError, { id: string }, TContext>;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseMutationResult<Awaited<ReturnType<typeof revokeDeputy>>, TError, { id: string }, TContext> => {
  const mutationOptions = getRevokeDeputyMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const rejectDeputy = (
  id: string,
  rejectDeputyDto: RejectDeputyDto,
  options?: SecondParameter<typeof request>,
  signal?: AbortSignal,
) => {
  return request<void>(
    {
      url: `/suite/deputies/${id}/reject`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: rejectDeputyDto,
      signal,
    },
    options,
  );
};

export const getRejectDeputyMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof rejectDeputy>>,
    TError,
    { id: string; data: RejectDeputyDto },
    TContext
  >;
  request?: SecondParameter<typeof request>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof rejectDeputy>>,
  TError,
  { id: string; data: RejectDeputyDto },
  TContext
> => {
  const mutationKey = ['rejectDeputy'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof rejectDeputy>>,
    { id: string; data: RejectDeputyDto }
  > = (props) => {
    const { id, data } = props ?? {};

    return rejectDeputy(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RejectDeputyMutationResult = NonNullable<Awaited<ReturnType<typeof rejectDeputy>>>;
export type RejectDeputyMutationBody = RejectDeputyDto;
export type RejectDeputyMutationError = unknown;

export const useRejectDeputy = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof rejectDeputy>>,
      TError,
      { id: string; data: RejectDeputyDto },
      TContext
    >;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof rejectDeputy>>,
  TError,
  { id: string; data: RejectDeputyDto },
  TContext
> => {
  const mutationOptions = getRejectDeputyMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const acceptDeputy = (id: string, options?: SecondParameter<typeof request>, signal?: AbortSignal) => {
  return request<void>({ url: `/suite/deputies/${id}/accept`, method: 'POST', signal }, options);
};

export const getAcceptDeputyMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof acceptDeputy>>, TError, { id: string }, TContext>;
  request?: SecondParameter<typeof request>;
}): UseMutationOptions<Awaited<ReturnType<typeof acceptDeputy>>, TError, { id: string }, TContext> => {
  const mutationKey = ['acceptDeputy'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof acceptDeputy>>, { id: string }> = (props) => {
    const { id } = props ?? {};

    return acceptDeputy(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AcceptDeputyMutationResult = NonNullable<Awaited<ReturnType<typeof acceptDeputy>>>;

export type AcceptDeputyMutationError = unknown;

export const useAcceptDeputy = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<Awaited<ReturnType<typeof acceptDeputy>>, TError, { id: string }, TContext>;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseMutationResult<Awaited<ReturnType<typeof acceptDeputy>>, TError, { id: string }, TContext> => {
  const mutationOptions = getAcceptDeputyMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const createPatientDataRequest = (
  createPatientDataRequestBody: CreatePatientDataRequestBody,
  options?: SecondParameter<typeof request>,
  signal?: AbortSignal,
) => {
  const formUrlEncoded = new URLSearchParams();
  formUrlEncoded.append(`insurance`, createPatientDataRequestBody.insurance);
  formUrlEncoded.append(`insuranceCustomerNr`, createPatientDataRequestBody.insuranceCustomerNr);
  formUrlEncoded.append(`birthDate`, createPatientDataRequestBody.birthDate);
  formUrlEncoded.append(`pid`, createPatientDataRequestBody.pid);
  formUrlEncoded.append(`fid`, createPatientDataRequestBody.fid);
  formUrlEncoded.append(`hospitalName`, createPatientDataRequestBody.hospitalName);
  if (createPatientDataRequestBody.department !== undefined) {
    formUrlEncoded.append(`department`, createPatientDataRequestBody.department);
  }
  formUrlEncoded.append(`confirmationEmail`, createPatientDataRequestBody.confirmationEmail);
  formUrlEncoded.append(`requestId`, createPatientDataRequestBody.requestId);
  formUrlEncoded.append(`created`, createPatientDataRequestBody.created);
  formUrlEncoded.append(`hmac`, createPatientDataRequestBody.hmac);

  return request<string>(
    {
      url: `/hospital/patient/request`,
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      data: formUrlEncoded,
      signal,
    },
    options,
  );
};

export const getCreatePatientDataRequestMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createPatientDataRequest>>,
    TError,
    { data: CreatePatientDataRequestBody },
    TContext
  >;
  request?: SecondParameter<typeof request>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createPatientDataRequest>>,
  TError,
  { data: CreatePatientDataRequestBody },
  TContext
> => {
  const mutationKey = ['createPatientDataRequest'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createPatientDataRequest>>,
    { data: CreatePatientDataRequestBody }
  > = (props) => {
    const { data } = props ?? {};

    return createPatientDataRequest(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreatePatientDataRequestMutationResult = NonNullable<Awaited<ReturnType<typeof createPatientDataRequest>>>;
export type CreatePatientDataRequestMutationBody = CreatePatientDataRequestBody;
export type CreatePatientDataRequestMutationError = unknown;

export const useCreatePatientDataRequest = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createPatientDataRequest>>,
      TError,
      { data: CreatePatientDataRequestBody },
      TContext
    >;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createPatientDataRequest>>,
  TError,
  { data: CreatePatientDataRequestBody },
  TContext
> => {
  const mutationOptions = getCreatePatientDataRequestMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const shareMedi24PatientWithPartner = (
  patientId: string,
  params: ShareMedi24PatientWithPartnerParams,
  options?: SecondParameter<typeof request>,
  signal?: AbortSignal,
) => {
  return request<void>(
    { url: `/callcenter/medi24/patients/${patientId}/share`, method: 'POST', params, signal },
    options,
  );
};

export const getShareMedi24PatientWithPartnerMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof shareMedi24PatientWithPartner>>,
    TError,
    { patientId: string; params: ShareMedi24PatientWithPartnerParams },
    TContext
  >;
  request?: SecondParameter<typeof request>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof shareMedi24PatientWithPartner>>,
  TError,
  { patientId: string; params: ShareMedi24PatientWithPartnerParams },
  TContext
> => {
  const mutationKey = ['shareMedi24PatientWithPartner'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof shareMedi24PatientWithPartner>>,
    { patientId: string; params: ShareMedi24PatientWithPartnerParams }
  > = (props) => {
    const { patientId, params } = props ?? {};

    return shareMedi24PatientWithPartner(patientId, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ShareMedi24PatientWithPartnerMutationResult = NonNullable<
  Awaited<ReturnType<typeof shareMedi24PatientWithPartner>>
>;

export type ShareMedi24PatientWithPartnerMutationError = unknown;

export const useShareMedi24PatientWithPartner = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof shareMedi24PatientWithPartner>>,
      TError,
      { patientId: string; params: ShareMedi24PatientWithPartnerParams },
      TContext
    >;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof shareMedi24PatientWithPartner>>,
  TError,
  { patientId: string; params: ShareMedi24PatientWithPartnerParams },
  TContext
> => {
  const mutationOptions = getShareMedi24PatientWithPartnerMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const getSelf = (options?: SecondParameter<typeof request>, signal?: AbortSignal) => {
  return request<WhoamiDto>({ url: `/suite/whoami`, method: 'GET', signal }, options);
};

export const getGetSelfQueryKey = () => {
  return [`/suite/whoami`] as const;
};

export const getGetSelfQueryOptions = <TData = Awaited<ReturnType<typeof getSelf>>, TError = unknown>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSelf>>, TError, TData>>;
  request?: SecondParameter<typeof request>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetSelfQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSelf>>> = ({ signal }) => getSelf(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSelf>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetSelfQueryResult = NonNullable<Awaited<ReturnType<typeof getSelf>>>;
export type GetSelfQueryError = unknown;

export function useGetSelf<TData = Awaited<ReturnType<typeof getSelf>>, TError = unknown>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSelf>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<Awaited<ReturnType<typeof getSelf>>, TError, Awaited<ReturnType<typeof getSelf>>>,
        'initialData'
      >;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetSelf<TData = Awaited<ReturnType<typeof getSelf>>, TError = unknown>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSelf>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<Awaited<ReturnType<typeof getSelf>>, TError, Awaited<ReturnType<typeof getSelf>>>,
        'initialData'
      >;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetSelf<TData = Awaited<ReturnType<typeof getSelf>>, TError = unknown>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSelf>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetSelf<TData = Awaited<ReturnType<typeof getSelf>>, TError = unknown>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSelf>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetSelfQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetSelfSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getSelf>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSelf>>, TError, TData>>;
  request?: SecondParameter<typeof request>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetSelfQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSelf>>> = ({ signal }) => getSelf(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getSelf>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetSelfSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getSelf>>>;
export type GetSelfSuspenseQueryError = unknown;

export function useGetSelfSuspense<TData = Awaited<ReturnType<typeof getSelf>>, TError = unknown>(
  options: {
    query: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSelf>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetSelfSuspense<TData = Awaited<ReturnType<typeof getSelf>>, TError = unknown>(
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSelf>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetSelfSuspense<TData = Awaited<ReturnType<typeof getSelf>>, TError = unknown>(
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSelf>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetSelfSuspense<TData = Awaited<ReturnType<typeof getSelf>>, TError = unknown>(
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSelf>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetSelfSuspenseQueryOptions(options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getPatientsSharedWithPractice = (
  params: GetPatientsSharedWithPracticeParams,
  options?: SecondParameter<typeof request>,
  signal?: AbortSignal,
) => {
  return request<SharedPatientDto[]>({ url: `/suite/shared-patients`, method: 'GET', params, signal }, options);
};

export const getGetPatientsSharedWithPracticeQueryKey = (params?: GetPatientsSharedWithPracticeParams) => {
  return [`/suite/shared-patients`, ...(params ? [params] : [])] as const;
};

export const getGetPatientsSharedWithPracticeQueryOptions = <
  TData = Awaited<ReturnType<typeof getPatientsSharedWithPractice>>,
  TError = unknown,
>(
  params: GetPatientsSharedWithPracticeParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientsSharedWithPractice>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetPatientsSharedWithPracticeQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPatientsSharedWithPractice>>> = ({ signal }) =>
    getPatientsSharedWithPractice(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getPatientsSharedWithPractice>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetPatientsSharedWithPracticeQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPatientsSharedWithPractice>>
>;
export type GetPatientsSharedWithPracticeQueryError = unknown;

export function useGetPatientsSharedWithPractice<
  TData = Awaited<ReturnType<typeof getPatientsSharedWithPractice>>,
  TError = unknown,
>(
  params: GetPatientsSharedWithPracticeParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientsSharedWithPractice>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPatientsSharedWithPractice>>,
          TError,
          Awaited<ReturnType<typeof getPatientsSharedWithPractice>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetPatientsSharedWithPractice<
  TData = Awaited<ReturnType<typeof getPatientsSharedWithPractice>>,
  TError = unknown,
>(
  params: GetPatientsSharedWithPracticeParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientsSharedWithPractice>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPatientsSharedWithPractice>>,
          TError,
          Awaited<ReturnType<typeof getPatientsSharedWithPractice>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetPatientsSharedWithPractice<
  TData = Awaited<ReturnType<typeof getPatientsSharedWithPractice>>,
  TError = unknown,
>(
  params: GetPatientsSharedWithPracticeParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientsSharedWithPractice>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetPatientsSharedWithPractice<
  TData = Awaited<ReturnType<typeof getPatientsSharedWithPractice>>,
  TError = unknown,
>(
  params: GetPatientsSharedWithPracticeParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientsSharedWithPractice>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetPatientsSharedWithPracticeQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetPatientsSharedWithPracticeSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getPatientsSharedWithPractice>>,
  TError = unknown,
>(
  params: GetPatientsSharedWithPracticeParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientsSharedWithPractice>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetPatientsSharedWithPracticeQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPatientsSharedWithPractice>>> = ({ signal }) =>
    getPatientsSharedWithPractice(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getPatientsSharedWithPractice>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetPatientsSharedWithPracticeSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPatientsSharedWithPractice>>
>;
export type GetPatientsSharedWithPracticeSuspenseQueryError = unknown;

export function useGetPatientsSharedWithPracticeSuspense<
  TData = Awaited<ReturnType<typeof getPatientsSharedWithPractice>>,
  TError = unknown,
>(
  params: GetPatientsSharedWithPracticeParams,
  options: {
    query: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientsSharedWithPractice>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetPatientsSharedWithPracticeSuspense<
  TData = Awaited<ReturnType<typeof getPatientsSharedWithPractice>>,
  TError = unknown,
>(
  params: GetPatientsSharedWithPracticeParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientsSharedWithPractice>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetPatientsSharedWithPracticeSuspense<
  TData = Awaited<ReturnType<typeof getPatientsSharedWithPractice>>,
  TError = unknown,
>(
  params: GetPatientsSharedWithPracticeParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientsSharedWithPractice>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetPatientsSharedWithPracticeSuspense<
  TData = Awaited<ReturnType<typeof getPatientsSharedWithPractice>>,
  TError = unknown,
>(
  params: GetPatientsSharedWithPracticeParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientsSharedWithPractice>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetPatientsSharedWithPracticeSuspenseQueryOptions(params, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getSharedPatientDetails = (
  id: string,
  params: GetSharedPatientDetailsParams,
  options?: SecondParameter<typeof request>,
  signal?: AbortSignal,
) => {
  return request<SharedPatientDetailsDto>(
    { url: `/suite/shared-patients/${id}`, method: 'GET', params, signal },
    options,
  );
};

export const getGetSharedPatientDetailsQueryKey = (id?: string, params?: GetSharedPatientDetailsParams) => {
  return [`/suite/shared-patients/${id}`, ...(params ? [params] : [])] as const;
};

export const getGetSharedPatientDetailsQueryOptions = <
  TData = Awaited<ReturnType<typeof getSharedPatientDetails>>,
  TError = unknown,
>(
  id: string,
  params: GetSharedPatientDetailsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSharedPatientDetails>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetSharedPatientDetailsQueryKey(id, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSharedPatientDetails>>> = ({ signal }) =>
    getSharedPatientDetails(id, params, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSharedPatientDetails>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetSharedPatientDetailsQueryResult = NonNullable<Awaited<ReturnType<typeof getSharedPatientDetails>>>;
export type GetSharedPatientDetailsQueryError = unknown;

export function useGetSharedPatientDetails<
  TData = Awaited<ReturnType<typeof getSharedPatientDetails>>,
  TError = unknown,
>(
  id: string,
  params: GetSharedPatientDetailsParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSharedPatientDetails>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSharedPatientDetails>>,
          TError,
          Awaited<ReturnType<typeof getSharedPatientDetails>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetSharedPatientDetails<
  TData = Awaited<ReturnType<typeof getSharedPatientDetails>>,
  TError = unknown,
>(
  id: string,
  params: GetSharedPatientDetailsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSharedPatientDetails>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSharedPatientDetails>>,
          TError,
          Awaited<ReturnType<typeof getSharedPatientDetails>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetSharedPatientDetails<
  TData = Awaited<ReturnType<typeof getSharedPatientDetails>>,
  TError = unknown,
>(
  id: string,
  params: GetSharedPatientDetailsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSharedPatientDetails>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetSharedPatientDetails<
  TData = Awaited<ReturnType<typeof getSharedPatientDetails>>,
  TError = unknown,
>(
  id: string,
  params: GetSharedPatientDetailsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSharedPatientDetails>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetSharedPatientDetailsQueryOptions(id, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetSharedPatientDetailsSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getSharedPatientDetails>>,
  TError = unknown,
>(
  id: string,
  params: GetSharedPatientDetailsParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSharedPatientDetails>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetSharedPatientDetailsQueryKey(id, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSharedPatientDetails>>> = ({ signal }) =>
    getSharedPatientDetails(id, params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getSharedPatientDetails>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetSharedPatientDetailsSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSharedPatientDetails>>
>;
export type GetSharedPatientDetailsSuspenseQueryError = unknown;

export function useGetSharedPatientDetailsSuspense<
  TData = Awaited<ReturnType<typeof getSharedPatientDetails>>,
  TError = unknown,
>(
  id: string,
  params: GetSharedPatientDetailsParams,
  options: {
    query: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSharedPatientDetails>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetSharedPatientDetailsSuspense<
  TData = Awaited<ReturnType<typeof getSharedPatientDetails>>,
  TError = unknown,
>(
  id: string,
  params: GetSharedPatientDetailsParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSharedPatientDetails>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetSharedPatientDetailsSuspense<
  TData = Awaited<ReturnType<typeof getSharedPatientDetails>>,
  TError = unknown,
>(
  id: string,
  params: GetSharedPatientDetailsParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSharedPatientDetails>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetSharedPatientDetailsSuspense<
  TData = Awaited<ReturnType<typeof getSharedPatientDetails>>,
  TError = unknown,
>(
  id: string,
  params: GetSharedPatientDetailsParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSharedPatientDetails>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetSharedPatientDetailsSuspenseQueryOptions(id, params, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getMobilePatients = (
  practiceId: string,
  options?: SecondParameter<typeof request>,
  signal?: AbortSignal,
) => {
  return request<MobilePatientDto[]>(
    { url: `/suite/practices/${practiceId}/mobile/patients`, method: 'GET', signal },
    options,
  );
};

export const getGetMobilePatientsQueryKey = (practiceId?: string) => {
  return [`/suite/practices/${practiceId}/mobile/patients`] as const;
};

export const getGetMobilePatientsQueryOptions = <
  TData = Awaited<ReturnType<typeof getMobilePatients>>,
  TError = unknown,
>(
  practiceId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMobilePatients>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMobilePatientsQueryKey(practiceId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMobilePatients>>> = ({ signal }) =>
    getMobilePatients(practiceId, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!practiceId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMobilePatients>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMobilePatientsQueryResult = NonNullable<Awaited<ReturnType<typeof getMobilePatients>>>;
export type GetMobilePatientsQueryError = unknown;

export function useGetMobilePatients<TData = Awaited<ReturnType<typeof getMobilePatients>>, TError = unknown>(
  practiceId: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMobilePatients>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMobilePatients>>,
          TError,
          Awaited<ReturnType<typeof getMobilePatients>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMobilePatients<TData = Awaited<ReturnType<typeof getMobilePatients>>, TError = unknown>(
  practiceId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMobilePatients>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMobilePatients>>,
          TError,
          Awaited<ReturnType<typeof getMobilePatients>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMobilePatients<TData = Awaited<ReturnType<typeof getMobilePatients>>, TError = unknown>(
  practiceId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMobilePatients>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetMobilePatients<TData = Awaited<ReturnType<typeof getMobilePatients>>, TError = unknown>(
  practiceId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMobilePatients>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMobilePatientsQueryOptions(practiceId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMobilePatientsSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getMobilePatients>>,
  TError = unknown,
>(
  practiceId: string,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMobilePatients>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMobilePatientsQueryKey(practiceId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMobilePatients>>> = ({ signal }) =>
    getMobilePatients(practiceId, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getMobilePatients>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMobilePatientsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getMobilePatients>>>;
export type GetMobilePatientsSuspenseQueryError = unknown;

export function useGetMobilePatientsSuspense<TData = Awaited<ReturnType<typeof getMobilePatients>>, TError = unknown>(
  practiceId: string,
  options: {
    query: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMobilePatients>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMobilePatientsSuspense<TData = Awaited<ReturnType<typeof getMobilePatients>>, TError = unknown>(
  practiceId: string,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMobilePatients>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMobilePatientsSuspense<TData = Awaited<ReturnType<typeof getMobilePatients>>, TError = unknown>(
  practiceId: string,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMobilePatients>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetMobilePatientsSuspense<TData = Awaited<ReturnType<typeof getMobilePatients>>, TError = unknown>(
  practiceId: string,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMobilePatients>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMobilePatientsSuspenseQueryOptions(practiceId, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getMobilePatientPasskeyCount = (
  practiceId: string,
  mobilePatientId: string,
  options?: SecondParameter<typeof request>,
  signal?: AbortSignal,
) => {
  return request<number>(
    { url: `/suite/practices/${practiceId}/mobile/patients/${mobilePatientId}/passkey-count`, method: 'GET', signal },
    options,
  );
};

export const getGetMobilePatientPasskeyCountQueryKey = (practiceId?: string, mobilePatientId?: string) => {
  return [`/suite/practices/${practiceId}/mobile/patients/${mobilePatientId}/passkey-count`] as const;
};

export const getGetMobilePatientPasskeyCountQueryOptions = <
  TData = Awaited<ReturnType<typeof getMobilePatientPasskeyCount>>,
  TError = unknown,
>(
  practiceId: string,
  mobilePatientId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMobilePatientPasskeyCount>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMobilePatientPasskeyCountQueryKey(practiceId, mobilePatientId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMobilePatientPasskeyCount>>> = ({ signal }) =>
    getMobilePatientPasskeyCount(practiceId, mobilePatientId, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!(practiceId && mobilePatientId), ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMobilePatientPasskeyCount>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMobilePatientPasskeyCountQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMobilePatientPasskeyCount>>
>;
export type GetMobilePatientPasskeyCountQueryError = unknown;

export function useGetMobilePatientPasskeyCount<
  TData = Awaited<ReturnType<typeof getMobilePatientPasskeyCount>>,
  TError = unknown,
>(
  practiceId: string,
  mobilePatientId: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMobilePatientPasskeyCount>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMobilePatientPasskeyCount>>,
          TError,
          Awaited<ReturnType<typeof getMobilePatientPasskeyCount>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMobilePatientPasskeyCount<
  TData = Awaited<ReturnType<typeof getMobilePatientPasskeyCount>>,
  TError = unknown,
>(
  practiceId: string,
  mobilePatientId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMobilePatientPasskeyCount>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMobilePatientPasskeyCount>>,
          TError,
          Awaited<ReturnType<typeof getMobilePatientPasskeyCount>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMobilePatientPasskeyCount<
  TData = Awaited<ReturnType<typeof getMobilePatientPasskeyCount>>,
  TError = unknown,
>(
  practiceId: string,
  mobilePatientId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMobilePatientPasskeyCount>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetMobilePatientPasskeyCount<
  TData = Awaited<ReturnType<typeof getMobilePatientPasskeyCount>>,
  TError = unknown,
>(
  practiceId: string,
  mobilePatientId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMobilePatientPasskeyCount>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMobilePatientPasskeyCountQueryOptions(practiceId, mobilePatientId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMobilePatientPasskeyCountSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getMobilePatientPasskeyCount>>,
  TError = unknown,
>(
  practiceId: string,
  mobilePatientId: string,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMobilePatientPasskeyCount>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMobilePatientPasskeyCountQueryKey(practiceId, mobilePatientId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMobilePatientPasskeyCount>>> = ({ signal }) =>
    getMobilePatientPasskeyCount(practiceId, mobilePatientId, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getMobilePatientPasskeyCount>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMobilePatientPasskeyCountSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMobilePatientPasskeyCount>>
>;
export type GetMobilePatientPasskeyCountSuspenseQueryError = unknown;

export function useGetMobilePatientPasskeyCountSuspense<
  TData = Awaited<ReturnType<typeof getMobilePatientPasskeyCount>>,
  TError = unknown,
>(
  practiceId: string,
  mobilePatientId: string,
  options: {
    query: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMobilePatientPasskeyCount>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMobilePatientPasskeyCountSuspense<
  TData = Awaited<ReturnType<typeof getMobilePatientPasskeyCount>>,
  TError = unknown,
>(
  practiceId: string,
  mobilePatientId: string,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMobilePatientPasskeyCount>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMobilePatientPasskeyCountSuspense<
  TData = Awaited<ReturnType<typeof getMobilePatientPasskeyCount>>,
  TError = unknown,
>(
  practiceId: string,
  mobilePatientId: string,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMobilePatientPasskeyCount>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetMobilePatientPasskeyCountSuspense<
  TData = Awaited<ReturnType<typeof getMobilePatientPasskeyCount>>,
  TError = unknown,
>(
  practiceId: string,
  mobilePatientId: string,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMobilePatientPasskeyCount>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMobilePatientPasskeyCountSuspenseQueryOptions(practiceId, mobilePatientId, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getIsHeurekaPatientManagedCare = (
  practiceId: string,
  heurekaPatientId: string,
  options?: SecondParameter<typeof request>,
  signal?: AbortSignal,
) => {
  return request<boolean>(
    {
      url: `/suite/practices/${practiceId}/mobile/patients/heureka/${heurekaPatientId}/is-managed-care`,
      method: 'GET',
      signal,
    },
    options,
  );
};

export const getGetIsHeurekaPatientManagedCareQueryKey = (practiceId?: string, heurekaPatientId?: string) => {
  return [`/suite/practices/${practiceId}/mobile/patients/heureka/${heurekaPatientId}/is-managed-care`] as const;
};

export const getGetIsHeurekaPatientManagedCareQueryOptions = <
  TData = Awaited<ReturnType<typeof getIsHeurekaPatientManagedCare>>,
  TError = unknown,
>(
  practiceId: string,
  heurekaPatientId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getIsHeurekaPatientManagedCare>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetIsHeurekaPatientManagedCareQueryKey(practiceId, heurekaPatientId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getIsHeurekaPatientManagedCare>>> = ({ signal }) =>
    getIsHeurekaPatientManagedCare(practiceId, heurekaPatientId, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!(practiceId && heurekaPatientId), ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getIsHeurekaPatientManagedCare>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetIsHeurekaPatientManagedCareQueryResult = NonNullable<
  Awaited<ReturnType<typeof getIsHeurekaPatientManagedCare>>
>;
export type GetIsHeurekaPatientManagedCareQueryError = unknown;

export function useGetIsHeurekaPatientManagedCare<
  TData = Awaited<ReturnType<typeof getIsHeurekaPatientManagedCare>>,
  TError = unknown,
>(
  practiceId: string,
  heurekaPatientId: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getIsHeurekaPatientManagedCare>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getIsHeurekaPatientManagedCare>>,
          TError,
          Awaited<ReturnType<typeof getIsHeurekaPatientManagedCare>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetIsHeurekaPatientManagedCare<
  TData = Awaited<ReturnType<typeof getIsHeurekaPatientManagedCare>>,
  TError = unknown,
>(
  practiceId: string,
  heurekaPatientId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getIsHeurekaPatientManagedCare>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getIsHeurekaPatientManagedCare>>,
          TError,
          Awaited<ReturnType<typeof getIsHeurekaPatientManagedCare>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetIsHeurekaPatientManagedCare<
  TData = Awaited<ReturnType<typeof getIsHeurekaPatientManagedCare>>,
  TError = unknown,
>(
  practiceId: string,
  heurekaPatientId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getIsHeurekaPatientManagedCare>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetIsHeurekaPatientManagedCare<
  TData = Awaited<ReturnType<typeof getIsHeurekaPatientManagedCare>>,
  TError = unknown,
>(
  practiceId: string,
  heurekaPatientId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getIsHeurekaPatientManagedCare>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetIsHeurekaPatientManagedCareQueryOptions(practiceId, heurekaPatientId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetIsHeurekaPatientManagedCareSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getIsHeurekaPatientManagedCare>>,
  TError = unknown,
>(
  practiceId: string,
  heurekaPatientId: string,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getIsHeurekaPatientManagedCare>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetIsHeurekaPatientManagedCareQueryKey(practiceId, heurekaPatientId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getIsHeurekaPatientManagedCare>>> = ({ signal }) =>
    getIsHeurekaPatientManagedCare(practiceId, heurekaPatientId, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getIsHeurekaPatientManagedCare>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetIsHeurekaPatientManagedCareSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getIsHeurekaPatientManagedCare>>
>;
export type GetIsHeurekaPatientManagedCareSuspenseQueryError = unknown;

export function useGetIsHeurekaPatientManagedCareSuspense<
  TData = Awaited<ReturnType<typeof getIsHeurekaPatientManagedCare>>,
  TError = unknown,
>(
  practiceId: string,
  heurekaPatientId: string,
  options: {
    query: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getIsHeurekaPatientManagedCare>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetIsHeurekaPatientManagedCareSuspense<
  TData = Awaited<ReturnType<typeof getIsHeurekaPatientManagedCare>>,
  TError = unknown,
>(
  practiceId: string,
  heurekaPatientId: string,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getIsHeurekaPatientManagedCare>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetIsHeurekaPatientManagedCareSuspense<
  TData = Awaited<ReturnType<typeof getIsHeurekaPatientManagedCare>>,
  TError = unknown,
>(
  practiceId: string,
  heurekaPatientId: string,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getIsHeurekaPatientManagedCare>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetIsHeurekaPatientManagedCareSuspense<
  TData = Awaited<ReturnType<typeof getIsHeurekaPatientManagedCare>>,
  TError = unknown,
>(
  practiceId: string,
  heurekaPatientId: string,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getIsHeurekaPatientManagedCare>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetIsHeurekaPatientManagedCareSuspenseQueryOptions(practiceId, heurekaPatientId, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getMobileActivationUrl = (
  practiceId: string,
  params: GetMobileActivationUrlParams,
  options?: SecondParameter<typeof request>,
  signal?: AbortSignal,
) => {
  return request<ActivationUrl>(
    { url: `/suite/practices/${practiceId}/mobile/activation-url`, method: 'GET', params, signal },
    options,
  );
};

export const getGetMobileActivationUrlQueryKey = (practiceId?: string, params?: GetMobileActivationUrlParams) => {
  return [`/suite/practices/${practiceId}/mobile/activation-url`, ...(params ? [params] : [])] as const;
};

export const getGetMobileActivationUrlQueryOptions = <
  TData = Awaited<ReturnType<typeof getMobileActivationUrl>>,
  TError = unknown,
>(
  practiceId: string,
  params: GetMobileActivationUrlParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMobileActivationUrl>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMobileActivationUrlQueryKey(practiceId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMobileActivationUrl>>> = ({ signal }) =>
    getMobileActivationUrl(practiceId, params, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!practiceId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMobileActivationUrl>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMobileActivationUrlQueryResult = NonNullable<Awaited<ReturnType<typeof getMobileActivationUrl>>>;
export type GetMobileActivationUrlQueryError = unknown;

export function useGetMobileActivationUrl<TData = Awaited<ReturnType<typeof getMobileActivationUrl>>, TError = unknown>(
  practiceId: string,
  params: GetMobileActivationUrlParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMobileActivationUrl>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMobileActivationUrl>>,
          TError,
          Awaited<ReturnType<typeof getMobileActivationUrl>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMobileActivationUrl<TData = Awaited<ReturnType<typeof getMobileActivationUrl>>, TError = unknown>(
  practiceId: string,
  params: GetMobileActivationUrlParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMobileActivationUrl>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMobileActivationUrl>>,
          TError,
          Awaited<ReturnType<typeof getMobileActivationUrl>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMobileActivationUrl<TData = Awaited<ReturnType<typeof getMobileActivationUrl>>, TError = unknown>(
  practiceId: string,
  params: GetMobileActivationUrlParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMobileActivationUrl>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetMobileActivationUrl<TData = Awaited<ReturnType<typeof getMobileActivationUrl>>, TError = unknown>(
  practiceId: string,
  params: GetMobileActivationUrlParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMobileActivationUrl>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMobileActivationUrlQueryOptions(practiceId, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMobileActivationUrlSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getMobileActivationUrl>>,
  TError = unknown,
>(
  practiceId: string,
  params: GetMobileActivationUrlParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMobileActivationUrl>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMobileActivationUrlQueryKey(practiceId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMobileActivationUrl>>> = ({ signal }) =>
    getMobileActivationUrl(practiceId, params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getMobileActivationUrl>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMobileActivationUrlSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getMobileActivationUrl>>>;
export type GetMobileActivationUrlSuspenseQueryError = unknown;

export function useGetMobileActivationUrlSuspense<
  TData = Awaited<ReturnType<typeof getMobileActivationUrl>>,
  TError = unknown,
>(
  practiceId: string,
  params: GetMobileActivationUrlParams,
  options: {
    query: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMobileActivationUrl>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMobileActivationUrlSuspense<
  TData = Awaited<ReturnType<typeof getMobileActivationUrl>>,
  TError = unknown,
>(
  practiceId: string,
  params: GetMobileActivationUrlParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMobileActivationUrl>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMobileActivationUrlSuspense<
  TData = Awaited<ReturnType<typeof getMobileActivationUrl>>,
  TError = unknown,
>(
  practiceId: string,
  params: GetMobileActivationUrlParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMobileActivationUrl>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetMobileActivationUrlSuspense<
  TData = Awaited<ReturnType<typeof getMobileActivationUrl>>,
  TError = unknown,
>(
  practiceId: string,
  params: GetMobileActivationUrlParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMobileActivationUrl>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMobileActivationUrlSuspenseQueryOptions(practiceId, params, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getPracticeMatchingSuggestions = (
  practiceId: string,
  options?: SecondParameter<typeof request>,
  signal?: AbortSignal,
) => {
  return request<string[]>(
    { url: `/suite/practices/${practiceId}/matching-suggestions`, method: 'GET', signal },
    options,
  );
};

export const getGetPracticeMatchingSuggestionsQueryKey = (practiceId?: string) => {
  return [`/suite/practices/${practiceId}/matching-suggestions`] as const;
};

export const getGetPracticeMatchingSuggestionsQueryOptions = <
  TData = Awaited<ReturnType<typeof getPracticeMatchingSuggestions>>,
  TError = unknown,
>(
  practiceId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPracticeMatchingSuggestions>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetPracticeMatchingSuggestionsQueryKey(practiceId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPracticeMatchingSuggestions>>> = ({ signal }) =>
    getPracticeMatchingSuggestions(practiceId, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!practiceId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getPracticeMatchingSuggestions>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetPracticeMatchingSuggestionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPracticeMatchingSuggestions>>
>;
export type GetPracticeMatchingSuggestionsQueryError = unknown;

export function useGetPracticeMatchingSuggestions<
  TData = Awaited<ReturnType<typeof getPracticeMatchingSuggestions>>,
  TError = unknown,
>(
  practiceId: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPracticeMatchingSuggestions>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPracticeMatchingSuggestions>>,
          TError,
          Awaited<ReturnType<typeof getPracticeMatchingSuggestions>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetPracticeMatchingSuggestions<
  TData = Awaited<ReturnType<typeof getPracticeMatchingSuggestions>>,
  TError = unknown,
>(
  practiceId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPracticeMatchingSuggestions>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPracticeMatchingSuggestions>>,
          TError,
          Awaited<ReturnType<typeof getPracticeMatchingSuggestions>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetPracticeMatchingSuggestions<
  TData = Awaited<ReturnType<typeof getPracticeMatchingSuggestions>>,
  TError = unknown,
>(
  practiceId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPracticeMatchingSuggestions>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetPracticeMatchingSuggestions<
  TData = Awaited<ReturnType<typeof getPracticeMatchingSuggestions>>,
  TError = unknown,
>(
  practiceId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPracticeMatchingSuggestions>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetPracticeMatchingSuggestionsQueryOptions(practiceId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetPracticeMatchingSuggestionsSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getPracticeMatchingSuggestions>>,
  TError = unknown,
>(
  practiceId: string,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPracticeMatchingSuggestions>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetPracticeMatchingSuggestionsQueryKey(practiceId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPracticeMatchingSuggestions>>> = ({ signal }) =>
    getPracticeMatchingSuggestions(practiceId, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getPracticeMatchingSuggestions>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetPracticeMatchingSuggestionsSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPracticeMatchingSuggestions>>
>;
export type GetPracticeMatchingSuggestionsSuspenseQueryError = unknown;

export function useGetPracticeMatchingSuggestionsSuspense<
  TData = Awaited<ReturnType<typeof getPracticeMatchingSuggestions>>,
  TError = unknown,
>(
  practiceId: string,
  options: {
    query: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPracticeMatchingSuggestions>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetPracticeMatchingSuggestionsSuspense<
  TData = Awaited<ReturnType<typeof getPracticeMatchingSuggestions>>,
  TError = unknown,
>(
  practiceId: string,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPracticeMatchingSuggestions>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetPracticeMatchingSuggestionsSuspense<
  TData = Awaited<ReturnType<typeof getPracticeMatchingSuggestions>>,
  TError = unknown,
>(
  practiceId: string,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPracticeMatchingSuggestions>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetPracticeMatchingSuggestionsSuspense<
  TData = Awaited<ReturnType<typeof getPracticeMatchingSuggestions>>,
  TError = unknown,
>(
  practiceId: string,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPracticeMatchingSuggestions>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetPracticeMatchingSuggestionsSuspenseQueryOptions(practiceId, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getCallcentersAssignedToPractice = (
  practiceId: string,
  options?: SecondParameter<typeof request>,
  signal?: AbortSignal,
) => {
  return request<GetCallcentersAssignedToPractice200Item[]>(
    { url: `/suite/practices/${practiceId}/callcenters`, method: 'GET', signal },
    options,
  );
};

export const getGetCallcentersAssignedToPracticeQueryKey = (practiceId?: string) => {
  return [`/suite/practices/${practiceId}/callcenters`] as const;
};

export const getGetCallcentersAssignedToPracticeQueryOptions = <
  TData = Awaited<ReturnType<typeof getCallcentersAssignedToPractice>>,
  TError = unknown,
>(
  practiceId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCallcentersAssignedToPractice>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCallcentersAssignedToPracticeQueryKey(practiceId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCallcentersAssignedToPractice>>> = ({ signal }) =>
    getCallcentersAssignedToPractice(practiceId, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!practiceId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCallcentersAssignedToPractice>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetCallcentersAssignedToPracticeQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCallcentersAssignedToPractice>>
>;
export type GetCallcentersAssignedToPracticeQueryError = unknown;

export function useGetCallcentersAssignedToPractice<
  TData = Awaited<ReturnType<typeof getCallcentersAssignedToPractice>>,
  TError = unknown,
>(
  practiceId: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCallcentersAssignedToPractice>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCallcentersAssignedToPractice>>,
          TError,
          Awaited<ReturnType<typeof getCallcentersAssignedToPractice>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetCallcentersAssignedToPractice<
  TData = Awaited<ReturnType<typeof getCallcentersAssignedToPractice>>,
  TError = unknown,
>(
  practiceId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCallcentersAssignedToPractice>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCallcentersAssignedToPractice>>,
          TError,
          Awaited<ReturnType<typeof getCallcentersAssignedToPractice>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetCallcentersAssignedToPractice<
  TData = Awaited<ReturnType<typeof getCallcentersAssignedToPractice>>,
  TError = unknown,
>(
  practiceId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCallcentersAssignedToPractice>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetCallcentersAssignedToPractice<
  TData = Awaited<ReturnType<typeof getCallcentersAssignedToPractice>>,
  TError = unknown,
>(
  practiceId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCallcentersAssignedToPractice>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetCallcentersAssignedToPracticeQueryOptions(practiceId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetCallcentersAssignedToPracticeSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getCallcentersAssignedToPractice>>,
  TError = unknown,
>(
  practiceId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCallcentersAssignedToPractice>>, TError, TData>
    >;
    request?: SecondParameter<typeof request>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCallcentersAssignedToPracticeQueryKey(practiceId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCallcentersAssignedToPractice>>> = ({ signal }) =>
    getCallcentersAssignedToPractice(practiceId, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getCallcentersAssignedToPractice>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetCallcentersAssignedToPracticeSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCallcentersAssignedToPractice>>
>;
export type GetCallcentersAssignedToPracticeSuspenseQueryError = unknown;

export function useGetCallcentersAssignedToPracticeSuspense<
  TData = Awaited<ReturnType<typeof getCallcentersAssignedToPractice>>,
  TError = unknown,
>(
  practiceId: string,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCallcentersAssignedToPractice>>, TError, TData>
    >;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetCallcentersAssignedToPracticeSuspense<
  TData = Awaited<ReturnType<typeof getCallcentersAssignedToPractice>>,
  TError = unknown,
>(
  practiceId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCallcentersAssignedToPractice>>, TError, TData>
    >;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetCallcentersAssignedToPracticeSuspense<
  TData = Awaited<ReturnType<typeof getCallcentersAssignedToPractice>>,
  TError = unknown,
>(
  practiceId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCallcentersAssignedToPractice>>, TError, TData>
    >;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetCallcentersAssignedToPracticeSuspense<
  TData = Awaited<ReturnType<typeof getCallcentersAssignedToPractice>>,
  TError = unknown,
>(
  practiceId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCallcentersAssignedToPractice>>, TError, TData>
    >;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetCallcentersAssignedToPracticeSuspenseQueryOptions(practiceId, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getPatientsByPractice = (
  params: GetPatientsByPracticeParams,
  options?: SecondParameter<typeof request>,
  signal?: AbortSignal,
) => {
  return request<PatientDto[]>({ url: `/suite/patients`, method: 'GET', params, signal }, options);
};

export const getGetPatientsByPracticeQueryKey = (params?: GetPatientsByPracticeParams) => {
  return [`/suite/patients`, ...(params ? [params] : [])] as const;
};

export const getGetPatientsByPracticeQueryOptions = <
  TData = Awaited<ReturnType<typeof getPatientsByPractice>>,
  TError = unknown,
>(
  params: GetPatientsByPracticeParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientsByPractice>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetPatientsByPracticeQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPatientsByPractice>>> = ({ signal }) =>
    getPatientsByPractice(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getPatientsByPractice>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetPatientsByPracticeQueryResult = NonNullable<Awaited<ReturnType<typeof getPatientsByPractice>>>;
export type GetPatientsByPracticeQueryError = unknown;

export function useGetPatientsByPractice<TData = Awaited<ReturnType<typeof getPatientsByPractice>>, TError = unknown>(
  params: GetPatientsByPracticeParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientsByPractice>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPatientsByPractice>>,
          TError,
          Awaited<ReturnType<typeof getPatientsByPractice>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetPatientsByPractice<TData = Awaited<ReturnType<typeof getPatientsByPractice>>, TError = unknown>(
  params: GetPatientsByPracticeParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientsByPractice>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPatientsByPractice>>,
          TError,
          Awaited<ReturnType<typeof getPatientsByPractice>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetPatientsByPractice<TData = Awaited<ReturnType<typeof getPatientsByPractice>>, TError = unknown>(
  params: GetPatientsByPracticeParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientsByPractice>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetPatientsByPractice<TData = Awaited<ReturnType<typeof getPatientsByPractice>>, TError = unknown>(
  params: GetPatientsByPracticeParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientsByPractice>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetPatientsByPracticeQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetPatientsByPracticeSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getPatientsByPractice>>,
  TError = unknown,
>(
  params: GetPatientsByPracticeParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientsByPractice>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetPatientsByPracticeQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPatientsByPractice>>> = ({ signal }) =>
    getPatientsByPractice(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getPatientsByPractice>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetPatientsByPracticeSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getPatientsByPractice>>>;
export type GetPatientsByPracticeSuspenseQueryError = unknown;

export function useGetPatientsByPracticeSuspense<
  TData = Awaited<ReturnType<typeof getPatientsByPractice>>,
  TError = unknown,
>(
  params: GetPatientsByPracticeParams,
  options: {
    query: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientsByPractice>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetPatientsByPracticeSuspense<
  TData = Awaited<ReturnType<typeof getPatientsByPractice>>,
  TError = unknown,
>(
  params: GetPatientsByPracticeParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientsByPractice>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetPatientsByPracticeSuspense<
  TData = Awaited<ReturnType<typeof getPatientsByPractice>>,
  TError = unknown,
>(
  params: GetPatientsByPracticeParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientsByPractice>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetPatientsByPracticeSuspense<
  TData = Awaited<ReturnType<typeof getPatientsByPractice>>,
  TError = unknown,
>(
  params: GetPatientsByPracticeParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientsByPractice>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetPatientsByPracticeSuspenseQueryOptions(params, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getPatientDetails = (
  patientId: string,
  options?: SecondParameter<typeof request>,
  signal?: AbortSignal,
) => {
  return request<PatientDto>({ url: `/suite/patients/${patientId}`, method: 'GET', signal }, options);
};

export const getGetPatientDetailsQueryKey = (patientId?: string) => {
  return [`/suite/patients/${patientId}`] as const;
};

export const getGetPatientDetailsQueryOptions = <
  TData = Awaited<ReturnType<typeof getPatientDetails>>,
  TError = unknown,
>(
  patientId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientDetails>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetPatientDetailsQueryKey(patientId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPatientDetails>>> = ({ signal }) =>
    getPatientDetails(patientId, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!patientId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getPatientDetails>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetPatientDetailsQueryResult = NonNullable<Awaited<ReturnType<typeof getPatientDetails>>>;
export type GetPatientDetailsQueryError = unknown;

export function useGetPatientDetails<TData = Awaited<ReturnType<typeof getPatientDetails>>, TError = unknown>(
  patientId: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientDetails>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPatientDetails>>,
          TError,
          Awaited<ReturnType<typeof getPatientDetails>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetPatientDetails<TData = Awaited<ReturnType<typeof getPatientDetails>>, TError = unknown>(
  patientId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientDetails>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPatientDetails>>,
          TError,
          Awaited<ReturnType<typeof getPatientDetails>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetPatientDetails<TData = Awaited<ReturnType<typeof getPatientDetails>>, TError = unknown>(
  patientId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientDetails>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetPatientDetails<TData = Awaited<ReturnType<typeof getPatientDetails>>, TError = unknown>(
  patientId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientDetails>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetPatientDetailsQueryOptions(patientId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetPatientDetailsSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getPatientDetails>>,
  TError = unknown,
>(
  patientId: string,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientDetails>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetPatientDetailsQueryKey(patientId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPatientDetails>>> = ({ signal }) =>
    getPatientDetails(patientId, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getPatientDetails>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetPatientDetailsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getPatientDetails>>>;
export type GetPatientDetailsSuspenseQueryError = unknown;

export function useGetPatientDetailsSuspense<TData = Awaited<ReturnType<typeof getPatientDetails>>, TError = unknown>(
  patientId: string,
  options: {
    query: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientDetails>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetPatientDetailsSuspense<TData = Awaited<ReturnType<typeof getPatientDetails>>, TError = unknown>(
  patientId: string,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientDetails>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetPatientDetailsSuspense<TData = Awaited<ReturnType<typeof getPatientDetails>>, TError = unknown>(
  patientId: string,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientDetails>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetPatientDetailsSuspense<TData = Awaited<ReturnType<typeof getPatientDetails>>, TError = unknown>(
  patientId: string,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientDetails>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetPatientDetailsSuspenseQueryOptions(patientId, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getPatientMatchingSuggestions = (
  patientId: string,
  options?: SecondParameter<typeof request>,
  signal?: AbortSignal,
) => {
  return request<HeurekaPatientSuggestionDto[]>(
    { url: `/suite/patients/${patientId}/matching-suggestions`, method: 'GET', signal },
    options,
  );
};

export const getGetPatientMatchingSuggestionsQueryKey = (patientId?: string) => {
  return [`/suite/patients/${patientId}/matching-suggestions`] as const;
};

export const getGetPatientMatchingSuggestionsQueryOptions = <
  TData = Awaited<ReturnType<typeof getPatientMatchingSuggestions>>,
  TError = unknown,
>(
  patientId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientMatchingSuggestions>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetPatientMatchingSuggestionsQueryKey(patientId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPatientMatchingSuggestions>>> = ({ signal }) =>
    getPatientMatchingSuggestions(patientId, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!patientId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getPatientMatchingSuggestions>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetPatientMatchingSuggestionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPatientMatchingSuggestions>>
>;
export type GetPatientMatchingSuggestionsQueryError = unknown;

export function useGetPatientMatchingSuggestions<
  TData = Awaited<ReturnType<typeof getPatientMatchingSuggestions>>,
  TError = unknown,
>(
  patientId: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientMatchingSuggestions>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPatientMatchingSuggestions>>,
          TError,
          Awaited<ReturnType<typeof getPatientMatchingSuggestions>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetPatientMatchingSuggestions<
  TData = Awaited<ReturnType<typeof getPatientMatchingSuggestions>>,
  TError = unknown,
>(
  patientId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientMatchingSuggestions>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPatientMatchingSuggestions>>,
          TError,
          Awaited<ReturnType<typeof getPatientMatchingSuggestions>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetPatientMatchingSuggestions<
  TData = Awaited<ReturnType<typeof getPatientMatchingSuggestions>>,
  TError = unknown,
>(
  patientId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientMatchingSuggestions>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetPatientMatchingSuggestions<
  TData = Awaited<ReturnType<typeof getPatientMatchingSuggestions>>,
  TError = unknown,
>(
  patientId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientMatchingSuggestions>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetPatientMatchingSuggestionsQueryOptions(patientId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetPatientMatchingSuggestionsSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getPatientMatchingSuggestions>>,
  TError = unknown,
>(
  patientId: string,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientMatchingSuggestions>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetPatientMatchingSuggestionsQueryKey(patientId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPatientMatchingSuggestions>>> = ({ signal }) =>
    getPatientMatchingSuggestions(patientId, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getPatientMatchingSuggestions>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetPatientMatchingSuggestionsSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPatientMatchingSuggestions>>
>;
export type GetPatientMatchingSuggestionsSuspenseQueryError = unknown;

export function useGetPatientMatchingSuggestionsSuspense<
  TData = Awaited<ReturnType<typeof getPatientMatchingSuggestions>>,
  TError = unknown,
>(
  patientId: string,
  options: {
    query: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientMatchingSuggestions>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetPatientMatchingSuggestionsSuspense<
  TData = Awaited<ReturnType<typeof getPatientMatchingSuggestions>>,
  TError = unknown,
>(
  patientId: string,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientMatchingSuggestions>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetPatientMatchingSuggestionsSuspense<
  TData = Awaited<ReturnType<typeof getPatientMatchingSuggestions>>,
  TError = unknown,
>(
  patientId: string,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientMatchingSuggestions>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetPatientMatchingSuggestionsSuspense<
  TData = Awaited<ReturnType<typeof getPatientMatchingSuggestions>>,
  TError = unknown,
>(
  patientId: string,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientMatchingSuggestions>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetPatientMatchingSuggestionsSuspenseQueryOptions(patientId, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getHeurekaResourceAvailability = (
  practiceId: string,
  options?: SecondParameter<typeof request>,
  signal?: AbortSignal,
) => {
  return request<HeurekaResourceAvailabilityDto>(
    { url: `/suite/heureka/practices/${practiceId}/resource-availability`, method: 'GET', signal },
    options,
  );
};

export const getGetHeurekaResourceAvailabilityQueryKey = (practiceId?: string) => {
  return [`/suite/heureka/practices/${practiceId}/resource-availability`] as const;
};

export const getGetHeurekaResourceAvailabilityQueryOptions = <
  TData = Awaited<ReturnType<typeof getHeurekaResourceAvailability>>,
  TError = unknown,
>(
  practiceId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getHeurekaResourceAvailability>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetHeurekaResourceAvailabilityQueryKey(practiceId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getHeurekaResourceAvailability>>> = ({ signal }) =>
    getHeurekaResourceAvailability(practiceId, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!practiceId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getHeurekaResourceAvailability>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetHeurekaResourceAvailabilityQueryResult = NonNullable<
  Awaited<ReturnType<typeof getHeurekaResourceAvailability>>
>;
export type GetHeurekaResourceAvailabilityQueryError = unknown;

export function useGetHeurekaResourceAvailability<
  TData = Awaited<ReturnType<typeof getHeurekaResourceAvailability>>,
  TError = unknown,
>(
  practiceId: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getHeurekaResourceAvailability>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getHeurekaResourceAvailability>>,
          TError,
          Awaited<ReturnType<typeof getHeurekaResourceAvailability>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetHeurekaResourceAvailability<
  TData = Awaited<ReturnType<typeof getHeurekaResourceAvailability>>,
  TError = unknown,
>(
  practiceId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getHeurekaResourceAvailability>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getHeurekaResourceAvailability>>,
          TError,
          Awaited<ReturnType<typeof getHeurekaResourceAvailability>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetHeurekaResourceAvailability<
  TData = Awaited<ReturnType<typeof getHeurekaResourceAvailability>>,
  TError = unknown,
>(
  practiceId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getHeurekaResourceAvailability>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetHeurekaResourceAvailability<
  TData = Awaited<ReturnType<typeof getHeurekaResourceAvailability>>,
  TError = unknown,
>(
  practiceId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getHeurekaResourceAvailability>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetHeurekaResourceAvailabilityQueryOptions(practiceId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetHeurekaResourceAvailabilitySuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getHeurekaResourceAvailability>>,
  TError = unknown,
>(
  practiceId: string,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getHeurekaResourceAvailability>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetHeurekaResourceAvailabilityQueryKey(practiceId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getHeurekaResourceAvailability>>> = ({ signal }) =>
    getHeurekaResourceAvailability(practiceId, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getHeurekaResourceAvailability>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetHeurekaResourceAvailabilitySuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getHeurekaResourceAvailability>>
>;
export type GetHeurekaResourceAvailabilitySuspenseQueryError = unknown;

export function useGetHeurekaResourceAvailabilitySuspense<
  TData = Awaited<ReturnType<typeof getHeurekaResourceAvailability>>,
  TError = unknown,
>(
  practiceId: string,
  options: {
    query: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getHeurekaResourceAvailability>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetHeurekaResourceAvailabilitySuspense<
  TData = Awaited<ReturnType<typeof getHeurekaResourceAvailability>>,
  TError = unknown,
>(
  practiceId: string,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getHeurekaResourceAvailability>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetHeurekaResourceAvailabilitySuspense<
  TData = Awaited<ReturnType<typeof getHeurekaResourceAvailability>>,
  TError = unknown,
>(
  practiceId: string,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getHeurekaResourceAvailability>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetHeurekaResourceAvailabilitySuspense<
  TData = Awaited<ReturnType<typeof getHeurekaResourceAvailability>>,
  TError = unknown,
>(
  practiceId: string,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getHeurekaResourceAvailability>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetHeurekaResourceAvailabilitySuspenseQueryOptions(practiceId, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getHeurekaPatientsByContent = (
  practiceId: string,
  params: GetHeurekaPatientsByContentParams,
  options?: SecondParameter<typeof request>,
  signal?: AbortSignal,
) => {
  return request<HeurekaPatientDto[]>(
    { url: `/suite/heureka/practices/${practiceId}/patients/search`, method: 'GET', params, signal },
    options,
  );
};

export const getGetHeurekaPatientsByContentQueryKey = (
  practiceId?: string,
  params?: GetHeurekaPatientsByContentParams,
) => {
  return [`/suite/heureka/practices/${practiceId}/patients/search`, ...(params ? [params] : [])] as const;
};

export const getGetHeurekaPatientsByContentQueryOptions = <
  TData = Awaited<ReturnType<typeof getHeurekaPatientsByContent>>,
  TError = unknown,
>(
  practiceId: string,
  params: GetHeurekaPatientsByContentParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getHeurekaPatientsByContent>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetHeurekaPatientsByContentQueryKey(practiceId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getHeurekaPatientsByContent>>> = ({ signal }) =>
    getHeurekaPatientsByContent(practiceId, params, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!practiceId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getHeurekaPatientsByContent>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetHeurekaPatientsByContentQueryResult = NonNullable<
  Awaited<ReturnType<typeof getHeurekaPatientsByContent>>
>;
export type GetHeurekaPatientsByContentQueryError = unknown;

export function useGetHeurekaPatientsByContent<
  TData = Awaited<ReturnType<typeof getHeurekaPatientsByContent>>,
  TError = unknown,
>(
  practiceId: string,
  params: GetHeurekaPatientsByContentParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getHeurekaPatientsByContent>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getHeurekaPatientsByContent>>,
          TError,
          Awaited<ReturnType<typeof getHeurekaPatientsByContent>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetHeurekaPatientsByContent<
  TData = Awaited<ReturnType<typeof getHeurekaPatientsByContent>>,
  TError = unknown,
>(
  practiceId: string,
  params: GetHeurekaPatientsByContentParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getHeurekaPatientsByContent>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getHeurekaPatientsByContent>>,
          TError,
          Awaited<ReturnType<typeof getHeurekaPatientsByContent>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetHeurekaPatientsByContent<
  TData = Awaited<ReturnType<typeof getHeurekaPatientsByContent>>,
  TError = unknown,
>(
  practiceId: string,
  params: GetHeurekaPatientsByContentParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getHeurekaPatientsByContent>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetHeurekaPatientsByContent<
  TData = Awaited<ReturnType<typeof getHeurekaPatientsByContent>>,
  TError = unknown,
>(
  practiceId: string,
  params: GetHeurekaPatientsByContentParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getHeurekaPatientsByContent>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetHeurekaPatientsByContentQueryOptions(practiceId, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetHeurekaPatientsByContentSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getHeurekaPatientsByContent>>,
  TError = unknown,
>(
  practiceId: string,
  params: GetHeurekaPatientsByContentParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getHeurekaPatientsByContent>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetHeurekaPatientsByContentQueryKey(practiceId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getHeurekaPatientsByContent>>> = ({ signal }) =>
    getHeurekaPatientsByContent(practiceId, params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getHeurekaPatientsByContent>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetHeurekaPatientsByContentSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getHeurekaPatientsByContent>>
>;
export type GetHeurekaPatientsByContentSuspenseQueryError = unknown;

export function useGetHeurekaPatientsByContentSuspense<
  TData = Awaited<ReturnType<typeof getHeurekaPatientsByContent>>,
  TError = unknown,
>(
  practiceId: string,
  params: GetHeurekaPatientsByContentParams,
  options: {
    query: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getHeurekaPatientsByContent>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetHeurekaPatientsByContentSuspense<
  TData = Awaited<ReturnType<typeof getHeurekaPatientsByContent>>,
  TError = unknown,
>(
  practiceId: string,
  params: GetHeurekaPatientsByContentParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getHeurekaPatientsByContent>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetHeurekaPatientsByContentSuspense<
  TData = Awaited<ReturnType<typeof getHeurekaPatientsByContent>>,
  TError = unknown,
>(
  practiceId: string,
  params: GetHeurekaPatientsByContentParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getHeurekaPatientsByContent>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetHeurekaPatientsByContentSuspense<
  TData = Awaited<ReturnType<typeof getHeurekaPatientsByContent>>,
  TError = unknown,
>(
  practiceId: string,
  params: GetHeurekaPatientsByContentParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getHeurekaPatientsByContent>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetHeurekaPatientsByContentSuspenseQueryOptions(practiceId, params, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getHeurekaPatientForManualMatching = (
  practiceId: string,
  params: GetHeurekaPatientForManualMatchingParams,
  options?: SecondParameter<typeof request>,
  signal?: AbortSignal,
) => {
  return request<PatientForManualMatchingDto>(
    { url: `/suite/heureka/practices/${practiceId}/patients/manual-matching`, method: 'GET', params, signal },
    options,
  );
};

export const getGetHeurekaPatientForManualMatchingQueryKey = (
  practiceId?: string,
  params?: GetHeurekaPatientForManualMatchingParams,
) => {
  return [`/suite/heureka/practices/${practiceId}/patients/manual-matching`, ...(params ? [params] : [])] as const;
};

export const getGetHeurekaPatientForManualMatchingQueryOptions = <
  TData = Awaited<ReturnType<typeof getHeurekaPatientForManualMatching>>,
  TError = unknown,
>(
  practiceId: string,
  params: GetHeurekaPatientForManualMatchingParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getHeurekaPatientForManualMatching>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetHeurekaPatientForManualMatchingQueryKey(practiceId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getHeurekaPatientForManualMatching>>> = ({ signal }) =>
    getHeurekaPatientForManualMatching(practiceId, params, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!practiceId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getHeurekaPatientForManualMatching>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetHeurekaPatientForManualMatchingQueryResult = NonNullable<
  Awaited<ReturnType<typeof getHeurekaPatientForManualMatching>>
>;
export type GetHeurekaPatientForManualMatchingQueryError = unknown;

export function useGetHeurekaPatientForManualMatching<
  TData = Awaited<ReturnType<typeof getHeurekaPatientForManualMatching>>,
  TError = unknown,
>(
  practiceId: string,
  params: GetHeurekaPatientForManualMatchingParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getHeurekaPatientForManualMatching>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getHeurekaPatientForManualMatching>>,
          TError,
          Awaited<ReturnType<typeof getHeurekaPatientForManualMatching>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetHeurekaPatientForManualMatching<
  TData = Awaited<ReturnType<typeof getHeurekaPatientForManualMatching>>,
  TError = unknown,
>(
  practiceId: string,
  params: GetHeurekaPatientForManualMatchingParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getHeurekaPatientForManualMatching>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getHeurekaPatientForManualMatching>>,
          TError,
          Awaited<ReturnType<typeof getHeurekaPatientForManualMatching>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetHeurekaPatientForManualMatching<
  TData = Awaited<ReturnType<typeof getHeurekaPatientForManualMatching>>,
  TError = unknown,
>(
  practiceId: string,
  params: GetHeurekaPatientForManualMatchingParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getHeurekaPatientForManualMatching>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetHeurekaPatientForManualMatching<
  TData = Awaited<ReturnType<typeof getHeurekaPatientForManualMatching>>,
  TError = unknown,
>(
  practiceId: string,
  params: GetHeurekaPatientForManualMatchingParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getHeurekaPatientForManualMatching>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetHeurekaPatientForManualMatchingQueryOptions(practiceId, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetHeurekaPatientForManualMatchingSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getHeurekaPatientForManualMatching>>,
  TError = unknown,
>(
  practiceId: string,
  params: GetHeurekaPatientForManualMatchingParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getHeurekaPatientForManualMatching>>, TError, TData>
    >;
    request?: SecondParameter<typeof request>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetHeurekaPatientForManualMatchingQueryKey(practiceId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getHeurekaPatientForManualMatching>>> = ({ signal }) =>
    getHeurekaPatientForManualMatching(practiceId, params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getHeurekaPatientForManualMatching>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetHeurekaPatientForManualMatchingSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getHeurekaPatientForManualMatching>>
>;
export type GetHeurekaPatientForManualMatchingSuspenseQueryError = unknown;

export function useGetHeurekaPatientForManualMatchingSuspense<
  TData = Awaited<ReturnType<typeof getHeurekaPatientForManualMatching>>,
  TError = unknown,
>(
  practiceId: string,
  params: GetHeurekaPatientForManualMatchingParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getHeurekaPatientForManualMatching>>, TError, TData>
    >;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetHeurekaPatientForManualMatchingSuspense<
  TData = Awaited<ReturnType<typeof getHeurekaPatientForManualMatching>>,
  TError = unknown,
>(
  practiceId: string,
  params: GetHeurekaPatientForManualMatchingParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getHeurekaPatientForManualMatching>>, TError, TData>
    >;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetHeurekaPatientForManualMatchingSuspense<
  TData = Awaited<ReturnType<typeof getHeurekaPatientForManualMatching>>,
  TError = unknown,
>(
  practiceId: string,
  params: GetHeurekaPatientForManualMatchingParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getHeurekaPatientForManualMatching>>, TError, TData>
    >;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetHeurekaPatientForManualMatchingSuspense<
  TData = Awaited<ReturnType<typeof getHeurekaPatientForManualMatching>>,
  TError = unknown,
>(
  practiceId: string,
  params: GetHeurekaPatientForManualMatchingParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getHeurekaPatientForManualMatching>>, TError, TData>
    >;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetHeurekaPatientForManualMatchingSuspenseQueryOptions(practiceId, params, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getHeurekaPatientMobilePhoneNumbersById = (
  practiceId: string,
  heurekaPatientId: string,
  options?: SecondParameter<typeof request>,
  signal?: AbortSignal,
) => {
  return request<MobileVerificationPhoneNumberDto[]>(
    {
      url: `/suite/heureka/practices/${practiceId}/patients/heureka/${heurekaPatientId}/mobile-numbers`,
      method: 'GET',
      signal,
    },
    options,
  );
};

export const getGetHeurekaPatientMobilePhoneNumbersByIdQueryKey = (practiceId?: string, heurekaPatientId?: string) => {
  return [`/suite/heureka/practices/${practiceId}/patients/heureka/${heurekaPatientId}/mobile-numbers`] as const;
};

export const getGetHeurekaPatientMobilePhoneNumbersByIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getHeurekaPatientMobilePhoneNumbersById>>,
  TError = unknown,
>(
  practiceId: string,
  heurekaPatientId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getHeurekaPatientMobilePhoneNumbersById>>, TError, TData>
    >;
    request?: SecondParameter<typeof request>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetHeurekaPatientMobilePhoneNumbersByIdQueryKey(practiceId, heurekaPatientId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getHeurekaPatientMobilePhoneNumbersById>>> = ({ signal }) =>
    getHeurekaPatientMobilePhoneNumbersById(practiceId, heurekaPatientId, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!(practiceId && heurekaPatientId), ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getHeurekaPatientMobilePhoneNumbersById>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetHeurekaPatientMobilePhoneNumbersByIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getHeurekaPatientMobilePhoneNumbersById>>
>;
export type GetHeurekaPatientMobilePhoneNumbersByIdQueryError = unknown;

export function useGetHeurekaPatientMobilePhoneNumbersById<
  TData = Awaited<ReturnType<typeof getHeurekaPatientMobilePhoneNumbersById>>,
  TError = unknown,
>(
  practiceId: string,
  heurekaPatientId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getHeurekaPatientMobilePhoneNumbersById>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getHeurekaPatientMobilePhoneNumbersById>>,
          TError,
          Awaited<ReturnType<typeof getHeurekaPatientMobilePhoneNumbersById>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetHeurekaPatientMobilePhoneNumbersById<
  TData = Awaited<ReturnType<typeof getHeurekaPatientMobilePhoneNumbersById>>,
  TError = unknown,
>(
  practiceId: string,
  heurekaPatientId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getHeurekaPatientMobilePhoneNumbersById>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getHeurekaPatientMobilePhoneNumbersById>>,
          TError,
          Awaited<ReturnType<typeof getHeurekaPatientMobilePhoneNumbersById>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetHeurekaPatientMobilePhoneNumbersById<
  TData = Awaited<ReturnType<typeof getHeurekaPatientMobilePhoneNumbersById>>,
  TError = unknown,
>(
  practiceId: string,
  heurekaPatientId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getHeurekaPatientMobilePhoneNumbersById>>, TError, TData>
    >;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetHeurekaPatientMobilePhoneNumbersById<
  TData = Awaited<ReturnType<typeof getHeurekaPatientMobilePhoneNumbersById>>,
  TError = unknown,
>(
  practiceId: string,
  heurekaPatientId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getHeurekaPatientMobilePhoneNumbersById>>, TError, TData>
    >;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetHeurekaPatientMobilePhoneNumbersByIdQueryOptions(practiceId, heurekaPatientId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetHeurekaPatientMobilePhoneNumbersByIdSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getHeurekaPatientMobilePhoneNumbersById>>,
  TError = unknown,
>(
  practiceId: string,
  heurekaPatientId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getHeurekaPatientMobilePhoneNumbersById>>, TError, TData>
    >;
    request?: SecondParameter<typeof request>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetHeurekaPatientMobilePhoneNumbersByIdQueryKey(practiceId, heurekaPatientId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getHeurekaPatientMobilePhoneNumbersById>>> = ({ signal }) =>
    getHeurekaPatientMobilePhoneNumbersById(practiceId, heurekaPatientId, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getHeurekaPatientMobilePhoneNumbersById>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetHeurekaPatientMobilePhoneNumbersByIdSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getHeurekaPatientMobilePhoneNumbersById>>
>;
export type GetHeurekaPatientMobilePhoneNumbersByIdSuspenseQueryError = unknown;

export function useGetHeurekaPatientMobilePhoneNumbersByIdSuspense<
  TData = Awaited<ReturnType<typeof getHeurekaPatientMobilePhoneNumbersById>>,
  TError = unknown,
>(
  practiceId: string,
  heurekaPatientId: string,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getHeurekaPatientMobilePhoneNumbersById>>, TError, TData>
    >;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetHeurekaPatientMobilePhoneNumbersByIdSuspense<
  TData = Awaited<ReturnType<typeof getHeurekaPatientMobilePhoneNumbersById>>,
  TError = unknown,
>(
  practiceId: string,
  heurekaPatientId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getHeurekaPatientMobilePhoneNumbersById>>, TError, TData>
    >;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetHeurekaPatientMobilePhoneNumbersByIdSuspense<
  TData = Awaited<ReturnType<typeof getHeurekaPatientMobilePhoneNumbersById>>,
  TError = unknown,
>(
  practiceId: string,
  heurekaPatientId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getHeurekaPatientMobilePhoneNumbersById>>, TError, TData>
    >;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetHeurekaPatientMobilePhoneNumbersByIdSuspense<
  TData = Awaited<ReturnType<typeof getHeurekaPatientMobilePhoneNumbersById>>,
  TError = unknown,
>(
  practiceId: string,
  heurekaPatientId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getHeurekaPatientMobilePhoneNumbersById>>, TError, TData>
    >;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetHeurekaPatientMobilePhoneNumbersByIdSuspenseQueryOptions(
    practiceId,
    heurekaPatientId,
    options,
  );

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const isHeurekaConnected = (
  practiceId: string,
  options?: SecondParameter<typeof request>,
  signal?: AbortSignal,
) => {
  return request<HeurekaDto>(
    { url: `/suite/heureka/practices/${practiceId}/connectionstate`, method: 'GET', signal },
    options,
  );
};

export const getIsHeurekaConnectedQueryKey = (practiceId?: string) => {
  return [`/suite/heureka/practices/${practiceId}/connectionstate`] as const;
};

export const getIsHeurekaConnectedQueryOptions = <
  TData = Awaited<ReturnType<typeof isHeurekaConnected>>,
  TError = unknown,
>(
  practiceId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof isHeurekaConnected>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getIsHeurekaConnectedQueryKey(practiceId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof isHeurekaConnected>>> = ({ signal }) =>
    isHeurekaConnected(practiceId, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!practiceId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof isHeurekaConnected>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type IsHeurekaConnectedQueryResult = NonNullable<Awaited<ReturnType<typeof isHeurekaConnected>>>;
export type IsHeurekaConnectedQueryError = unknown;

export function useIsHeurekaConnected<TData = Awaited<ReturnType<typeof isHeurekaConnected>>, TError = unknown>(
  practiceId: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof isHeurekaConnected>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof isHeurekaConnected>>,
          TError,
          Awaited<ReturnType<typeof isHeurekaConnected>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useIsHeurekaConnected<TData = Awaited<ReturnType<typeof isHeurekaConnected>>, TError = unknown>(
  practiceId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof isHeurekaConnected>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof isHeurekaConnected>>,
          TError,
          Awaited<ReturnType<typeof isHeurekaConnected>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useIsHeurekaConnected<TData = Awaited<ReturnType<typeof isHeurekaConnected>>, TError = unknown>(
  practiceId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof isHeurekaConnected>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useIsHeurekaConnected<TData = Awaited<ReturnType<typeof isHeurekaConnected>>, TError = unknown>(
  practiceId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof isHeurekaConnected>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getIsHeurekaConnectedQueryOptions(practiceId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getIsHeurekaConnectedSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof isHeurekaConnected>>,
  TError = unknown,
>(
  practiceId: string,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof isHeurekaConnected>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getIsHeurekaConnectedQueryKey(practiceId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof isHeurekaConnected>>> = ({ signal }) =>
    isHeurekaConnected(practiceId, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof isHeurekaConnected>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type IsHeurekaConnectedSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof isHeurekaConnected>>>;
export type IsHeurekaConnectedSuspenseQueryError = unknown;

export function useIsHeurekaConnectedSuspense<TData = Awaited<ReturnType<typeof isHeurekaConnected>>, TError = unknown>(
  practiceId: string,
  options: {
    query: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof isHeurekaConnected>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useIsHeurekaConnectedSuspense<TData = Awaited<ReturnType<typeof isHeurekaConnected>>, TError = unknown>(
  practiceId: string,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof isHeurekaConnected>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useIsHeurekaConnectedSuspense<TData = Awaited<ReturnType<typeof isHeurekaConnected>>, TError = unknown>(
  practiceId: string,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof isHeurekaConnected>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useIsHeurekaConnectedSuspense<TData = Awaited<ReturnType<typeof isHeurekaConnected>>, TError = unknown>(
  practiceId: string,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof isHeurekaConnected>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getIsHeurekaConnectedSuspenseQueryOptions(practiceId, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getHeurekaPatient = (
  patientId: string,
  options?: SecondParameter<typeof request>,
  signal?: AbortSignal,
) => {
  return request<HeurekaPatientDetailsWithPracticeAndInsuranceDto>(
    { url: `/suite/heureka/patients/${patientId}`, method: 'GET', signal },
    options,
  );
};

export const getGetHeurekaPatientQueryKey = (patientId?: string) => {
  return [`/suite/heureka/patients/${patientId}`] as const;
};

export const getGetHeurekaPatientQueryOptions = <
  TData = Awaited<ReturnType<typeof getHeurekaPatient>>,
  TError = unknown,
>(
  patientId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getHeurekaPatient>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetHeurekaPatientQueryKey(patientId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getHeurekaPatient>>> = ({ signal }) =>
    getHeurekaPatient(patientId, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!patientId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getHeurekaPatient>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetHeurekaPatientQueryResult = NonNullable<Awaited<ReturnType<typeof getHeurekaPatient>>>;
export type GetHeurekaPatientQueryError = unknown;

export function useGetHeurekaPatient<TData = Awaited<ReturnType<typeof getHeurekaPatient>>, TError = unknown>(
  patientId: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getHeurekaPatient>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getHeurekaPatient>>,
          TError,
          Awaited<ReturnType<typeof getHeurekaPatient>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetHeurekaPatient<TData = Awaited<ReturnType<typeof getHeurekaPatient>>, TError = unknown>(
  patientId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getHeurekaPatient>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getHeurekaPatient>>,
          TError,
          Awaited<ReturnType<typeof getHeurekaPatient>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetHeurekaPatient<TData = Awaited<ReturnType<typeof getHeurekaPatient>>, TError = unknown>(
  patientId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getHeurekaPatient>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetHeurekaPatient<TData = Awaited<ReturnType<typeof getHeurekaPatient>>, TError = unknown>(
  patientId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getHeurekaPatient>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetHeurekaPatientQueryOptions(patientId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetHeurekaPatientSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getHeurekaPatient>>,
  TError = unknown,
>(
  patientId: string,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getHeurekaPatient>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetHeurekaPatientQueryKey(patientId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getHeurekaPatient>>> = ({ signal }) =>
    getHeurekaPatient(patientId, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getHeurekaPatient>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetHeurekaPatientSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getHeurekaPatient>>>;
export type GetHeurekaPatientSuspenseQueryError = unknown;

export function useGetHeurekaPatientSuspense<TData = Awaited<ReturnType<typeof getHeurekaPatient>>, TError = unknown>(
  patientId: string,
  options: {
    query: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getHeurekaPatient>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetHeurekaPatientSuspense<TData = Awaited<ReturnType<typeof getHeurekaPatient>>, TError = unknown>(
  patientId: string,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getHeurekaPatient>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetHeurekaPatientSuspense<TData = Awaited<ReturnType<typeof getHeurekaPatient>>, TError = unknown>(
  patientId: string,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getHeurekaPatient>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetHeurekaPatientSuspense<TData = Awaited<ReturnType<typeof getHeurekaPatient>>, TError = unknown>(
  patientId: string,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getHeurekaPatient>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetHeurekaPatientSuspenseQueryOptions(patientId, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getActiveEmergencyServiceForEmergencyCircle = (
  params: GetActiveEmergencyServiceForEmergencyCircleParams,
  options?: SecondParameter<typeof request>,
  signal?: AbortSignal,
) => {
  return request<GetActiveEmergencyServiceForEmergencyCircle200>(
    { url: `/suite/emergency-service`, method: 'GET', params, signal },
    options,
  );
};

export const getGetActiveEmergencyServiceForEmergencyCircleQueryKey = (
  params?: GetActiveEmergencyServiceForEmergencyCircleParams,
) => {
  return [`/suite/emergency-service`, ...(params ? [params] : [])] as const;
};

export const getGetActiveEmergencyServiceForEmergencyCircleQueryOptions = <
  TData = Awaited<ReturnType<typeof getActiveEmergencyServiceForEmergencyCircle>>,
  TError = unknown,
>(
  params: GetActiveEmergencyServiceForEmergencyCircleParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getActiveEmergencyServiceForEmergencyCircle>>, TError, TData>
    >;
    request?: SecondParameter<typeof request>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetActiveEmergencyServiceForEmergencyCircleQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getActiveEmergencyServiceForEmergencyCircle>>> = ({
    signal,
  }) => getActiveEmergencyServiceForEmergencyCircle(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getActiveEmergencyServiceForEmergencyCircle>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetActiveEmergencyServiceForEmergencyCircleQueryResult = NonNullable<
  Awaited<ReturnType<typeof getActiveEmergencyServiceForEmergencyCircle>>
>;
export type GetActiveEmergencyServiceForEmergencyCircleQueryError = unknown;

export function useGetActiveEmergencyServiceForEmergencyCircle<
  TData = Awaited<ReturnType<typeof getActiveEmergencyServiceForEmergencyCircle>>,
  TError = unknown,
>(
  params: GetActiveEmergencyServiceForEmergencyCircleParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getActiveEmergencyServiceForEmergencyCircle>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getActiveEmergencyServiceForEmergencyCircle>>,
          TError,
          Awaited<ReturnType<typeof getActiveEmergencyServiceForEmergencyCircle>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetActiveEmergencyServiceForEmergencyCircle<
  TData = Awaited<ReturnType<typeof getActiveEmergencyServiceForEmergencyCircle>>,
  TError = unknown,
>(
  params: GetActiveEmergencyServiceForEmergencyCircleParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getActiveEmergencyServiceForEmergencyCircle>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getActiveEmergencyServiceForEmergencyCircle>>,
          TError,
          Awaited<ReturnType<typeof getActiveEmergencyServiceForEmergencyCircle>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetActiveEmergencyServiceForEmergencyCircle<
  TData = Awaited<ReturnType<typeof getActiveEmergencyServiceForEmergencyCircle>>,
  TError = unknown,
>(
  params: GetActiveEmergencyServiceForEmergencyCircleParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getActiveEmergencyServiceForEmergencyCircle>>, TError, TData>
    >;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetActiveEmergencyServiceForEmergencyCircle<
  TData = Awaited<ReturnType<typeof getActiveEmergencyServiceForEmergencyCircle>>,
  TError = unknown,
>(
  params: GetActiveEmergencyServiceForEmergencyCircleParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getActiveEmergencyServiceForEmergencyCircle>>, TError, TData>
    >;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetActiveEmergencyServiceForEmergencyCircleQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetActiveEmergencyServiceForEmergencyCircleSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getActiveEmergencyServiceForEmergencyCircle>>,
  TError = unknown,
>(
  params: GetActiveEmergencyServiceForEmergencyCircleParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getActiveEmergencyServiceForEmergencyCircle>>, TError, TData>
    >;
    request?: SecondParameter<typeof request>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetActiveEmergencyServiceForEmergencyCircleQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getActiveEmergencyServiceForEmergencyCircle>>> = ({
    signal,
  }) => getActiveEmergencyServiceForEmergencyCircle(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getActiveEmergencyServiceForEmergencyCircle>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetActiveEmergencyServiceForEmergencyCircleSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getActiveEmergencyServiceForEmergencyCircle>>
>;
export type GetActiveEmergencyServiceForEmergencyCircleSuspenseQueryError = unknown;

export function useGetActiveEmergencyServiceForEmergencyCircleSuspense<
  TData = Awaited<ReturnType<typeof getActiveEmergencyServiceForEmergencyCircle>>,
  TError = unknown,
>(
  params: GetActiveEmergencyServiceForEmergencyCircleParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getActiveEmergencyServiceForEmergencyCircle>>, TError, TData>
    >;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetActiveEmergencyServiceForEmergencyCircleSuspense<
  TData = Awaited<ReturnType<typeof getActiveEmergencyServiceForEmergencyCircle>>,
  TError = unknown,
>(
  params: GetActiveEmergencyServiceForEmergencyCircleParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getActiveEmergencyServiceForEmergencyCircle>>, TError, TData>
    >;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetActiveEmergencyServiceForEmergencyCircleSuspense<
  TData = Awaited<ReturnType<typeof getActiveEmergencyServiceForEmergencyCircle>>,
  TError = unknown,
>(
  params: GetActiveEmergencyServiceForEmergencyCircleParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getActiveEmergencyServiceForEmergencyCircle>>, TError, TData>
    >;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetActiveEmergencyServiceForEmergencyCircleSuspense<
  TData = Awaited<ReturnType<typeof getActiveEmergencyServiceForEmergencyCircle>>,
  TError = unknown,
>(
  params: GetActiveEmergencyServiceForEmergencyCircleParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getActiveEmergencyServiceForEmergencyCircle>>, TError, TData>
    >;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetActiveEmergencyServiceForEmergencyCircleSuspenseQueryOptions(params, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getActiveEmergencyServicesForPractice = (
  practiceId: string,
  options?: SecondParameter<typeof request>,
  signal?: AbortSignal,
) => {
  return request<EmergencyServiceDto[]>(
    { url: `/suite/emergency-service/practice/${practiceId}`, method: 'GET', signal },
    options,
  );
};

export const getGetActiveEmergencyServicesForPracticeQueryKey = (practiceId?: string) => {
  return [`/suite/emergency-service/practice/${practiceId}`] as const;
};

export const getGetActiveEmergencyServicesForPracticeQueryOptions = <
  TData = Awaited<ReturnType<typeof getActiveEmergencyServicesForPractice>>,
  TError = unknown,
>(
  practiceId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getActiveEmergencyServicesForPractice>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetActiveEmergencyServicesForPracticeQueryKey(practiceId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getActiveEmergencyServicesForPractice>>> = ({ signal }) =>
    getActiveEmergencyServicesForPractice(practiceId, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!practiceId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getActiveEmergencyServicesForPractice>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetActiveEmergencyServicesForPracticeQueryResult = NonNullable<
  Awaited<ReturnType<typeof getActiveEmergencyServicesForPractice>>
>;
export type GetActiveEmergencyServicesForPracticeQueryError = unknown;

export function useGetActiveEmergencyServicesForPractice<
  TData = Awaited<ReturnType<typeof getActiveEmergencyServicesForPractice>>,
  TError = unknown,
>(
  practiceId: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getActiveEmergencyServicesForPractice>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getActiveEmergencyServicesForPractice>>,
          TError,
          Awaited<ReturnType<typeof getActiveEmergencyServicesForPractice>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetActiveEmergencyServicesForPractice<
  TData = Awaited<ReturnType<typeof getActiveEmergencyServicesForPractice>>,
  TError = unknown,
>(
  practiceId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getActiveEmergencyServicesForPractice>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getActiveEmergencyServicesForPractice>>,
          TError,
          Awaited<ReturnType<typeof getActiveEmergencyServicesForPractice>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetActiveEmergencyServicesForPractice<
  TData = Awaited<ReturnType<typeof getActiveEmergencyServicesForPractice>>,
  TError = unknown,
>(
  practiceId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getActiveEmergencyServicesForPractice>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetActiveEmergencyServicesForPractice<
  TData = Awaited<ReturnType<typeof getActiveEmergencyServicesForPractice>>,
  TError = unknown,
>(
  practiceId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getActiveEmergencyServicesForPractice>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetActiveEmergencyServicesForPracticeQueryOptions(practiceId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetActiveEmergencyServicesForPracticeSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getActiveEmergencyServicesForPractice>>,
  TError = unknown,
>(
  practiceId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getActiveEmergencyServicesForPractice>>, TError, TData>
    >;
    request?: SecondParameter<typeof request>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetActiveEmergencyServicesForPracticeQueryKey(practiceId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getActiveEmergencyServicesForPractice>>> = ({ signal }) =>
    getActiveEmergencyServicesForPractice(practiceId, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getActiveEmergencyServicesForPractice>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetActiveEmergencyServicesForPracticeSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getActiveEmergencyServicesForPractice>>
>;
export type GetActiveEmergencyServicesForPracticeSuspenseQueryError = unknown;

export function useGetActiveEmergencyServicesForPracticeSuspense<
  TData = Awaited<ReturnType<typeof getActiveEmergencyServicesForPractice>>,
  TError = unknown,
>(
  practiceId: string,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getActiveEmergencyServicesForPractice>>, TError, TData>
    >;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetActiveEmergencyServicesForPracticeSuspense<
  TData = Awaited<ReturnType<typeof getActiveEmergencyServicesForPractice>>,
  TError = unknown,
>(
  practiceId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getActiveEmergencyServicesForPractice>>, TError, TData>
    >;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetActiveEmergencyServicesForPracticeSuspense<
  TData = Awaited<ReturnType<typeof getActiveEmergencyServicesForPractice>>,
  TError = unknown,
>(
  practiceId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getActiveEmergencyServicesForPractice>>, TError, TData>
    >;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetActiveEmergencyServicesForPracticeSuspense<
  TData = Awaited<ReturnType<typeof getActiveEmergencyServicesForPractice>>,
  TError = unknown,
>(
  practiceId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getActiveEmergencyServicesForPractice>>, TError, TData>
    >;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetActiveEmergencyServicesForPracticeSuspenseQueryOptions(practiceId, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getEmergencyCirclesForPractice = (
  params: GetEmergencyCirclesForPracticeParams,
  options?: SecondParameter<typeof request>,
  signal?: AbortSignal,
) => {
  return request<EmergencyCircleDto[]>({ url: `/suite/emergency-circle`, method: 'GET', params, signal }, options);
};

export const getGetEmergencyCirclesForPracticeQueryKey = (params?: GetEmergencyCirclesForPracticeParams) => {
  return [`/suite/emergency-circle`, ...(params ? [params] : [])] as const;
};

export const getGetEmergencyCirclesForPracticeQueryOptions = <
  TData = Awaited<ReturnType<typeof getEmergencyCirclesForPractice>>,
  TError = unknown,
>(
  params: GetEmergencyCirclesForPracticeParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmergencyCirclesForPractice>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetEmergencyCirclesForPracticeQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getEmergencyCirclesForPractice>>> = ({ signal }) =>
    getEmergencyCirclesForPractice(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getEmergencyCirclesForPractice>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetEmergencyCirclesForPracticeQueryResult = NonNullable<
  Awaited<ReturnType<typeof getEmergencyCirclesForPractice>>
>;
export type GetEmergencyCirclesForPracticeQueryError = unknown;

export function useGetEmergencyCirclesForPractice<
  TData = Awaited<ReturnType<typeof getEmergencyCirclesForPractice>>,
  TError = unknown,
>(
  params: GetEmergencyCirclesForPracticeParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmergencyCirclesForPractice>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEmergencyCirclesForPractice>>,
          TError,
          Awaited<ReturnType<typeof getEmergencyCirclesForPractice>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetEmergencyCirclesForPractice<
  TData = Awaited<ReturnType<typeof getEmergencyCirclesForPractice>>,
  TError = unknown,
>(
  params: GetEmergencyCirclesForPracticeParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmergencyCirclesForPractice>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEmergencyCirclesForPractice>>,
          TError,
          Awaited<ReturnType<typeof getEmergencyCirclesForPractice>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetEmergencyCirclesForPractice<
  TData = Awaited<ReturnType<typeof getEmergencyCirclesForPractice>>,
  TError = unknown,
>(
  params: GetEmergencyCirclesForPracticeParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmergencyCirclesForPractice>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetEmergencyCirclesForPractice<
  TData = Awaited<ReturnType<typeof getEmergencyCirclesForPractice>>,
  TError = unknown,
>(
  params: GetEmergencyCirclesForPracticeParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmergencyCirclesForPractice>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetEmergencyCirclesForPracticeQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetEmergencyCirclesForPracticeSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getEmergencyCirclesForPractice>>,
  TError = unknown,
>(
  params: GetEmergencyCirclesForPracticeParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getEmergencyCirclesForPractice>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetEmergencyCirclesForPracticeQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getEmergencyCirclesForPractice>>> = ({ signal }) =>
    getEmergencyCirclesForPractice(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getEmergencyCirclesForPractice>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetEmergencyCirclesForPracticeSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getEmergencyCirclesForPractice>>
>;
export type GetEmergencyCirclesForPracticeSuspenseQueryError = unknown;

export function useGetEmergencyCirclesForPracticeSuspense<
  TData = Awaited<ReturnType<typeof getEmergencyCirclesForPractice>>,
  TError = unknown,
>(
  params: GetEmergencyCirclesForPracticeParams,
  options: {
    query: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getEmergencyCirclesForPractice>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetEmergencyCirclesForPracticeSuspense<
  TData = Awaited<ReturnType<typeof getEmergencyCirclesForPractice>>,
  TError = unknown,
>(
  params: GetEmergencyCirclesForPracticeParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getEmergencyCirclesForPractice>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetEmergencyCirclesForPracticeSuspense<
  TData = Awaited<ReturnType<typeof getEmergencyCirclesForPractice>>,
  TError = unknown,
>(
  params: GetEmergencyCirclesForPracticeParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getEmergencyCirclesForPractice>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetEmergencyCirclesForPracticeSuspense<
  TData = Awaited<ReturnType<typeof getEmergencyCirclesForPractice>>,
  TError = unknown,
>(
  params: GetEmergencyCirclesForPracticeParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getEmergencyCirclesForPractice>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetEmergencyCirclesForPracticeSuspenseQueryOptions(params, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getOfferedDeputyForDeputyPractice = (
  id: string,
  options?: SecondParameter<typeof request>,
  signal?: AbortSignal,
) => {
  return request<GetOfferedDeputyForDeputyPractice200>(
    { url: `/suite/deputies/${id}`, method: 'GET', signal },
    options,
  );
};

export const getGetOfferedDeputyForDeputyPracticeQueryKey = (id?: string) => {
  return [`/suite/deputies/${id}`] as const;
};

export const getGetOfferedDeputyForDeputyPracticeQueryOptions = <
  TData = Awaited<ReturnType<typeof getOfferedDeputyForDeputyPractice>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getOfferedDeputyForDeputyPractice>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetOfferedDeputyForDeputyPracticeQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getOfferedDeputyForDeputyPractice>>> = ({ signal }) =>
    getOfferedDeputyForDeputyPractice(id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getOfferedDeputyForDeputyPractice>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetOfferedDeputyForDeputyPracticeQueryResult = NonNullable<
  Awaited<ReturnType<typeof getOfferedDeputyForDeputyPractice>>
>;
export type GetOfferedDeputyForDeputyPracticeQueryError = unknown;

export function useGetOfferedDeputyForDeputyPractice<
  TData = Awaited<ReturnType<typeof getOfferedDeputyForDeputyPractice>>,
  TError = unknown,
>(
  id: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getOfferedDeputyForDeputyPractice>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOfferedDeputyForDeputyPractice>>,
          TError,
          Awaited<ReturnType<typeof getOfferedDeputyForDeputyPractice>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetOfferedDeputyForDeputyPractice<
  TData = Awaited<ReturnType<typeof getOfferedDeputyForDeputyPractice>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getOfferedDeputyForDeputyPractice>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOfferedDeputyForDeputyPractice>>,
          TError,
          Awaited<ReturnType<typeof getOfferedDeputyForDeputyPractice>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetOfferedDeputyForDeputyPractice<
  TData = Awaited<ReturnType<typeof getOfferedDeputyForDeputyPractice>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getOfferedDeputyForDeputyPractice>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetOfferedDeputyForDeputyPractice<
  TData = Awaited<ReturnType<typeof getOfferedDeputyForDeputyPractice>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getOfferedDeputyForDeputyPractice>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetOfferedDeputyForDeputyPracticeQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetOfferedDeputyForDeputyPracticeSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getOfferedDeputyForDeputyPractice>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOfferedDeputyForDeputyPractice>>, TError, TData>
    >;
    request?: SecondParameter<typeof request>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetOfferedDeputyForDeputyPracticeQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getOfferedDeputyForDeputyPractice>>> = ({ signal }) =>
    getOfferedDeputyForDeputyPractice(id, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getOfferedDeputyForDeputyPractice>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetOfferedDeputyForDeputyPracticeSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getOfferedDeputyForDeputyPractice>>
>;
export type GetOfferedDeputyForDeputyPracticeSuspenseQueryError = unknown;

export function useGetOfferedDeputyForDeputyPracticeSuspense<
  TData = Awaited<ReturnType<typeof getOfferedDeputyForDeputyPractice>>,
  TError = unknown,
>(
  id: string,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOfferedDeputyForDeputyPractice>>, TError, TData>
    >;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetOfferedDeputyForDeputyPracticeSuspense<
  TData = Awaited<ReturnType<typeof getOfferedDeputyForDeputyPractice>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOfferedDeputyForDeputyPractice>>, TError, TData>
    >;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetOfferedDeputyForDeputyPracticeSuspense<
  TData = Awaited<ReturnType<typeof getOfferedDeputyForDeputyPractice>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOfferedDeputyForDeputyPractice>>, TError, TData>
    >;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetOfferedDeputyForDeputyPracticeSuspense<
  TData = Awaited<ReturnType<typeof getOfferedDeputyForDeputyPractice>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOfferedDeputyForDeputyPractice>>, TError, TData>
    >;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetOfferedDeputyForDeputyPracticeSuspenseQueryOptions(id, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getUnexpiredNonRevokedDeputiesForSharedPractice = (
  params: GetUnexpiredNonRevokedDeputiesForSharedPracticeParams,
  options?: SecondParameter<typeof request>,
  signal?: AbortSignal,
) => {
  return request<DeputyDto[]>({ url: `/suite/deputies/unexpirednonrevoked`, method: 'GET', params, signal }, options);
};

export const getGetUnexpiredNonRevokedDeputiesForSharedPracticeQueryKey = (
  params?: GetUnexpiredNonRevokedDeputiesForSharedPracticeParams,
) => {
  return [`/suite/deputies/unexpirednonrevoked`, ...(params ? [params] : [])] as const;
};

export const getGetUnexpiredNonRevokedDeputiesForSharedPracticeQueryOptions = <
  TData = Awaited<ReturnType<typeof getUnexpiredNonRevokedDeputiesForSharedPractice>>,
  TError = unknown,
>(
  params: GetUnexpiredNonRevokedDeputiesForSharedPracticeParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getUnexpiredNonRevokedDeputiesForSharedPractice>>, TError, TData>
    >;
    request?: SecondParameter<typeof request>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetUnexpiredNonRevokedDeputiesForSharedPracticeQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getUnexpiredNonRevokedDeputiesForSharedPractice>>> = ({
    signal,
  }) => getUnexpiredNonRevokedDeputiesForSharedPractice(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getUnexpiredNonRevokedDeputiesForSharedPractice>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetUnexpiredNonRevokedDeputiesForSharedPracticeQueryResult = NonNullable<
  Awaited<ReturnType<typeof getUnexpiredNonRevokedDeputiesForSharedPractice>>
>;
export type GetUnexpiredNonRevokedDeputiesForSharedPracticeQueryError = unknown;

export function useGetUnexpiredNonRevokedDeputiesForSharedPractice<
  TData = Awaited<ReturnType<typeof getUnexpiredNonRevokedDeputiesForSharedPractice>>,
  TError = unknown,
>(
  params: GetUnexpiredNonRevokedDeputiesForSharedPracticeParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getUnexpiredNonRevokedDeputiesForSharedPractice>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUnexpiredNonRevokedDeputiesForSharedPractice>>,
          TError,
          Awaited<ReturnType<typeof getUnexpiredNonRevokedDeputiesForSharedPractice>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetUnexpiredNonRevokedDeputiesForSharedPractice<
  TData = Awaited<ReturnType<typeof getUnexpiredNonRevokedDeputiesForSharedPractice>>,
  TError = unknown,
>(
  params: GetUnexpiredNonRevokedDeputiesForSharedPracticeParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getUnexpiredNonRevokedDeputiesForSharedPractice>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUnexpiredNonRevokedDeputiesForSharedPractice>>,
          TError,
          Awaited<ReturnType<typeof getUnexpiredNonRevokedDeputiesForSharedPractice>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetUnexpiredNonRevokedDeputiesForSharedPractice<
  TData = Awaited<ReturnType<typeof getUnexpiredNonRevokedDeputiesForSharedPractice>>,
  TError = unknown,
>(
  params: GetUnexpiredNonRevokedDeputiesForSharedPracticeParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getUnexpiredNonRevokedDeputiesForSharedPractice>>, TError, TData>
    >;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetUnexpiredNonRevokedDeputiesForSharedPractice<
  TData = Awaited<ReturnType<typeof getUnexpiredNonRevokedDeputiesForSharedPractice>>,
  TError = unknown,
>(
  params: GetUnexpiredNonRevokedDeputiesForSharedPracticeParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getUnexpiredNonRevokedDeputiesForSharedPractice>>, TError, TData>
    >;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetUnexpiredNonRevokedDeputiesForSharedPracticeQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetUnexpiredNonRevokedDeputiesForSharedPracticeSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getUnexpiredNonRevokedDeputiesForSharedPractice>>,
  TError = unknown,
>(
  params: GetUnexpiredNonRevokedDeputiesForSharedPracticeParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getUnexpiredNonRevokedDeputiesForSharedPractice>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof request>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetUnexpiredNonRevokedDeputiesForSharedPracticeQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getUnexpiredNonRevokedDeputiesForSharedPractice>>> = ({
    signal,
  }) => getUnexpiredNonRevokedDeputiesForSharedPractice(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getUnexpiredNonRevokedDeputiesForSharedPractice>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetUnexpiredNonRevokedDeputiesForSharedPracticeSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getUnexpiredNonRevokedDeputiesForSharedPractice>>
>;
export type GetUnexpiredNonRevokedDeputiesForSharedPracticeSuspenseQueryError = unknown;

export function useGetUnexpiredNonRevokedDeputiesForSharedPracticeSuspense<
  TData = Awaited<ReturnType<typeof getUnexpiredNonRevokedDeputiesForSharedPractice>>,
  TError = unknown,
>(
  params: GetUnexpiredNonRevokedDeputiesForSharedPracticeParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getUnexpiredNonRevokedDeputiesForSharedPractice>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetUnexpiredNonRevokedDeputiesForSharedPracticeSuspense<
  TData = Awaited<ReturnType<typeof getUnexpiredNonRevokedDeputiesForSharedPractice>>,
  TError = unknown,
>(
  params: GetUnexpiredNonRevokedDeputiesForSharedPracticeParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getUnexpiredNonRevokedDeputiesForSharedPractice>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetUnexpiredNonRevokedDeputiesForSharedPracticeSuspense<
  TData = Awaited<ReturnType<typeof getUnexpiredNonRevokedDeputiesForSharedPractice>>,
  TError = unknown,
>(
  params: GetUnexpiredNonRevokedDeputiesForSharedPracticeParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getUnexpiredNonRevokedDeputiesForSharedPractice>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetUnexpiredNonRevokedDeputiesForSharedPracticeSuspense<
  TData = Awaited<ReturnType<typeof getUnexpiredNonRevokedDeputiesForSharedPractice>>,
  TError = unknown,
>(
  params: GetUnexpiredNonRevokedDeputiesForSharedPracticeParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getUnexpiredNonRevokedDeputiesForSharedPractice>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetUnexpiredNonRevokedDeputiesForSharedPracticeSuspenseQueryOptions(params, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getDeputyPracticesByName = (
  params: GetDeputyPracticesByNameParams,
  options?: SecondParameter<typeof request>,
  signal?: AbortSignal,
) => {
  return request<PracticeDto[]>({ url: `/suite/deputies/search`, method: 'GET', params, signal }, options);
};

export const getGetDeputyPracticesByNameQueryKey = (params?: GetDeputyPracticesByNameParams) => {
  return [`/suite/deputies/search`, ...(params ? [params] : [])] as const;
};

export const getGetDeputyPracticesByNameQueryOptions = <
  TData = Awaited<ReturnType<typeof getDeputyPracticesByName>>,
  TError = unknown,
>(
  params: GetDeputyPracticesByNameParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getDeputyPracticesByName>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetDeputyPracticesByNameQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getDeputyPracticesByName>>> = ({ signal }) =>
    getDeputyPracticesByName(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getDeputyPracticesByName>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetDeputyPracticesByNameQueryResult = NonNullable<Awaited<ReturnType<typeof getDeputyPracticesByName>>>;
export type GetDeputyPracticesByNameQueryError = unknown;

export function useGetDeputyPracticesByName<
  TData = Awaited<ReturnType<typeof getDeputyPracticesByName>>,
  TError = unknown,
>(
  params: GetDeputyPracticesByNameParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getDeputyPracticesByName>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDeputyPracticesByName>>,
          TError,
          Awaited<ReturnType<typeof getDeputyPracticesByName>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetDeputyPracticesByName<
  TData = Awaited<ReturnType<typeof getDeputyPracticesByName>>,
  TError = unknown,
>(
  params: GetDeputyPracticesByNameParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getDeputyPracticesByName>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDeputyPracticesByName>>,
          TError,
          Awaited<ReturnType<typeof getDeputyPracticesByName>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetDeputyPracticesByName<
  TData = Awaited<ReturnType<typeof getDeputyPracticesByName>>,
  TError = unknown,
>(
  params: GetDeputyPracticesByNameParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getDeputyPracticesByName>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetDeputyPracticesByName<
  TData = Awaited<ReturnType<typeof getDeputyPracticesByName>>,
  TError = unknown,
>(
  params: GetDeputyPracticesByNameParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getDeputyPracticesByName>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetDeputyPracticesByNameQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetDeputyPracticesByNameSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getDeputyPracticesByName>>,
  TError = unknown,
>(
  params: GetDeputyPracticesByNameParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDeputyPracticesByName>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetDeputyPracticesByNameQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getDeputyPracticesByName>>> = ({ signal }) =>
    getDeputyPracticesByName(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getDeputyPracticesByName>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetDeputyPracticesByNameSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDeputyPracticesByName>>
>;
export type GetDeputyPracticesByNameSuspenseQueryError = unknown;

export function useGetDeputyPracticesByNameSuspense<
  TData = Awaited<ReturnType<typeof getDeputyPracticesByName>>,
  TError = unknown,
>(
  params: GetDeputyPracticesByNameParams,
  options: {
    query: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDeputyPracticesByName>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetDeputyPracticesByNameSuspense<
  TData = Awaited<ReturnType<typeof getDeputyPracticesByName>>,
  TError = unknown,
>(
  params: GetDeputyPracticesByNameParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDeputyPracticesByName>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetDeputyPracticesByNameSuspense<
  TData = Awaited<ReturnType<typeof getDeputyPracticesByName>>,
  TError = unknown,
>(
  params: GetDeputyPracticesByNameParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDeputyPracticesByName>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetDeputyPracticesByNameSuspense<
  TData = Awaited<ReturnType<typeof getDeputyPracticesByName>>,
  TError = unknown,
>(
  params: GetDeputyPracticesByNameParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDeputyPracticesByName>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetDeputyPracticesByNameSuspenseQueryOptions(params, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getActiveDeputiesForDeputyPractice = (
  params: GetActiveDeputiesForDeputyPracticeParams,
  options?: SecondParameter<typeof request>,
  signal?: AbortSignal,
) => {
  return request<DeputyDto[]>({ url: `/suite/deputies/active`, method: 'GET', params, signal }, options);
};

export const getGetActiveDeputiesForDeputyPracticeQueryKey = (params?: GetActiveDeputiesForDeputyPracticeParams) => {
  return [`/suite/deputies/active`, ...(params ? [params] : [])] as const;
};

export const getGetActiveDeputiesForDeputyPracticeQueryOptions = <
  TData = Awaited<ReturnType<typeof getActiveDeputiesForDeputyPractice>>,
  TError = unknown,
>(
  params: GetActiveDeputiesForDeputyPracticeParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getActiveDeputiesForDeputyPractice>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetActiveDeputiesForDeputyPracticeQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getActiveDeputiesForDeputyPractice>>> = ({ signal }) =>
    getActiveDeputiesForDeputyPractice(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getActiveDeputiesForDeputyPractice>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetActiveDeputiesForDeputyPracticeQueryResult = NonNullable<
  Awaited<ReturnType<typeof getActiveDeputiesForDeputyPractice>>
>;
export type GetActiveDeputiesForDeputyPracticeQueryError = unknown;

export function useGetActiveDeputiesForDeputyPractice<
  TData = Awaited<ReturnType<typeof getActiveDeputiesForDeputyPractice>>,
  TError = unknown,
>(
  params: GetActiveDeputiesForDeputyPracticeParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getActiveDeputiesForDeputyPractice>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getActiveDeputiesForDeputyPractice>>,
          TError,
          Awaited<ReturnType<typeof getActiveDeputiesForDeputyPractice>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetActiveDeputiesForDeputyPractice<
  TData = Awaited<ReturnType<typeof getActiveDeputiesForDeputyPractice>>,
  TError = unknown,
>(
  params: GetActiveDeputiesForDeputyPracticeParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getActiveDeputiesForDeputyPractice>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getActiveDeputiesForDeputyPractice>>,
          TError,
          Awaited<ReturnType<typeof getActiveDeputiesForDeputyPractice>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetActiveDeputiesForDeputyPractice<
  TData = Awaited<ReturnType<typeof getActiveDeputiesForDeputyPractice>>,
  TError = unknown,
>(
  params: GetActiveDeputiesForDeputyPracticeParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getActiveDeputiesForDeputyPractice>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetActiveDeputiesForDeputyPractice<
  TData = Awaited<ReturnType<typeof getActiveDeputiesForDeputyPractice>>,
  TError = unknown,
>(
  params: GetActiveDeputiesForDeputyPracticeParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getActiveDeputiesForDeputyPractice>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetActiveDeputiesForDeputyPracticeQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetActiveDeputiesForDeputyPracticeSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getActiveDeputiesForDeputyPractice>>,
  TError = unknown,
>(
  params: GetActiveDeputiesForDeputyPracticeParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getActiveDeputiesForDeputyPractice>>, TError, TData>
    >;
    request?: SecondParameter<typeof request>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetActiveDeputiesForDeputyPracticeQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getActiveDeputiesForDeputyPractice>>> = ({ signal }) =>
    getActiveDeputiesForDeputyPractice(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getActiveDeputiesForDeputyPractice>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetActiveDeputiesForDeputyPracticeSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getActiveDeputiesForDeputyPractice>>
>;
export type GetActiveDeputiesForDeputyPracticeSuspenseQueryError = unknown;

export function useGetActiveDeputiesForDeputyPracticeSuspense<
  TData = Awaited<ReturnType<typeof getActiveDeputiesForDeputyPractice>>,
  TError = unknown,
>(
  params: GetActiveDeputiesForDeputyPracticeParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getActiveDeputiesForDeputyPractice>>, TError, TData>
    >;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetActiveDeputiesForDeputyPracticeSuspense<
  TData = Awaited<ReturnType<typeof getActiveDeputiesForDeputyPractice>>,
  TError = unknown,
>(
  params: GetActiveDeputiesForDeputyPracticeParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getActiveDeputiesForDeputyPractice>>, TError, TData>
    >;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetActiveDeputiesForDeputyPracticeSuspense<
  TData = Awaited<ReturnType<typeof getActiveDeputiesForDeputyPractice>>,
  TError = unknown,
>(
  params: GetActiveDeputiesForDeputyPracticeParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getActiveDeputiesForDeputyPractice>>, TError, TData>
    >;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetActiveDeputiesForDeputyPracticeSuspense<
  TData = Awaited<ReturnType<typeof getActiveDeputiesForDeputyPractice>>,
  TError = unknown,
>(
  params: GetActiveDeputiesForDeputyPracticeParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getActiveDeputiesForDeputyPractice>>, TError, TData>
    >;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetActiveDeputiesForDeputyPracticeSuspenseQueryOptions(params, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getAccessLogsForPractice = (
  params: GetAccessLogsForPracticeParams,
  options?: SecondParameter<typeof request>,
  signal?: AbortSignal,
) => {
  return request<AccessLogDto[]>({ url: `/suite/accesslogs`, method: 'GET', params, signal }, options);
};

export const getGetAccessLogsForPracticeQueryKey = (params?: GetAccessLogsForPracticeParams) => {
  return [`/suite/accesslogs`, ...(params ? [params] : [])] as const;
};

export const getGetAccessLogsForPracticeQueryOptions = <
  TData = Awaited<ReturnType<typeof getAccessLogsForPractice>>,
  TError = unknown,
>(
  params: GetAccessLogsForPracticeParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccessLogsForPractice>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAccessLogsForPracticeQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAccessLogsForPractice>>> = ({ signal }) =>
    getAccessLogsForPractice(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAccessLogsForPractice>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetAccessLogsForPracticeQueryResult = NonNullable<Awaited<ReturnType<typeof getAccessLogsForPractice>>>;
export type GetAccessLogsForPracticeQueryError = unknown;

export function useGetAccessLogsForPractice<
  TData = Awaited<ReturnType<typeof getAccessLogsForPractice>>,
  TError = unknown,
>(
  params: GetAccessLogsForPracticeParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccessLogsForPractice>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAccessLogsForPractice>>,
          TError,
          Awaited<ReturnType<typeof getAccessLogsForPractice>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetAccessLogsForPractice<
  TData = Awaited<ReturnType<typeof getAccessLogsForPractice>>,
  TError = unknown,
>(
  params: GetAccessLogsForPracticeParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccessLogsForPractice>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAccessLogsForPractice>>,
          TError,
          Awaited<ReturnType<typeof getAccessLogsForPractice>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetAccessLogsForPractice<
  TData = Awaited<ReturnType<typeof getAccessLogsForPractice>>,
  TError = unknown,
>(
  params: GetAccessLogsForPracticeParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccessLogsForPractice>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetAccessLogsForPractice<
  TData = Awaited<ReturnType<typeof getAccessLogsForPractice>>,
  TError = unknown,
>(
  params: GetAccessLogsForPracticeParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccessLogsForPractice>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetAccessLogsForPracticeQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetAccessLogsForPracticeSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getAccessLogsForPractice>>,
  TError = unknown,
>(
  params: GetAccessLogsForPracticeParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAccessLogsForPractice>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAccessLogsForPracticeQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAccessLogsForPractice>>> = ({ signal }) =>
    getAccessLogsForPractice(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getAccessLogsForPractice>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetAccessLogsForPracticeSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAccessLogsForPractice>>
>;
export type GetAccessLogsForPracticeSuspenseQueryError = unknown;

export function useGetAccessLogsForPracticeSuspense<
  TData = Awaited<ReturnType<typeof getAccessLogsForPractice>>,
  TError = unknown,
>(
  params: GetAccessLogsForPracticeParams,
  options: {
    query: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAccessLogsForPractice>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetAccessLogsForPracticeSuspense<
  TData = Awaited<ReturnType<typeof getAccessLogsForPractice>>,
  TError = unknown,
>(
  params: GetAccessLogsForPracticeParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAccessLogsForPractice>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetAccessLogsForPracticeSuspense<
  TData = Awaited<ReturnType<typeof getAccessLogsForPractice>>,
  TError = unknown,
>(
  params: GetAccessLogsForPracticeParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAccessLogsForPractice>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetAccessLogsForPracticeSuspense<
  TData = Awaited<ReturnType<typeof getAccessLogsForPractice>>,
  TError = unknown,
>(
  params: GetAccessLogsForPracticeParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAccessLogsForPractice>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetAccessLogsForPracticeSuspenseQueryOptions(params, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const denySharePatientWithHospital = (
  params: DenySharePatientWithHospitalParams,
  options?: SecondParameter<typeof request>,
  signal?: AbortSignal,
) => {
  return request<DenySharePatientWithHospital200>(
    { url: `/hospital/patient/share/deny`, method: 'GET', params, signal },
    options,
  );
};

export const getDenySharePatientWithHospitalQueryKey = (params?: DenySharePatientWithHospitalParams) => {
  return [`/hospital/patient/share/deny`, ...(params ? [params] : [])] as const;
};

export const getDenySharePatientWithHospitalQueryOptions = <
  TData = Awaited<ReturnType<typeof denySharePatientWithHospital>>,
  TError = unknown,
>(
  params: DenySharePatientWithHospitalParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof denySharePatientWithHospital>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getDenySharePatientWithHospitalQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof denySharePatientWithHospital>>> = ({ signal }) =>
    denySharePatientWithHospital(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof denySharePatientWithHospital>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type DenySharePatientWithHospitalQueryResult = NonNullable<
  Awaited<ReturnType<typeof denySharePatientWithHospital>>
>;
export type DenySharePatientWithHospitalQueryError = unknown;

export function useDenySharePatientWithHospital<
  TData = Awaited<ReturnType<typeof denySharePatientWithHospital>>,
  TError = unknown,
>(
  params: DenySharePatientWithHospitalParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof denySharePatientWithHospital>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof denySharePatientWithHospital>>,
          TError,
          Awaited<ReturnType<typeof denySharePatientWithHospital>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useDenySharePatientWithHospital<
  TData = Awaited<ReturnType<typeof denySharePatientWithHospital>>,
  TError = unknown,
>(
  params: DenySharePatientWithHospitalParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof denySharePatientWithHospital>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof denySharePatientWithHospital>>,
          TError,
          Awaited<ReturnType<typeof denySharePatientWithHospital>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useDenySharePatientWithHospital<
  TData = Awaited<ReturnType<typeof denySharePatientWithHospital>>,
  TError = unknown,
>(
  params: DenySharePatientWithHospitalParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof denySharePatientWithHospital>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useDenySharePatientWithHospital<
  TData = Awaited<ReturnType<typeof denySharePatientWithHospital>>,
  TError = unknown,
>(
  params: DenySharePatientWithHospitalParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof denySharePatientWithHospital>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getDenySharePatientWithHospitalQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getDenySharePatientWithHospitalSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof denySharePatientWithHospital>>,
  TError = unknown,
>(
  params: DenySharePatientWithHospitalParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof denySharePatientWithHospital>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getDenySharePatientWithHospitalQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof denySharePatientWithHospital>>> = ({ signal }) =>
    denySharePatientWithHospital(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof denySharePatientWithHospital>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type DenySharePatientWithHospitalSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof denySharePatientWithHospital>>
>;
export type DenySharePatientWithHospitalSuspenseQueryError = unknown;

export function useDenySharePatientWithHospitalSuspense<
  TData = Awaited<ReturnType<typeof denySharePatientWithHospital>>,
  TError = unknown,
>(
  params: DenySharePatientWithHospitalParams,
  options: {
    query: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof denySharePatientWithHospital>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useDenySharePatientWithHospitalSuspense<
  TData = Awaited<ReturnType<typeof denySharePatientWithHospital>>,
  TError = unknown,
>(
  params: DenySharePatientWithHospitalParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof denySharePatientWithHospital>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useDenySharePatientWithHospitalSuspense<
  TData = Awaited<ReturnType<typeof denySharePatientWithHospital>>,
  TError = unknown,
>(
  params: DenySharePatientWithHospitalParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof denySharePatientWithHospital>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useDenySharePatientWithHospitalSuspense<
  TData = Awaited<ReturnType<typeof denySharePatientWithHospital>>,
  TError = unknown,
>(
  params: DenySharePatientWithHospitalParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof denySharePatientWithHospital>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getDenySharePatientWithHospitalSuspenseQueryOptions(params, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const acceptSharePatientWithHospital = (
  params: AcceptSharePatientWithHospitalParams,
  options?: SecondParameter<typeof request>,
  signal?: AbortSignal,
) => {
  return request<AcceptSharePatientWithHospital200>(
    { url: `/hospital/patient/share/accept`, method: 'GET', params, signal },
    options,
  );
};

export const getAcceptSharePatientWithHospitalQueryKey = (params?: AcceptSharePatientWithHospitalParams) => {
  return [`/hospital/patient/share/accept`, ...(params ? [params] : [])] as const;
};

export const getAcceptSharePatientWithHospitalQueryOptions = <
  TData = Awaited<ReturnType<typeof acceptSharePatientWithHospital>>,
  TError = unknown,
>(
  params: AcceptSharePatientWithHospitalParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof acceptSharePatientWithHospital>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAcceptSharePatientWithHospitalQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof acceptSharePatientWithHospital>>> = ({ signal }) =>
    acceptSharePatientWithHospital(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof acceptSharePatientWithHospital>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AcceptSharePatientWithHospitalQueryResult = NonNullable<
  Awaited<ReturnType<typeof acceptSharePatientWithHospital>>
>;
export type AcceptSharePatientWithHospitalQueryError = unknown;

export function useAcceptSharePatientWithHospital<
  TData = Awaited<ReturnType<typeof acceptSharePatientWithHospital>>,
  TError = unknown,
>(
  params: AcceptSharePatientWithHospitalParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof acceptSharePatientWithHospital>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof acceptSharePatientWithHospital>>,
          TError,
          Awaited<ReturnType<typeof acceptSharePatientWithHospital>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAcceptSharePatientWithHospital<
  TData = Awaited<ReturnType<typeof acceptSharePatientWithHospital>>,
  TError = unknown,
>(
  params: AcceptSharePatientWithHospitalParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof acceptSharePatientWithHospital>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof acceptSharePatientWithHospital>>,
          TError,
          Awaited<ReturnType<typeof acceptSharePatientWithHospital>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAcceptSharePatientWithHospital<
  TData = Awaited<ReturnType<typeof acceptSharePatientWithHospital>>,
  TError = unknown,
>(
  params: AcceptSharePatientWithHospitalParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof acceptSharePatientWithHospital>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useAcceptSharePatientWithHospital<
  TData = Awaited<ReturnType<typeof acceptSharePatientWithHospital>>,
  TError = unknown,
>(
  params: AcceptSharePatientWithHospitalParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof acceptSharePatientWithHospital>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getAcceptSharePatientWithHospitalQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getAcceptSharePatientWithHospitalSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof acceptSharePatientWithHospital>>,
  TError = unknown,
>(
  params: AcceptSharePatientWithHospitalParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof acceptSharePatientWithHospital>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAcceptSharePatientWithHospitalQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof acceptSharePatientWithHospital>>> = ({ signal }) =>
    acceptSharePatientWithHospital(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof acceptSharePatientWithHospital>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AcceptSharePatientWithHospitalSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof acceptSharePatientWithHospital>>
>;
export type AcceptSharePatientWithHospitalSuspenseQueryError = unknown;

export function useAcceptSharePatientWithHospitalSuspense<
  TData = Awaited<ReturnType<typeof acceptSharePatientWithHospital>>,
  TError = unknown,
>(
  params: AcceptSharePatientWithHospitalParams,
  options: {
    query: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof acceptSharePatientWithHospital>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAcceptSharePatientWithHospitalSuspense<
  TData = Awaited<ReturnType<typeof acceptSharePatientWithHospital>>,
  TError = unknown,
>(
  params: AcceptSharePatientWithHospitalParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof acceptSharePatientWithHospital>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAcceptSharePatientWithHospitalSuspense<
  TData = Awaited<ReturnType<typeof acceptSharePatientWithHospital>>,
  TError = unknown,
>(
  params: AcceptSharePatientWithHospitalParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof acceptSharePatientWithHospital>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useAcceptSharePatientWithHospitalSuspense<
  TData = Awaited<ReturnType<typeof acceptSharePatientWithHospital>>,
  TError = unknown,
>(
  params: AcceptSharePatientWithHospitalParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof acceptSharePatientWithHospital>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getAcceptSharePatientWithHospitalSuspenseQueryOptions(params, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getSante24PatientDetails = (
  patientId: string,
  options?: SecondParameter<typeof request>,
  signal?: AbortSignal,
) => {
  return request<HeurekaPatientDetailsWithPracticeAndInsuranceDto>(
    { url: `/callcenter/sante24/private/patient/${patientId}/details`, method: 'GET', signal },
    options,
  );
};

export const getGetSante24PatientDetailsQueryKey = (patientId?: string) => {
  return [`/callcenter/sante24/private/patient/${patientId}/details`] as const;
};

export const getGetSante24PatientDetailsQueryOptions = <
  TData = Awaited<ReturnType<typeof getSante24PatientDetails>>,
  TError = unknown,
>(
  patientId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSante24PatientDetails>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetSante24PatientDetailsQueryKey(patientId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSante24PatientDetails>>> = ({ signal }) =>
    getSante24PatientDetails(patientId, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!patientId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSante24PatientDetails>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetSante24PatientDetailsQueryResult = NonNullable<Awaited<ReturnType<typeof getSante24PatientDetails>>>;
export type GetSante24PatientDetailsQueryError = unknown;

export function useGetSante24PatientDetails<
  TData = Awaited<ReturnType<typeof getSante24PatientDetails>>,
  TError = unknown,
>(
  patientId: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSante24PatientDetails>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSante24PatientDetails>>,
          TError,
          Awaited<ReturnType<typeof getSante24PatientDetails>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetSante24PatientDetails<
  TData = Awaited<ReturnType<typeof getSante24PatientDetails>>,
  TError = unknown,
>(
  patientId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSante24PatientDetails>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSante24PatientDetails>>,
          TError,
          Awaited<ReturnType<typeof getSante24PatientDetails>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetSante24PatientDetails<
  TData = Awaited<ReturnType<typeof getSante24PatientDetails>>,
  TError = unknown,
>(
  patientId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSante24PatientDetails>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetSante24PatientDetails<
  TData = Awaited<ReturnType<typeof getSante24PatientDetails>>,
  TError = unknown,
>(
  patientId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSante24PatientDetails>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetSante24PatientDetailsQueryOptions(patientId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetSante24PatientDetailsSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getSante24PatientDetails>>,
  TError = unknown,
>(
  patientId: string,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSante24PatientDetails>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetSante24PatientDetailsQueryKey(patientId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSante24PatientDetails>>> = ({ signal }) =>
    getSante24PatientDetails(patientId, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getSante24PatientDetails>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetSante24PatientDetailsSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSante24PatientDetails>>
>;
export type GetSante24PatientDetailsSuspenseQueryError = unknown;

export function useGetSante24PatientDetailsSuspense<
  TData = Awaited<ReturnType<typeof getSante24PatientDetails>>,
  TError = unknown,
>(
  patientId: string,
  options: {
    query: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSante24PatientDetails>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetSante24PatientDetailsSuspense<
  TData = Awaited<ReturnType<typeof getSante24PatientDetails>>,
  TError = unknown,
>(
  patientId: string,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSante24PatientDetails>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetSante24PatientDetailsSuspense<
  TData = Awaited<ReturnType<typeof getSante24PatientDetails>>,
  TError = unknown,
>(
  patientId: string,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSante24PatientDetails>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetSante24PatientDetailsSuspense<
  TData = Awaited<ReturnType<typeof getSante24PatientDetails>>,
  TError = unknown,
>(
  patientId: string,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSante24PatientDetails>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetSante24PatientDetailsSuspenseQueryOptions(patientId, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getMedi24PatientDetails = (
  patientId: string,
  options?: SecondParameter<typeof request>,
  signal?: AbortSignal,
) => {
  return request<HeurekaPatientDetailsWithPracticeAndInsuranceDto>(
    { url: `/callcenter/medi24/patients/${patientId}`, method: 'GET', signal },
    options,
  );
};

export const getGetMedi24PatientDetailsQueryKey = (patientId?: string) => {
  return [`/callcenter/medi24/patients/${patientId}`] as const;
};

export const getGetMedi24PatientDetailsQueryOptions = <
  TData = Awaited<ReturnType<typeof getMedi24PatientDetails>>,
  TError = unknown,
>(
  patientId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMedi24PatientDetails>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMedi24PatientDetailsQueryKey(patientId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMedi24PatientDetails>>> = ({ signal }) =>
    getMedi24PatientDetails(patientId, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!patientId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMedi24PatientDetails>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMedi24PatientDetailsQueryResult = NonNullable<Awaited<ReturnType<typeof getMedi24PatientDetails>>>;
export type GetMedi24PatientDetailsQueryError = unknown;

export function useGetMedi24PatientDetails<
  TData = Awaited<ReturnType<typeof getMedi24PatientDetails>>,
  TError = unknown,
>(
  patientId: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMedi24PatientDetails>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMedi24PatientDetails>>,
          TError,
          Awaited<ReturnType<typeof getMedi24PatientDetails>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMedi24PatientDetails<
  TData = Awaited<ReturnType<typeof getMedi24PatientDetails>>,
  TError = unknown,
>(
  patientId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMedi24PatientDetails>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMedi24PatientDetails>>,
          TError,
          Awaited<ReturnType<typeof getMedi24PatientDetails>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMedi24PatientDetails<
  TData = Awaited<ReturnType<typeof getMedi24PatientDetails>>,
  TError = unknown,
>(
  patientId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMedi24PatientDetails>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetMedi24PatientDetails<
  TData = Awaited<ReturnType<typeof getMedi24PatientDetails>>,
  TError = unknown,
>(
  patientId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMedi24PatientDetails>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMedi24PatientDetailsQueryOptions(patientId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMedi24PatientDetailsSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getMedi24PatientDetails>>,
  TError = unknown,
>(
  patientId: string,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMedi24PatientDetails>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMedi24PatientDetailsQueryKey(patientId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMedi24PatientDetails>>> = ({ signal }) =>
    getMedi24PatientDetails(patientId, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getMedi24PatientDetails>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMedi24PatientDetailsSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMedi24PatientDetails>>
>;
export type GetMedi24PatientDetailsSuspenseQueryError = unknown;

export function useGetMedi24PatientDetailsSuspense<
  TData = Awaited<ReturnType<typeof getMedi24PatientDetails>>,
  TError = unknown,
>(
  patientId: string,
  options: {
    query: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMedi24PatientDetails>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMedi24PatientDetailsSuspense<
  TData = Awaited<ReturnType<typeof getMedi24PatientDetails>>,
  TError = unknown,
>(
  patientId: string,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMedi24PatientDetails>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMedi24PatientDetailsSuspense<
  TData = Awaited<ReturnType<typeof getMedi24PatientDetails>>,
  TError = unknown,
>(
  patientId: string,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMedi24PatientDetails>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetMedi24PatientDetailsSuspense<
  TData = Awaited<ReturnType<typeof getMedi24PatientDetails>>,
  TError = unknown,
>(
  patientId: string,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMedi24PatientDetails>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMedi24PatientDetailsSuspenseQueryOptions(patientId, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const isMedi24PatientDataAvailable = (
  params: IsMedi24PatientDataAvailableParams,
  options?: SecondParameter<typeof request>,
  signal?: AbortSignal,
) => {
  return request<boolean>({ url: `/callcenter/medi24/patient/exists`, method: 'GET', params, signal }, options);
};

export const getIsMedi24PatientDataAvailableQueryKey = (params?: IsMedi24PatientDataAvailableParams) => {
  return [`/callcenter/medi24/patient/exists`, ...(params ? [params] : [])] as const;
};

export const getIsMedi24PatientDataAvailableQueryOptions = <
  TData = Awaited<ReturnType<typeof isMedi24PatientDataAvailable>>,
  TError = unknown,
>(
  params: IsMedi24PatientDataAvailableParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof isMedi24PatientDataAvailable>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getIsMedi24PatientDataAvailableQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof isMedi24PatientDataAvailable>>> = ({ signal }) =>
    isMedi24PatientDataAvailable(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof isMedi24PatientDataAvailable>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type IsMedi24PatientDataAvailableQueryResult = NonNullable<
  Awaited<ReturnType<typeof isMedi24PatientDataAvailable>>
>;
export type IsMedi24PatientDataAvailableQueryError = unknown;

export function useIsMedi24PatientDataAvailable<
  TData = Awaited<ReturnType<typeof isMedi24PatientDataAvailable>>,
  TError = unknown,
>(
  params: IsMedi24PatientDataAvailableParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof isMedi24PatientDataAvailable>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof isMedi24PatientDataAvailable>>,
          TError,
          Awaited<ReturnType<typeof isMedi24PatientDataAvailable>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useIsMedi24PatientDataAvailable<
  TData = Awaited<ReturnType<typeof isMedi24PatientDataAvailable>>,
  TError = unknown,
>(
  params: IsMedi24PatientDataAvailableParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof isMedi24PatientDataAvailable>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof isMedi24PatientDataAvailable>>,
          TError,
          Awaited<ReturnType<typeof isMedi24PatientDataAvailable>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useIsMedi24PatientDataAvailable<
  TData = Awaited<ReturnType<typeof isMedi24PatientDataAvailable>>,
  TError = unknown,
>(
  params: IsMedi24PatientDataAvailableParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof isMedi24PatientDataAvailable>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useIsMedi24PatientDataAvailable<
  TData = Awaited<ReturnType<typeof isMedi24PatientDataAvailable>>,
  TError = unknown,
>(
  params: IsMedi24PatientDataAvailableParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof isMedi24PatientDataAvailable>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getIsMedi24PatientDataAvailableQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getIsMedi24PatientDataAvailableSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof isMedi24PatientDataAvailable>>,
  TError = unknown,
>(
  params: IsMedi24PatientDataAvailableParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof isMedi24PatientDataAvailable>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getIsMedi24PatientDataAvailableQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof isMedi24PatientDataAvailable>>> = ({ signal }) =>
    isMedi24PatientDataAvailable(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof isMedi24PatientDataAvailable>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type IsMedi24PatientDataAvailableSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof isMedi24PatientDataAvailable>>
>;
export type IsMedi24PatientDataAvailableSuspenseQueryError = unknown;

export function useIsMedi24PatientDataAvailableSuspense<
  TData = Awaited<ReturnType<typeof isMedi24PatientDataAvailable>>,
  TError = unknown,
>(
  params: IsMedi24PatientDataAvailableParams,
  options: {
    query: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof isMedi24PatientDataAvailable>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useIsMedi24PatientDataAvailableSuspense<
  TData = Awaited<ReturnType<typeof isMedi24PatientDataAvailable>>,
  TError = unknown,
>(
  params: IsMedi24PatientDataAvailableParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof isMedi24PatientDataAvailable>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useIsMedi24PatientDataAvailableSuspense<
  TData = Awaited<ReturnType<typeof isMedi24PatientDataAvailable>>,
  TError = unknown,
>(
  params: IsMedi24PatientDataAvailableParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof isMedi24PatientDataAvailable>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useIsMedi24PatientDataAvailableSuspense<
  TData = Awaited<ReturnType<typeof isMedi24PatientDataAvailable>>,
  TError = unknown,
>(
  params: IsMedi24PatientDataAvailableParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof isMedi24PatientDataAvailable>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getIsMedi24PatientDataAvailableSuspenseQueryOptions(params, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getMedi24PartnerPractices = (
  params?: GetMedi24PartnerPracticesParams,
  options?: SecondParameter<typeof request>,
  signal?: AbortSignal,
) => {
  return request<PracticeDto[]>({ url: `/callcenter/medi24/partnerpractices`, method: 'GET', params, signal }, options);
};

export const getGetMedi24PartnerPracticesQueryKey = (params?: GetMedi24PartnerPracticesParams) => {
  return [`/callcenter/medi24/partnerpractices`, ...(params ? [params] : [])] as const;
};

export const getGetMedi24PartnerPracticesQueryOptions = <
  TData = Awaited<ReturnType<typeof getMedi24PartnerPractices>>,
  TError = unknown,
>(
  params?: GetMedi24PartnerPracticesParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMedi24PartnerPractices>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMedi24PartnerPracticesQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMedi24PartnerPractices>>> = ({ signal }) =>
    getMedi24PartnerPractices(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMedi24PartnerPractices>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMedi24PartnerPracticesQueryResult = NonNullable<Awaited<ReturnType<typeof getMedi24PartnerPractices>>>;
export type GetMedi24PartnerPracticesQueryError = unknown;

export function useGetMedi24PartnerPractices<
  TData = Awaited<ReturnType<typeof getMedi24PartnerPractices>>,
  TError = unknown,
>(
  params: undefined | GetMedi24PartnerPracticesParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMedi24PartnerPractices>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMedi24PartnerPractices>>,
          TError,
          Awaited<ReturnType<typeof getMedi24PartnerPractices>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMedi24PartnerPractices<
  TData = Awaited<ReturnType<typeof getMedi24PartnerPractices>>,
  TError = unknown,
>(
  params?: GetMedi24PartnerPracticesParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMedi24PartnerPractices>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMedi24PartnerPractices>>,
          TError,
          Awaited<ReturnType<typeof getMedi24PartnerPractices>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMedi24PartnerPractices<
  TData = Awaited<ReturnType<typeof getMedi24PartnerPractices>>,
  TError = unknown,
>(
  params?: GetMedi24PartnerPracticesParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMedi24PartnerPractices>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetMedi24PartnerPractices<
  TData = Awaited<ReturnType<typeof getMedi24PartnerPractices>>,
  TError = unknown,
>(
  params?: GetMedi24PartnerPracticesParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMedi24PartnerPractices>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMedi24PartnerPracticesQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMedi24PartnerPracticesSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getMedi24PartnerPractices>>,
  TError = unknown,
>(
  params?: GetMedi24PartnerPracticesParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMedi24PartnerPractices>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMedi24PartnerPracticesQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMedi24PartnerPractices>>> = ({ signal }) =>
    getMedi24PartnerPractices(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getMedi24PartnerPractices>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMedi24PartnerPracticesSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMedi24PartnerPractices>>
>;
export type GetMedi24PartnerPracticesSuspenseQueryError = unknown;

export function useGetMedi24PartnerPracticesSuspense<
  TData = Awaited<ReturnType<typeof getMedi24PartnerPractices>>,
  TError = unknown,
>(
  params: undefined | GetMedi24PartnerPracticesParams,
  options: {
    query: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMedi24PartnerPractices>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMedi24PartnerPracticesSuspense<
  TData = Awaited<ReturnType<typeof getMedi24PartnerPractices>>,
  TError = unknown,
>(
  params?: GetMedi24PartnerPracticesParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMedi24PartnerPractices>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMedi24PartnerPracticesSuspense<
  TData = Awaited<ReturnType<typeof getMedi24PartnerPractices>>,
  TError = unknown,
>(
  params?: GetMedi24PartnerPracticesParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMedi24PartnerPractices>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetMedi24PartnerPracticesSuspense<
  TData = Awaited<ReturnType<typeof getMedi24PartnerPractices>>,
  TError = unknown,
>(
  params?: GetMedi24PartnerPracticesParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMedi24PartnerPractices>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMedi24PartnerPracticesSuspenseQueryOptions(params, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getMedi24EmailAddress = (
  params: GetMedi24EmailAddressParams,
  options?: SecondParameter<typeof request>,
  signal?: AbortSignal,
) => {
  return request<string>({ url: `/callcenter/medi24/email`, method: 'GET', params, signal }, options);
};

export const getGetMedi24EmailAddressQueryKey = (params?: GetMedi24EmailAddressParams) => {
  return [`/callcenter/medi24/email`, ...(params ? [params] : [])] as const;
};

export const getGetMedi24EmailAddressQueryOptions = <
  TData = Awaited<ReturnType<typeof getMedi24EmailAddress>>,
  TError = unknown,
>(
  params: GetMedi24EmailAddressParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMedi24EmailAddress>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMedi24EmailAddressQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMedi24EmailAddress>>> = ({ signal }) =>
    getMedi24EmailAddress(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMedi24EmailAddress>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMedi24EmailAddressQueryResult = NonNullable<Awaited<ReturnType<typeof getMedi24EmailAddress>>>;
export type GetMedi24EmailAddressQueryError = unknown;

export function useGetMedi24EmailAddress<TData = Awaited<ReturnType<typeof getMedi24EmailAddress>>, TError = unknown>(
  params: GetMedi24EmailAddressParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMedi24EmailAddress>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMedi24EmailAddress>>,
          TError,
          Awaited<ReturnType<typeof getMedi24EmailAddress>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMedi24EmailAddress<TData = Awaited<ReturnType<typeof getMedi24EmailAddress>>, TError = unknown>(
  params: GetMedi24EmailAddressParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMedi24EmailAddress>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMedi24EmailAddress>>,
          TError,
          Awaited<ReturnType<typeof getMedi24EmailAddress>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMedi24EmailAddress<TData = Awaited<ReturnType<typeof getMedi24EmailAddress>>, TError = unknown>(
  params: GetMedi24EmailAddressParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMedi24EmailAddress>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetMedi24EmailAddress<TData = Awaited<ReturnType<typeof getMedi24EmailAddress>>, TError = unknown>(
  params: GetMedi24EmailAddressParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMedi24EmailAddress>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMedi24EmailAddressQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMedi24EmailAddressSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getMedi24EmailAddress>>,
  TError = unknown,
>(
  params: GetMedi24EmailAddressParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMedi24EmailAddress>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMedi24EmailAddressQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMedi24EmailAddress>>> = ({ signal }) =>
    getMedi24EmailAddress(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getMedi24EmailAddress>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMedi24EmailAddressSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getMedi24EmailAddress>>>;
export type GetMedi24EmailAddressSuspenseQueryError = unknown;

export function useGetMedi24EmailAddressSuspense<
  TData = Awaited<ReturnType<typeof getMedi24EmailAddress>>,
  TError = unknown,
>(
  params: GetMedi24EmailAddressParams,
  options: {
    query: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMedi24EmailAddress>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMedi24EmailAddressSuspense<
  TData = Awaited<ReturnType<typeof getMedi24EmailAddress>>,
  TError = unknown,
>(
  params: GetMedi24EmailAddressParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMedi24EmailAddress>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMedi24EmailAddressSuspense<
  TData = Awaited<ReturnType<typeof getMedi24EmailAddress>>,
  TError = unknown,
>(
  params: GetMedi24EmailAddressParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMedi24EmailAddress>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetMedi24EmailAddressSuspense<
  TData = Awaited<ReturnType<typeof getMedi24EmailAddress>>,
  TError = unknown,
>(
  params: GetMedi24EmailAddressParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMedi24EmailAddress>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMedi24EmailAddressSuspenseQueryOptions(params, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}
